(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRouteDetailController', TrRouteDetailController);

    TrRouteDetailController.$inject = ['$scope', '$http', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrRoute', 'User', 'RouteType', 'TrRouteImages', 'TrRouteRecordings', 'AlertService', '$window', '$localStorage', 'getRouteImage', 'Configs', 'routeDetail', 'Inventory', 'SummaryPost', 'imageRoutePoint', 'TrRouteForMap', 'TaskLogRouteReportData', 'MaterialByDates', 'MaterialDates', 'ParseLinks', 'RouteByID', 'Report', 'dailyLogByTaskId', 'TaskSectionById', 'TaskStatusById', 'taskComment', 'dailyLog', 'BaseUrl', 'DailyLogByTaskIdWithType', 'AssetByID', 'RouteImageMeta', 'RingGeofence', 'SectionSelect', 'AllAssetsTypes', 'UserAccount', 'AllTerrainTypes', 'TrTerrain', 'AllRowTypes', 'TrRow', 'RouteStatus'];

    function TrRouteDetailController($scope, $http, $rootScope, $stateParams, previousState, entity, TrRoute, User, RouteType, TrRouteImages, TrRouteRecordings, AlertService, $window, $localStorage, getRouteImage, Configs, routeDetail, Inventory, SummaryPost, imageRoutePoint, TrRouteForMap, TaskLogRouteReportData, MaterialByDates, MaterialDates, ParseLinks, RouteByID, Report, dailyLogByTaskId, TaskSectionById, TaskStatusById, taskComment, dailyLog, BaseUrl, DailyLogByTaskIdWithType, AssetByID, RouteImageMeta, RingGeofence, SectionSelect, AllAssetsTypes, UserAccount, AllTerrainTypes, TrTerrain, AllRowTypes, TrRow, RouteStatus) {
        var vm = this;
        vm.tabNum = 0;
        vm.trRoute = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        vm.showTaskLogReport = showTaskLogReport;
        vm.downloadRouteKml = downloadRouteKml;
        vm.downloadSurveyReport1 = downloadSurveyReport1;
        var unsubscribe = $rootScope.$on('trakeyeApp:trRouteUpdate', function (event, result) {
            vm.trRoute = result;
        });
        vm.showRouteAttachment = false
        vm.expandResponse = []
        vm.storeMaterialTransactionName = []
        vm.activeTab = 'material';
        var colors = [];
        loadAssets(vm.trRoute.id, null);
        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        vm.selectedPaths = [];
        vm.sectionSave = sectionSave;
        var labelFrom, labelTo
        labelFrom = 'From Terrain'
        labelTo = 'To Terrain'
        vm.gpAssets = [];
        var Trmarkers = [];
        var uniqueColors = [
            "#FF0000", "#0000FF", "#008000", "#FFFF00", "#FFA500", "#800080", "#FFC0CB", "#00FFFF", "#FF00FF",
            "#008080", "#E6E6FA", "#A52A2A", "#800000", "#000080", "#808000", "#00FF00", "#FFDAB9", "#000000",
            "#808080", "#C0C0C0", "#FFD700", "#4B0082", "#EE82EE", "#40E0D0", "#D2B48C", "#FA8072", "#FF7F50",
            "#F0E68C", "#DC143C", "#7CFC00"
        ];
        var phasePolylines = []
        var phaseMarkers = []
        var coordinateListMaintenance = []
        var coordinateListRollout = []
        var coordinateListPlanSurvey = []
        var coordinateListPlanning = []
        var assetSpreadListPlanning = []
        var assetSpreadListMaintenance = []
        var assetSpreadListRollout = []
        var assetSpreadListPlanSurvey = []

        //measure tool
        var measureEnabled = false
        var polyMeasureTool, segmentDistance, midpoint
        var totalDistance = 0
        var distanceMarkers = []
        var totalDistanceMarkers = []
        var pointerMarkers = []
        var arrpolyMeasureTool = []
        vm.gotoLatitute = gotoLatitute;
        vm.gotoLatituteCity = gotoLatituteCity;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.closeGotoLatituteCity = closeGotoLatituteCity;
        vm.showZoomLocation = showZoomLocation;
        var gotoMarker = null;
        var measureTool = document.createElement("button");
        var measureToolIcon = document.createElement("i");
        vm.closeAssetAttributesModal = closeAssetAttributesModal;

        vm.showRingDetailGpReport = true;
        vm.showRingDetailSurveyReport = true;
        vm.showRingDetailWorkProgressTab = true;
        vm.showRingDetailSummaryTabMxDownload = true;
        vm.showRingDetailSummaryTabRxDownload = true;

        vm.updatedSurveyPath = [];
        vm.assets = []
        vm.fromToIntersectingPoints = [];
        var colors = uniqueColors.map(function (color) {
            return { color: color, used: false };
        });

        Configs.get("RouteImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showRouteAttachment = true
                }
            }
        })

        Configs.get("Features", function (response) {
            response.filter(function (value) {

                if (value.configKey == "RingDetailGpReport") {
                    if (value.configValue == "True") {
                        vm.showRingDetailGpReport = true
                    } else {
                        vm.showRingDetailGpReport = false
                    }
                }

                if (value.configKey == "RingDetailSurveyReport") {
                    if (value.configValue == "True") {
                        vm.showRingDetailSurveyReport = true
                    } else {
                        vm.showRingDetailSurveyReport = false
                    }
                }

                if (value.configKey == "RingDetailWorkProgressTab") {
                    if (value.configValue == "True") {
                        vm.showRingDetailWorkProgressTab = true
                    } else {
                        vm.showRingDetailWorkProgressTab = false
                    }
                }

                if (value.configKey == "RingDetailSummaryTabMxDownload") {
                    if (value.configValue == "True") {
                        vm.showRingDetailSummaryTabMxDownload = true
                    } else {
                        vm.showRingDetailSummaryTabMxDownload = false
                    }
                }

                if (value.configKey == "RingDetailSummaryTabRxDownload") {
                    if (value.configValue == "True") {
                        vm.showRingDetailSummaryTabRxDownload = true
                    } else {
                        vm.showRingDetailSummaryTabRxDownload = false
                    }
                }
            })
        });

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                img +
                '">'
            );
            imgWindow.document.close();
        };

       

        function getPolylineMidpoint(polyline) {
            var path = polyline.getPath();

            if (!path || path.getLength() < 2) {
                console.warn("Polyline must have at least two points.");
                return null;
            }

            var firstLatLng = path.getAt(0);
            var lastLatLng = path.getAt(path.getLength() - 1);

            var midpointLat = (firstLatLng.lat() + lastLatLng.lat()) / 2;
            var midpointLng = (firstLatLng.lng() + lastLatLng.lng()) / 2;

            return new google.maps.LatLng(midpointLat, midpointLng);
        }

        function downloadRouteKml() {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block"; // Show the spinner
            }
            Report.downloadRouteKml({
                id: vm.trRoute.id
            }, function (response) {
                if (spinner) {
                    spinner.style.display = "none"; // Show the spinner
                }
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/text' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = vm.trRoute.name + ".kml";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }

        function downloadSurveyReport1() {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block"; // Show the spinner
            }
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/route-survey-report2/" + vm.trRoute.id;
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (spinner) {
                        spinner.style.display = "none"; // Show the spinner
                    }
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));

                                downloadLink.download = vm.trRoute.name + ' GP_Report.xlsx';

                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    } else if (this.status == 404) { alert("No Data Available") }
                };
                request.send();
            });
        }



        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.allimages = false;
        //		$scope

        $scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrRouteImages.query(
                            {
                                routeId: vm.trRoute.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.routeImages = data.filter(function (routeImages) {
                                return routeImages.image
                            });

                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getRouteImage.get(vm.trRoute.id, function (res) {
                            vm.attachments = res;
                        });
                    }
                case "section":
                    vm.showSection = !vm.showSection;
                    break;
                    break;

                default:
                    console.log("");
            }
        };


        function decodeImage(img) {
            return window.atob(img);
        }

        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };


        $scope.setTab = function (newTab) {
            vm.tabNum = newTab;
            if (newTab == 8) {
                //Comment Box
                vm.objectComments = {}
                vm.objectComments.entityId = entity.id
                vm.objectComments.entityName = "ROUTE"
            }
if(vm.tabNum==4){
         SummaryPost.dailyLogsTx({
            "projectIds": [vm.trRoute.projectId],
            "routeIds": [vm.trRoute.id]
        }, function (response) {
            vm.dailyLogsTxSummary = response
        })

        SummaryPost.mtrlTx({
            "projectIds": [vm.trRoute.projectId],
            "routeIds": [vm.trRoute.id]
        }, function (response) {
            vm.mtrlTxSummary = response
        })

        SummaryPost.resTx({
            "projectIds": [vm.trRoute.projectId],
            "routeIds": [vm.trRoute.id]
        }, function (response) {
            vm.resTxSummary = response
        })
       }

            if (newTab == 4 && vm.dailyLogsTxSummary.sectionTasks.length) {
                $scope.tab = 7
                showTaskLogReport(vm.trRoute.id);
            } else {
                $scope.tab = newTab;
            }
        }

        routeDetail.getRoutesDetails(entity.id, function (response) {
            vm.sectionResponse = response;
        })
        var locations = {};
        var markers = [];
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 24
        var center = {
            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
        };

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            myOption($rootScope.rolloutMapInitZoom, center)
        );
        var infoWindow = new google.maps.InfoWindow();
        google.maps.event.addListener(locations.map, "click", function (event) {
            var latitude = event.latLng.lat();
            var longitude = event.latLng.lng();

            var contentDiv = document.createElement("div");
            contentDiv.className = "infoWindowhead";
            contentDiv.innerHTML =
                "<b>Latitude : " + latitude + "</b><br>" +
                "<b>Longitude : " + longitude + "</b><br>";

            var btnCreateMarker = document.createElement("input");
            btnCreateMarker.type = "button";
            btnCreateMarker.value = "Create Marker";
            btnCreateMarker.className = "button";

            google.maps.event.addDomListener(btnCreateMarker, "click", function () {
                var routeMarkerPayload = [{
                    "latitude": latitude,
                    "longitude": longitude,
                    "id": null,
                    "sessionNumber": generateUUID(),
                    "routeId": vm.trRoute.id,
                    "routePointNumber": 100,
                    "routePointType": "MARKER",
                    "lhsOffset": 3,
                    "rhsOffset": 3,
                    "rodometerLength": 3,
                    "roadWidth": 3,
                    "distance": 0,
                    "landMark": "",
                    "phase": "SURVEY"
                }];

                routeDetail.saveBulkRoutePoints(routeMarkerPayload, function (response) {
                    infoWindow.close()
                    alert("Marker Created")
                    vm.refreshMarkers();
                });
            });
            contentDiv.appendChild(btnCreateMarker);
            infoWindow.setContent(contentDiv);
            infoWindow.setPosition(event.latLng);
            infoWindow.open(locations.map);
        });
        vm.refreshMarkers = function () {
            vm.objectRouteImg.refreshMarkersFn();
        };


        function templateBg(color) {
            return '<img class="square" style="background-color:' +
                color +
                ';">'
        }

        vm.phaseFilter = []
        vm.blockFilter = []
        var tempColor = {
            "PLANNING": "#FD7A24",
            "SURVEY": "#0096FF",
            "ROLLOUT": "#7FFF00",
            "MAINTENANCE": "#DE3163"
        }

        var isObjBool = {
            "PLANNING": false,
            "SURVEY": false,
            "ROLLOUT": false,
            "MAINTENANCE": false
        }

        if (vm.trRoute && vm.trRoute.routePoints != null && vm.trRoute.routePoints.length) {
            vm.trRoute.routePoints.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
            var groupedRoutePoints = {};
            vm.trRoute.routePoints.forEach(function (each) {
                if (each.routePointType == "COORDINATE" && each.phase != null) {
                    if (each.sessionNumber) {
                        if (!groupedRoutePoints[each.sessionNumber]) {
                            groupedRoutePoints[each.sessionNumber] = [];
                        }
                        groupedRoutePoints[each.sessionNumber].push(each);
                    }
                } else if (each.routePointType == "CHAINAGE" && each.phase != null) {
                    isObjBool[each.phase] = true;
                    chainageList.push({ latitude: each.latitude, longitude: each.longitude, type: each.routePointType, number: each.routePointNumber, phase: each.phase });
                }
            });
            Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                var sessionPoints = groupedRoutePoints[sessionNumber];
                sessionPoints.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                if (sessionPoints.length > 1) {
                    sessionPoints.forEach(function (each) {
                        callSwitchPhaseCoordinate(each, each.phase);
                        isObjBool[each.phase] = true;
                        var coordinate = { lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber, sessionNumber: each.sessionNumber };
                        if (each.phase === "PLANNING") {
                            coordinateListPlanning.push(coordinate);
                            vm.plannedCoordinats = coordinateListPlanning
                        } else if (each.phase === "SURVEY") {
                            vm.surveyPhase = "SURVEY"
                            coordinateListPlanSurvey.push(coordinate);
                        } else if (each.phase === "ROLLOUT") {
                            coordinateListRollout.push(coordinate);
                        } else if (each.phase === "MAINTENANCE") {
                            coordinateListMaintenance.push(coordinate);
                        }
                    });
                    callPhaseCoordinate();
                    coordinateListPlanning = [];
                    coordinateListPlanSurvey = [];
                    coordinateListRollout = [];
                    coordinateListMaintenance = [];
                }
            });
            callPhaseCoordinate();
            if (chainageList.length) {

                locations.map.setCenter(chainageList[0]);
                createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map, null);
            }
            callObjPhases();
        }

        function callObjPhases() {
            if (isObjBool["PLANNING"]) {
                vm.phaseFilter.push({ name: "PLANNING", selected: true, strokeColor: templateBg("#FD7A24") })
            }
            if (isObjBool["SURVEY"]) {
                vm.phaseFilter.push({ name: "SURVEY", selected: true, strokeColor: templateBg("#0096FF") })
            }
        }
        var plannigCoordinate = coordinateListPlanning
        var polyLine = []
        function callPhaseCoordinate() {
            if (coordinateListPlanning.length) {
                coordinateListPlanning.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                locations.map.setCenter(coordinateListPlanning[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListPlanning,
                    geodesic: true,
                    strokeColor: tempColor["PLANNING"],
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    name: "PLANNING",
                    zIndex: 2
                });
                coordinateListPlanning.forEach(function (each) {
                    createInfoWindow(polyline, each)
                })
                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
            if (coordinateListPlanSurvey.length) {
                //vm.phaseFilter.push({name:"PROPOSED",selected:true,strokeColor:templateBg("#0096FF")})
                coordinateListPlanSurvey.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                locations.map.setCenter(coordinateListPlanSurvey[0]);
                var surveyCoord = coordinateListPlanSurvey;
                var polyline = new google.maps.Polyline({
                    path: coordinateListPlanSurvey,
                    geodesic: true,
                    strokeColor: tempColor["SURVEY"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "SURVEY",
                    zIndex: 2
                });
                polyline.setMap(locations.map);

                var polylineInfoWindowsurvey = new google.maps.InfoWindow();
                            google.maps.event.addListener(polyline, 'click', function (event) {
                                var contentString = document.createElement("div"),
                                    btnEditSurveyPath
                                contentString.innerHTML = '<div class="infoWindowhead">'
                                "</div>";
                                polylineInfoWindowsurvey.setContent(contentString);
                                polylineInfoWindowsurvey.setPosition(event.latLng);
                                polylineInfoWindowsurvey.open(locations.map);
                                openedInfoWindow = polylineInfoWindowsurvey;
                                var originalOptions = {
                                    strokeColor: polyline.get("strokeColor"),
                                    strokeWeight: polyline.get("strokeWeight"),
                                    strokeOpacity: polyline.get("strokeOpacity")
                                };
                                polyline.setOptions({
                                    strokeColor: "#A938F3",
                                    strokeWeight: 12,
                                    strokeOpacity: 0.6,
                                });
                                setTimeout(function () {
                                    polyline.setOptions(originalOptions);
                                }, 10000);
                                if (vm.trRoute.id) {
                                    btnEditSurveyPath = contentString.appendChild(
                                        document.createElement("input")
                                    );

                                    btnEditSurveyPath.type = "button";
                                    btnEditSurveyPath.value = "Edit Path";
                                    btnEditSurveyPath.className = "button";
                                    google.maps.event.addDomListener(
                                        btnEditSurveyPath,
                                        "click",
                                        function () {
                                             AllTerrainTypes.getAll(function (response) {
                                             vm.terrainTypes = response;
                                             });

                                              AllRowTypes.getAll(function (response) {
                                              vm.rowTypes = response;
                                             });

                                            vm.editSurveyPath(surveyCoord);
                                            polylineInfoWindowsurvey.close()
                                        }
                                    );
                                }
                            });
                            google.maps.event.addListener(
                                polyline,
                                "click",
                                (function (event) {
                                    vm.SuveryMapCenter = {
                                        lat: event.latLng.lat(),
                                        lng: event.latLng.lng()
                                    }
                                }))
                phasePolylines.push(polyline)
            }

            if (coordinateListRollout.length) {
                //vm.phaseFilter.push({name:"ROLLOUT",selected:true,strokeColor:templateBg("#7FFF00"), color:"#7FFF00"})
                locations.map.setCenter(coordinateListRollout[0]);
                coordinateListRollout.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                var polyline = new google.maps.Polyline({
                    path: coordinateListRollout,
                    geodesic: true,
                    strokeColor: tempColor["ROLLOUT"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "ROLLOUT"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (coordinateListMaintenance.length) {
                //vm.phaseFilter.push({name:"MAINTENANCE",selected:true,strokeColor:templateBg("#DE3163"), color :"#DE3163"})
                coordinateListMaintenance.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                locations.map.setCenter(coordinateListMaintenance[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListMaintenance,
                    geodesic: true,
                    strokeColor: tempColor["MAINTENANCE"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "MAINTENANCE"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
        }
        function callPhaseSpread() {
            if (assetSpreadListPlanning.length) {
                //vm.phaseFilter.push({name:"PLANNING",selected:true,strokeColor:templateBg("#FD7A24")})
                locations.map.setCenter(assetSpreadListPlanning[0]);

                var polyline = new google.maps.Polyline({
                    path: assetSpreadListPlanning,
                    geodesic: true,
                    strokeColor: tempColor["PLANNING"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "PLANNING",
                    zIndex: 2
                });
                // Set the map to display the polyline
                assetSpreadListPlanning.forEach(function (each) {
                    createInfoWindow(polyline, each)
                    polyline.set('block', each.block);
                })
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListPlanSurvey.length) {
                //vm.phaseFilter.push({name:"PROPOSED",selected:true,strokeColor:templateBg("#0096FF")})
                locations.map.setCenter(assetSpreadListPlanSurvey[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListPlanSurvey,
                    geodesic: true,
                    strokeColor: tempColor["SURVEY"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "SURVEY",
                    zIndex: 2
                });

                assetSpreadListPlanSurvey.forEach(function (each) {
                    createInfoWindow(polyline, each)
                    polyline.set('block', each.block);
                })
                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListRollout.length) {
                //vm.phaseFilter.push({name:"ROLLOUT",selected:true,strokeColor:templateBg("#7FFF00"), color:"#7FFF00"})

                locations.map.setCenter(assetSpreadListRollout[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListRollout,
                    geodesic: true,
                    strokeColor: tempColor["ROLLOUT"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "ROLLOUT"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListMaintenance.length) {
                //vm.phaseFilter.push({name:"MAINTENANCE",selected:true,strokeColor:templateBg("#DE3163"), color :"#DE3163"})
                locations.map.setCenter(assetSpreadListMaintenance[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListMaintenance,
                    geodesic: true,
                    strokeColor: tempColor["MAINTENANCE"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "MAINTENANCE"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
        }

        function callSwitchPhaseCoordinate(each, ph) {
            switch (ph) {
                case "PLANNING":
                    coordinateListPlanning.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "SURVEY":
                    coordinateListPlanSurvey.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, sessionNumber: each.sessionNumber })
                    break;

                case "ROLLOUT":
                    coordinateListRollout.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "MAINTENANCE":
                    coordinateListMaintenance.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;
            }
        }

        function callSwitchPhaseSpread(each, ph, name, block) {
            switch (ph) {
                case "PLANNING":
                    assetSpreadListPlanning.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, name: name, block: block })
                    break;

                case "SURVEY":
                    assetSpreadListPlanSurvey.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, name: name, block: block })
                    break;

                case "ROLLOUT":
                    assetSpreadListRollout.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, block: block })
                    break;

                case "MAINTENANCE":
                    assetSpreadListMaintenance.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, block: block })
                    break;
            }
        }

        $scope.togglePhase = function () {
            if (vm.selectedPhase.length) {
                clearPhase()
                vm.selectedPhase.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (phasePolylines[i].name === each.name) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (phaseMarkers[i].name === each.name) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPhase()
            }
        };

        $scope.toggleBlock = function () {
            if (vm.selectedBlock.length) {
                clearPhase()
                vm.selectedBlock.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (phasePolylines[i].block === each.name /* || phasePolylines[i].block == null */) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (phaseMarkers[i].block === each.name /* || phasePolylines[i].block == null */) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPhase()
                vm.phaseFilter.forEach(function (item) {
                    item.selected = false
                })
            }
        };

        function createMarkers(arr, img, map, str) {
            var marker, markerSymbol
            arr.forEach(function (each) {

                marker = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                    name: each.phase
                });

                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.latitude + "</b></br>" +
                            "<b>Longitude : " + each.longitude + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "<b>Number : " + each.number + "</b></br>" +
                            "</br></div>"
                        );
                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.latitude,
                            lng: each.longitude,
                        });
                        openedInfoWindow = infowindow;
                    }))

                phaseMarkers.push(marker);

            })
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
            {
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#EFEFEF",
                    },
                ],
            }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.expand = function (section, str) {
            vm.sectionResponse.forEach(function (item) {
                item.tasks = true;
            });

            if (vm.toggle == section.sectionId) {
                vm.toggle = undefined;
            } else {
                switch (str) {
                    case "tasks":
                        vm.expandResponse = null
                        vm.headers = null
                        routeDetail.postSectionsDetails({ "sectionIds": [section.sectionId] }, function (response) {
                            vm.headers = [
                                { key: "logs", display: "Logs" },
                                { key: "taskName", display: "Task Name" },
                                { key: "userLogin", display: "Assigned To" }
                            ]
                            vm.expandResponse = response
                        })
                        section.tasks = true;
                        vm.toggle = section.sectionId;
                        break;

                    default: console.log("default")
                }
            }
        }


       

        vm.objectRouteImg = {}
        vm.objectRouteImg.hidemarker = true
        vm.objectRouteImg.hideRoutemarker = true
        vm.objectRouteImg.routeId = vm.trRoute.id
        vm.objectRouteImg.routeName = vm.trRoute.name
        vm.objectRouteImg.plannedPath = vm.plannedCoordinats
        vm.objectRouteImg.map = locations.map
        vm.objectRouteImg.hidesurveyRoutemarker = true;
        vm.mapFilterList = [];
        var polylines = []
        var tempPath = []
        
         TrRouteForMap.getTerrainPathByRoute(
            vm.trRoute.id,
            function (response) {
                vm.terrainPathResponse = response

                callTerrainPath()

            }, function (err) {
                vm.mapFilterList.push({
                    name:
                        '<strong>' + vm.trRoute.name + '</strong>',
                    path: coordinateList,
                    visible: true,
                    strokeColor: '<img class="square" style="background-color:#' +
                        'FD7A24' +
                        ';">',
                    colorCode: 'FD7A24',
                    routeDisable: true
                })

                for (var i = 0; i < vm.mapFilterList.length; i++) {
                    var filteredPath = vm.mapFilterList[i].path;
                    filteredPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                    var line = new google.maps.Polyline({
                        path: filteredPath,
                        visible: vm.mapFilterList[i].visible,
                        strokeColor: '#' + vm.mapFilterList[i].colorCode,
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        name: vm.mapFilterList[i].name
                    });
                    line.setMap(locations.map);
                    polylines.push(line);
                }

                TrRouteForMap.getRoWPathByRoute(
                    vm.trRoute.id,
                    function (response) {
                        vm.rowPathResponse = response
                        if (response.length) {
                            vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                            callRowPath()
                        }
                    }
                );
            }
        );

        function callTerrainPath() {

            TrRouteForMap.getTerrainByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    polylines = []
                    vm.terrainListResponse = nameResponse
                    vm.totalTerrain = 0;
                    vm.terrainListResponse.forEach(function (terrain) {
                        vm.totalTerrain += terrain.length;
                    });
                    if (nameResponse.length) {
                        vm.isShowFilter = true
                        vm.mapFilterList.push({
                            name:
                                '<strong>' + vm.trRoute.name + '</strong>',
                            path: coordinateList,
                            visible: true,
                            strokeColor: '<img class="square" style="background-color:#' +
                                'FD7A24' +
                                ';">',
                            colorCode: 'FD7A24',
                            routeDisable: true,

                        })
                        vm.mapFilterList.push({ name: '<strong>Terrain</strong>', msGroup: true })
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.terrainPathResponse.length) {
                                vm.terrainPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude, routePointNumber: parseFloat(cord.routePointNumber) })
                                            })
                                            tempPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                                            var colorCode = randomColor()
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }
                        });
                        vm.mapFilterList.push({ msGroup: false })
                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                callRowPath()
                            }
                        );
                    } else {
                        vm.mapFilterList.push({
                            name:
                                '<strong>' + vm.trRoute.name + '</strong>',
                            path: coordinateList,
                            visible: true,
                            strokeColor: '<img class="square" style="background-color:#' +
                                'FD7A24' +
                                ';">',
                            colorCode: 'FD7A24',
                            routeDisable: true
                        })

                        for (var i = 0; i < vm.mapFilterList.length; i++) {
                            var filteredPath = vm.mapFilterList[i].path;
                            filteredPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            var line = new google.maps.Polyline({
                                path: filteredPath,
                                visible: vm.mapFilterList[i].visible,
                                strokeColor: '#' + vm.mapFilterList[i].colorCode,
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                name: vm.mapFilterList[i].name
                            });
                            line.setMap(locations.map);
                            polylines.push(line);
                        }

                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                if (response.length) {
                                    vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                    callRowPath()
                                }

                            }
                        );
                    }
                },
                function (error) {
                    vm.mapFilterList.push({
                        name:
                            '<strong>' + vm.trRoute.name + '</strong>',
                        path: coordinateList,
                        visible: true,
                        strokeColor: '<img class="square" style="background-color:#' +
                            'FD7A24' +
                            ';">',
                        colorCode: 'FD7A24',
                        routeDisable: true
                    })

                    for (var i = 0; i < vm.mapFilterList.length; i++) {
                        var filteredPath = vm.mapFilterList[i].path;
                        filteredPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var line = new google.maps.Polyline({
                            path: filteredPath,
                            visible: vm.mapFilterList[i].visible,
                            strokeColor: '#' + vm.mapFilterList[i].colorCode,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            name: vm.mapFilterList[i].name
                        });
                        line.setMap(locations.map);
                        // polylines.push(line);
                    }

                    TrRouteForMap.getRoWPathByRoute(
                        vm.trRoute.id,
                        function (response) {
                            vm.rowPathResponse = response
                            if (response.length) {
                                vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                callRowPath()
                            }

                        }
                    );
                }
            );
        }
        function callRowPath() {

            TrRouteForMap.getRoWByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    vm.rowListResponse = nameResponse
                    vm.totalRow = 0;
                    vm.rowListResponse.forEach(function (row) {
                        vm.totalRow += row.length;
                    });
                    if (nameResponse.length) {
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.rowPathResponse.length) {
                                vm.rowPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude, routePointNumber: parseFloat(cord.routePointNumber) })
                                            })
                                            tempPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                                            var colorCode = randomColor()
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }
                        });
                        vm.mapFilterList.push({ msGroup: false })
                    }
                }
            );
        }
        $scope.togglePolyline = function () {
            if (vm.selectedTerrainName.length) {
                clearPolyLines()
                vm.selectedTerrainName.forEach(function (each) {
                    for (var i = 0; i < polylines.length; i++) {
                        if (polylines[i].name === each.name) {
                            if (each.visible) {
                                polylines[i].setMap(locations.map);
                            }
                        } else {
                            polylines[i].setMap(null)
                        }
                    }
                })
            } else {
                clearPolyLines()
            }
        };
        function clearPolyLines() {
            for (var i = 0; i < polylines.length; i++) {

                polylines[i].setMap(null);

            }
        }
        $scope.type = {
            terrain: {
                search: "Search",
                nothingSelected: "Map Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
            phase: {
                search: "Search",
                nothingSelected: "Phase Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
            block: {
                search: "Search",
                nothingSelected: "Block Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            }
        };
        vm.getSections = function () {
        vm.sectionNameResponse = [];
        routeDetail.getSection(vm.trRoute.id, function (response) {
            vm.sectionNameResponse = response;
        });

            $('#showRingsSections').modal('show');
        }
        function randomColor() {
            var unusedColors = colors.filter(function (color) {
                return !color.used;
            });
            if (unusedColors.length === 0) return null;
            var randomIndex = Math.floor(Math.random() * unusedColors.length);
            var randomColor = unusedColors[randomIndex];
            randomColor.used = true;
            return randomColor.color;
        }

        function createMetaTag(attrName, attrValue, content) {
            var meta = document.createElement('meta');
            meta.setAttribute(attrName, attrValue);
            meta.setAttribute('content', content);
            return meta;
        }

        function createTable(classNames) {
            var table = document.createElement('table');
            table.setAttribute('border', '1');
            table.setAttribute('cellpadding', '5');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('id', 'sheet0');
            table.setAttribute('class', classNames);
            return table;
        }

        function createTableCell(tagName, textContent) {
            var cell = document.createElement(tagName);
            cell.textContent = textContent;
            return cell;
        }

        function showTaskLogReport(routeId) {
            vm.isReportGenerated = false;
            TaskLogRouteReportData.query(
                {
                    reportType: "daily",
                    routeId: routeId
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                var htmlDoc = document.createElement('html');
                var head = document.createElement('head');
                var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
                var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
                var meta3 = createMetaTag('name', 'author', 'Apache POI');
                var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
                head.appendChild(meta1);
                head.appendChild(meta2);
                head.appendChild(meta3);
                head.appendChild(meta4);
                var body = document.createElement('body');
                var table = createTable('sheet0 gridlines');
                var thead = document.createElement('thead');
                var tbody = document.createElement('tbody');

                function createTable(classNames) {
                    var table = document.createElement('table');
                    table.setAttribute('border', '1');
                    table.setAttribute('cellpadding', '5');
                    table.setAttribute('cellspacing', '0');
                    table.setAttribute('id', 'sheet0');
                    table.setAttribute('class', classNames);
                    return table;
                }

                function createMetaTag(attrName, attrValue, content) {
                    var meta = document.createElement('meta');
                    meta.setAttribute(attrName, attrValue);
                    meta.setAttribute('content', content);
                    return meta;
                }

                function createTableCell(tag, content) {
                    var cell = document.createElement(tag);
                    cell.textContent = content;
                    cell.style.fontSize = "13px";
                    return cell;
                }

                thead.className = 'thReport';
                table.appendChild(thead);
                tbody.className = 'tdReport';
                table.appendChild(tbody);
                var styleElement = document.createElement('style');
                styleElement.textContent = "\
                .subheader {\
                    margin: auto;\
                }\
                .thReport > tr > th{\
                    text-align: center;\
                    padding: 10px;\
                }\
                .tdReport > tr > td {\
                    text-align: center; \
                    padding: 10px;\
                }\
                ";
                document.head.appendChild(styleElement);

                var colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2',];
                function getRandomColor() {
                    if (colors.length === 0) {
                        colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2'];
                    }
                    var index = Math.floor(Math.random() * colors.length);
                    var color = colors[index];
                    colors.splice(index, 1);
                    return color;
                }


                var groupedData = {};
                data.forEach(function (item) {
                    if (!groupedData[item.date]) {
                        groupedData[item.date] = [];
                    }
                    groupedData[item.date].push(item);
                });
                var names = getUniqueNames(data);
                var nameHeaderRow = document.createElement('tr');
                var serialNumberHeader = createTableCell('th', 'S.No');
                serialNumberHeader.style.fontWeight = 'bold';
                serialNumberHeader.style.backgroundColor = '#7dcfb6';
                serialNumberHeader.rowSpan = 2;
                nameHeaderRow.appendChild(serialNumberHeader);
                var dateHeader = createTableCell('th', 'Date');
                dateHeader.style.backgroundColor = '#7dcfb6';
                dateHeader.style.fontWeight = 'bold';
                dateHeader.rowSpan = 2;
                nameHeaderRow.appendChild(dateHeader);
                var typeHeaderRow = document.createElement('tr');

                names.forEach(function (name, index) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    var availableTypes = getUniqueTypes(nameData);
                    var nameHeaderCell = createTableCell('th', name);
                    nameHeaderCell.style.backgroundColor = getRandomColor();
                    nameHeaderCell.style.fontWeight = 'bold';
                    nameHeaderCell.colSpan = availableTypes.length;
                    nameHeaderRow.appendChild(nameHeaderCell);
                    availableTypes.forEach(function (type) {
                        var typeHeaderCell = createTableCell('th', type);
                        typeHeaderCell.style.backgroundColor = nameHeaderCell.style.backgroundColor;
                        typeHeaderCell.style.fontWeight = 'bold';
                        typeHeaderRow.appendChild(typeHeaderCell);
                    });
                });
                var totalProgressHeader = createTableCell('th', 'Total Progress');
                totalProgressHeader.style.backgroundColor = '#cfe0c3';
                totalProgressHeader.style.fontWeight = 'bold';
                totalProgressHeader.colSpan = 3;
                nameHeaderRow.appendChild(totalProgressHeader);
                var subHeaders = [
                    {
                        type: 'Total',
                    },
                    {
                        type: "Ducting",
                    }, {
                        type: "Validation",

                    }
                ];
                subHeaders.forEach(function (subHeader) {
                    var subHeaderCell = createTableCell('th', subHeader.type);
                    subHeaderCell.style.backgroundColor = '#cfe0c3';
                    subHeaderCell.style.fontWeight = 'bold';
                    typeHeaderRow.appendChild(subHeaderCell);
                });
                thead.appendChild(nameHeaderRow);
                thead.appendChild(typeHeaderRow);
                var totals = {};

                Object.keys(groupedData)
                    .sort(function (a, b) {
                        var dateA = a.split('-').reverse().join('-');
                        var dateB = b.split('-').reverse().join('-');
                        return new Date(dateA) - new Date(dateB);
                    })
                    .forEach(function (date, index) {
                        var totalLength = 0;
                        var totalValidation = 0;
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name && item.date === date; });
                            var ductingLength = 0;
                            var hddLength = 0;
                            var horizontalDirectionalDrilling = 0
                            var validationLength = 0;
                            nameData.forEach(function (item) {
                                if (item.type === 'Ducting') {
                                    ductingLength += item.length;
                                }
                                else if (item.type === 'HDD') {
                                    hddLength += item.length;

                                }
                                else if (item.type === 'HDD ( Horizontal Directional Drilling )') {
                                    horizontalDirectionalDrilling += item.length;
                                }
                                else if (item.type === 'Validation' || item.type === 'Validation (T&D)') {
                                    validationLength += item.length;
                                }
                            });
                            totalLength += (ductingLength + hddLength + horizontalDirectionalDrilling);
                            totalValidation += validationLength;

                        });
                        var tr = document.createElement('tr');
                        var serialNumberCell = createTableCell('td', index + 1);
                        serialNumberCell.style.fontSize = "13px";
                        tr.appendChild(serialNumberCell);
                        var dateCell = createTableCell('td', date);
                        dateCell.style.width = '77px'
                        dateCell.style.whiteSpace = 'nowrap';
                        dateCell.style.fontSize = "13px";
                        tr.appendChild(dateCell);
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name; });
                            var availableTypes = getUniqueTypes(nameData);

                            availableTypes.forEach(function (type) {
                                var item = groupedData[date].find(function (item) {
                                    return item.name === name && item.type === type;
                                });
                                var lengthValue = item ? item.length : 0;
                                var td = createTableCell('td', lengthValue);

                                tr.appendChild(td);
                                if (!totals[type]) {
                                    totals[type] = 0;
                                }
                                totals[type] += lengthValue;
                            });
                        });
                        var total = 0;
                        for (var i = 2; i < tr.cells.length; i++) {
                            total += parseInt(tr.cells[i].textContent);
                        }
                        var columnValueCell = createTableCell('td', total);
                        columnValueCell.colSpan = 1;
                        tr.appendChild(columnValueCell);
                        var remainingDuctingCell = createTableCell('td', totalLength);
                        tr.appendChild(remainingDuctingCell);
                        var remainingValidationCell = createTableCell('td', totalValidation);
                        tr.appendChild(remainingValidationCell);
                        if (index === 0) {
                            totals['Total Progress Ducting'] = 0;
                            totals['Total Progress Validation'] = 0;
                        }
                        totals['Total Progress Ducting'] += totalLength;
                        totals['Total Progress Validation'] += totalValidation;
                        tbody.appendChild(tr);
                    });

                var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting'];
                var allAvailableTypes = [];
                names.forEach(function (name) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    allAvailableTypes.push.apply(allAvailableTypes, getUniqueTypes(nameData));
                });
                var availableTypes = allAvailableTypes;
                var maxUniqueTypesCount = availableTypes.length;
                var totalLength = maxUniqueTypesCount + subHeaders.length;

                var columnTotals = {};
                for (var i = 2; i < totalLength; i++) {
                    var total = 0;
                    for (var j = 0; j < tbody.rows.length; j++) {
                        var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
                        total += cellValue;
                    }
                    columnTotals[i] = total;
                }
                staticColumns.forEach(function (column) {
                    var staticRow = document.createElement('tr');
                    var columnNameCell = createTableCell('td', column);
                    columnNameCell.colSpan = 2;
                    columnNameCell.style.backgroundColor = '#cfe0c3';
                    columnNameCell.style.fontSize = "13px";
                    columnNameCell.style.fontWeight = 'bold';
                    staticRow.appendChild(columnNameCell);
                    if (column == 'Total') {
                        for (var i = 2; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', columnTotals[i].toString());
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                        var columnValueCell = createTableCell('td', totals['Total Progress Ducting']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                        var columnValueCell = createTableCell('td', totals['Total Progress Validation']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                    } else {
                        for (var i = 0; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', '0');
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    }
                    tbody.appendChild(staticRow);
                });
                table.appendChild(thead);
                table.appendChild(tbody);
                body.appendChild(table);
                htmlDoc.appendChild(body);
                htmlDoc.appendChild(head);
                var htmlString = htmlDoc.outerHTML;
                var containerDiv = document.getElementById("generatedHtmlContainer");
                containerDiv.innerHTML = htmlString;

                function getUniqueNames(data) {
                    var uniqueNames = [];
                    data.forEach(function (item) {
                        if (uniqueNames.indexOf(item.name) === -1) {
                            uniqueNames.push(item.name);
                        }
                    });
                    return uniqueNames;
                }
                function getUniqueTypes(data) {
                    var uniqueTypes = [];
                    data.forEach(function (item) {
                        if (uniqueTypes.indexOf(item.type) === -1) {
                            uniqueTypes.push(item.type);
                        }
                    });
                    return uniqueTypes;
                }

                // Set background color for specified cells
                var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
                var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

                // Loop through JCB cells and set background color to light green
                jcbCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Loop through HDD cells and set background color to light green
                hddCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

                // Loop through each relevant row
                relevantRows.forEach(function (rowClass) {
                    var cells = document.querySelectorAll(rowClass + ' td');

                    // Loop through the cells in the row
                    cells.forEach(function (cell) {
                        // Check if the content of the cell is '0' or empty
                        if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
                            // Set background color to white
                            cell.style.backgroundColor = 'white';
                        }
                    });
                });

                vm.isReportGenerated = true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clearPhase() {
            for (var k = 0; k < phasePolylines.length; k++) {
                phasePolylines[k].setMap(null);
            }
            for (var j = 0; j < phaseMarkers.length; j++) {
                phaseMarkers[j].setMap(null);
            }
        }

        function createInfoWindow(polyline, each) {
            google.maps.event.addListener(
                polyline,
                "click",
                (function () {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    var name = each.name ? "<b>Name : " + each.name + "</b></br>" : ""
                    var block = each.block ? "<b>Block : " + each.block + "</b></br>" : ""
                    infowindow.setContent(
                        '<div class="infoWindowhead"></br></br>' +
                        name +
                        "<b>Latitude : " + each.lat + "</b></br>" +
                        "<b>Longitude : " + each.lng + "</b></br>" +
                        block +
                        "</br></div>"
                    );
                    infowindow.open(locations.map);
                    infowindow.setPosition({
                        lat: each.lat,
                        lng: each.lng,
                    });
                    openedInfoWindow = infowindow;
                }))
        }

        //callAssetsRouteByID(vm.trRoute.id,null)
        function callAssetsRouteByID(routeId, lastId) {
            assetsByRouteId.get(routeId, lastId, function (data) {
                if (data.assets.length) {
                    var markerSymbol, marker
                    data.assets.forEach(function (item) {
                        if (item.block) {
                            var isDuplicate = false;
                            for (var i = 0; i < vm.blockFilter.length; i++) {
                                if (vm.blockFilter[i].name === item.block) {
                                    isDuplicate = true;
                                    break;
                                }
                            }
                            if (!isDuplicate) {
                                vm.blockFilter.push({ name: item.block, selected: true });
                            }
                        }
                        if (item.assetCoordinates.length) {
                            if (item.assetTypeLayout == "FIXED" && item.phase != null) {
                                isObjBool[item.phase] = true
                                locations.map.setCenter({ lat: item.assetCoordinates[0].latitude, lng: item.assetCoordinates[0].longitude });
                                var imagePath = item.assetTypeImagePath;
                                item.assetCoordinates.forEach(function (each, index) {
                                    marker = new google.maps.Marker({
                                        position: { lat: each.latitude, lng: each.longitude },
                                        map: locations.map,
                                        icon: {
                                            scaledSize: new google.maps.Size(iconSize, iconSize),
                                            url: imagePath,
                                            anchor: new google.maps.Point(
                                                iconSize / 2,
                                                iconSize / 2
                                            ),
                                            labelOrigin: new google.maps.Point(25, 22),
                                        },
                                        name: item.phase,
                                        block: item.block
                                    });
                                    google.maps.event.addListener(
                                        marker,
                                        "click",
                                        (function (marker) {
                                            var assetDetails = item;
                                            var userContent = document.createElement("div"),
                                                btnShowAttributes,
                                                btnCr,
                                                btnText,
                                                btnEditAsset,
                                                btnCreateCase,
                                                btnThreePointRef,
                                                brBreak;
                                            var otdr = "";
                                            var infoStr = "";
                                            userContent.innerHTML =
                                                '<div class="infoWindowhead">' +
                                                assetDetails.name +
                                                '</div><div class="infoWindowContent">' +
                                                "<b>Asset Type </b> : " +
                                                assetDetails.assetTypeName +
                                                "<br><b>Phase </b> : " +
                                                assetDetails.phase +
                                                "<br>" +
                                                infoStr +
                                                "</div><br>";

                                            return function () {
                                                infowindow.setContent(userContent);
                                                infowindow.open(locations.map, marker);
                                                infowindow.setPosition(
                                                    new google.maps.LatLng(
                                                        marker.getPosition().lat(),
                                                        marker.getPosition().lng()
                                                    )
                                                );
                                                setTimeout(function () {
                                                    infowindow.close();
                                                }, 50000);
                                            };
                                        })(marker, index)
                                    );
                                    phaseMarkers.push(marker);
                                    // phaseMarkers.push(markerSymbol);
                                })

                            }

                            if (item.assetTypeLayout == "SPREAD" && item.phase != null) {
                                isObjBool[item.phase] = true
                                assetSpreadListPlanning = []
                                assetSpreadListMaintenance = []
                                assetSpreadListRollout = []
                                assetSpreadListPlanSurvey = []
                                item.assetCoordinates.forEach(function (each) {
                                    callSwitchPhaseSpread(each, item.phase, item.name, item.block)
                                })
                                callPhaseSpread()
                            }
                        }

                    })

                    callObjPhases()
                }
                if (data.assets.length >= 50) {
                    callAssetsRouteByID(vm.trRoute.id, data.assets[data.assets.length - 1].id)
                }
            })
        }
        vm.page = 1;
        vm.predicate = 'modified_date';
        vm.itemsPerPage = 10;
        vm.mtrpage = 1;
        vm.mtrPerPage = 10;
        vm.materialTxnByDates = [];
        vm.materialByDate = [];
        vm.loadMaterialTxnDate = function () {
            MaterialDates.query({
                type: "route",
                id: entity.id,
                page: vm.mtrpage - 1,
                size: vm.mtrPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.TotalItems = headers('X-Total-Count');
                vm.QueryCount = vm.TotalItems;
                vm.materialByDate = data.map(function (item) {
                    return {
                        timestamp: item[0],
                        total: item[1],
                        isExpand: false
                    };
                });

            });
        };
        vm.loadMaterialTxnDate();
        vm.loadMaterialTxnByDates = function (date) {
            MaterialByDates.query({
                type: 'route',
                id: entity.id,
                date: date,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTxnByDates = data.map(function (item) {
                    return {
                        materialId: item[0] || "NA",
                        timestamp: item[4] || "NA",
                        transactionName: item[1] || "NA",
                        transactionType: item[2] || "NA",
                        count: item[3] || "NA",
                        status: item[5] || "NA",
                        transactionId: item[6] || "NA",
                    };
                });
            });
        };
        vm.toggleExpand = function (selectedTask) {
            angular.forEach(vm.materialByDate, function (task) {
                if (task === selectedTask) {
                    task.isExpand = !task.isExpand;
                    if (task.isExpand) {
                        vm.loadMaterialTxnByDates(task.timestamp);
                    } else {
                        vm.materialTxnByDates = [];
                    }
                } else {
                    task.isExpand = false;
                }
            });
        };
        vm.transitionMainMateril = function () {
            vm.loadMaterialTxnDate()
        }
        vm.fetchTerrain = function () {
            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePathResponse = response;
                callRoutePath(vm.routePathResponse.routePoints);
            });
            function callRoutePath(routePaths) {
                var colors = ['#FD7A24', '#0096FF'];
                var pathColor = colors[0];
                var proposedPathColor = colors[1];
                var groupedRoutePaths = {};
                var bounds = new google.maps.LatLngBounds();

                routePaths.forEach(function (coord) {
                    if (coord.sessionNumber) {
                        if (!groupedRoutePaths[coord.sessionNumber]) {
                            groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                        }

                        if (coord.routePointType === 'COORDINATE') {
                            if (coord.phase === 'PLANNING') {
                                groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                            } else if (coord.phase === 'SURVEY') {
                                groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                            }
                        }
                    }
                });


                Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                    var sessionData = groupedRoutePaths[sessionNumber];
                    var pathData = [];
                    if (vm.trRoute.phase == 'PLANNING') {
                        pathData = sessionData.planned;
                    } else {
                        pathData = sessionData.proposed;
                    }
                    if (pathData.length) {
                        var pathCoordinates = pathData.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            zIndex: 1
                        });
                        pathPolyline.setMap(vm.newMap);
                    }

                    if (sessionData.proposed.length) {
                        var proposedPathCoordinates = sessionData.proposed.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        proposedPathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var proposedPathPolyline = new google.maps.Polyline({
                            path: proposedPathCoordinates,
                            geodesic: true,
                            strokeColor: proposedPathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 1
                        });
                        proposedPathPolyline.setMap(vm.newMap);
                    }
                });
            }
            var bounds = new google.maps.LatLngBounds();
            vm.newMap = new google.maps.Map(
                document.getElementById("map_canvasStarts"),
                myOption($rootScope.rolloutMapInitZoom, center)
            );
            geoLocation(vm.newMap);
            TrRouteForMap.getTerrainPathByRoute(vm.trRoute.id, function (response) {
                vm.terrainPathResponse = response;
                callTerrainPath(vm.terrainPathResponse);
            });
            function callTerrainPath(terrainPaths) {
                vm.terrainPolylines = {};
                vm.terrainMarkers = {};
                terrainPaths.forEach(function (pathGroup) {
                    vm.terrainColorMap = {};
                    vm.terrainListResponse.forEach(function (terrain) {
                        vm.terrainColorMap[terrain.id] = terrain.colorcode;
                    });
                    var pathColor = vm.terrainColorMap[pathGroup.id];

                    if (pathGroup.value && Array.isArray(pathGroup.value.COORDINATE)) {
                        var pathCoordinates = pathGroup.value.COORDINATE.map(function (coord) {
                            if (Array.isArray(coord.routePointNumber)) {
                                coord.routePointNumber.sort(function (a, b) {
                                    return a - b;
                                });
                            }
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 2
                        });
                        pathPolyline.setMap(vm.newMap);
                        vm.terrainPolylines[pathGroup.id] = pathPolyline;
                        google.maps.event.addListener(pathPolyline, 'click', function (event) {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }

                            var terrain = vm.terrainListResponse.find(function (terrain) {
                                return terrain.id === pathGroup.id;
                            });
                            if (terrain) {
                                var contentString = '<div class="infoWindowhead">' +
                                    "<b>Terrain Name: " + terrain.name + "</b></br>" +
                                    "<b>Terrain-Type: " + terrain.typeName + "</b></br>" +
                                    "<b>Length: " + terrain.length + "</b></br>" +
                                    "<b>Phase: " + terrain.phase + "</b></br>" +
                                    "</div>";

                                infowindow.setContent(contentString);
                                infowindow.setPosition(event.latLng);
                                infowindow.open(vm.newMap);
                                openedInfoWindow = infowindow;
                            }
                        })
                        var tooltip = new google.maps.InfoWindow();
                        google.maps.event.addListener(pathPolyline, 'mouseover', function (event) {
                            var terrain = vm.terrainListResponse.find(function (terrain) {
                                return terrain.id === pathGroup.id;
                            });
                            if (terrain) {
                                tooltip.setContent("<b>" + terrain.name + "</b>");
                                tooltip.setPosition(event.latLng);
                                tooltip.open(vm.newMap);
                            }
                        });

                        // Close tooltip when mouse leaves
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            tooltip.close();
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseover', function () {
                            vm.highlightTableTerrain(pathGroup.id);
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            vm.resetTableRowHighlight(pathGroup.id);
                        });
                    }
                });
                vm.newMap.fitBounds(bounds);
            }
            vm.terrainListResponse;
            vm.uniquePhases = [];
            var phasesMap = {};
            vm.isVerifiedFilter = false;
            vm.isNotVerifiedFilter = false;
            vm.isDeviatedFilter = false;
            for (var i = 0; i < vm.terrainListResponse.length; i++) {
                var phase = vm.terrainListResponse[i].phase;
                if (!phasesMap[phase]) {
                    vm.uniquePhases.push({ phase: phase, selected: false });
                    phasesMap[phase] = true;
                }
            }

            vm.uniqueTerrainTypes = [];
            vm.filteredTerrainList = vm.terrainListResponse;
            vm.updateTerrainTypes = function () {
                var selectedPhases = [];

                for (var j = 0; j < vm.uniquePhases.length; j++) {
                    if (vm.uniquePhases[j].selected) {
                        selectedPhases.push(vm.uniquePhases[j].phase);
                    }
                }
                if (selectedPhases.length === 0) {
                    vm.uniqueTerrainTypes = [];
                }

                vm.uniqueTerrainTypes = [];
                var terrainTypesMap = {};
                for (var k = 0; k < vm.terrainListResponse.length; k++) {
                    var terrain = vm.terrainListResponse[k];

                    var isPhaseMatched = selectedPhases.indexOf(terrain.phase) !== -1;
                    var isVerifiedMatch = (vm.isVerifiedFilter && terrain.isVerified === true) ||
                        (vm.isNotVerifiedFilter && terrain.isVerified === false) ||
                        (!vm.isVerifiedFilter && !vm.isNotVerifiedFilter);

                    var isDeviatedMatch = (vm.isDeviatedFilter && terrain.isDeviated === true) ||
                        (!vm.isDeviatedFilter);

                    if (isPhaseMatched && isVerifiedMatch && isDeviatedMatch) {
                        if (!terrainTypesMap[terrain.typeName]) {
                            vm.uniqueTerrainTypes.push({
                                typeName: terrain.typeName,
                                colorcode: terrain.colorcode,
                                selected: false
                            });
                            terrainTypesMap[terrain.typeName] = true;
                        }
                    }
                }

                for (var id in vm.terrainPolylines) {
                    if (vm.terrainPolylines.hasOwnProperty(id)) {
                        vm.terrainPolylines[id].setOptions({ strokeWeight: 3 });
                    }
                }

                vm.areFiltersSelected = function () {
                    var selectedPhases = vm.uniquePhases.some(function (phase) {
                        return phase.selected;
                    });
                    var selectedTerrainTypes = vm.uniqueTerrainTypes.some(function (terrain) {
                        return terrain.selected;
                    });
                    var selectedVerification = vm.isVerifiedFilter || vm.isNotVerifiedFilter || vm.isDeviatedFilter;
                    return selectedPhases || selectedTerrainTypes || selectedVerification;
                };
            };

            vm.applyFilters = function () {
                var selectedPhases = [];
                var selectedTerrainTypes = [];

                for (var l = 0; l < vm.uniquePhases.length; l++) {
                    if (vm.uniquePhases[l].selected) {
                        selectedPhases.push(vm.uniquePhases[l].phase);
                    }
                }

                var filteredList = vm.terrainListResponse.filter(function (terrain) {
                    return selectedPhases.length === 0 || selectedPhases.indexOf(terrain.phase) !== -1;
                });

                var isVerifiedOrNotChecked = vm.isVerifiedFilter || vm.isNotVerifiedFilter;
                var isDeviatedChecked = vm.isDeviatedFilter;

                filteredList = filteredList.filter(function (terrain) {
                    return (!isVerifiedOrNotChecked) ||
                        (vm.isVerifiedFilter && terrain.isVerified === true) ||
                        (vm.isNotVerifiedFilter && (terrain.isVerified === false || terrain.isVerified === null));
                });

                filteredList = filteredList.filter(function (terrain) {
                    return (!isDeviatedChecked) || (vm.isDeviatedFilter && terrain.isDeviated === true);
                });

                var availableTerrainTypes = [];
                filteredList.forEach(function (terrain) {
                    if (availableTerrainTypes.indexOf(terrain.typeName) === -1) {
                        availableTerrainTypes.push(terrain.typeName);
                    }
                });

                vm.uniqueTerrainTypes.forEach(function (terrainType) {
                    terrainType.isAvailable = availableTerrainTypes.indexOf(terrainType.typeName) !== -1;
                });

                for (var m = 0; m < vm.uniqueTerrainTypes.length; m++) {
                    if (vm.uniqueTerrainTypes[m].selected) {
                        selectedTerrainTypes.push(vm.uniqueTerrainTypes[m].typeName);
                    }
                }

                filteredList = filteredList.filter(function (terrain) {
                    return selectedTerrainTypes.length === 0 || selectedTerrainTypes.indexOf(terrain.typeName) !== -1;
                });

                for (var id in vm.terrainPolylines) {
                    if (vm.terrainPolylines.hasOwnProperty(id)) {
                        vm.terrainPolylines[id].setOptions({ strokeWeight: 0 });
                    }
                }

                filteredList.forEach(function (terrain) {
                    var terrainId = terrain.id;
                    if (vm.terrainPolylines[terrainId]) {
                        vm.terrainPolylines[terrainId].setOptions({ strokeWeight: 6, strokeColor: terrain.colorcode });
                    }
                });

                vm.filteredTerrainList = filteredList;
                vm.isFilterMenuOpen = false;
            };

            vm.resetFilters = function () {
                for (var o = 0; o < vm.uniquePhases.length; o++) {
                    vm.uniquePhases[o].selected = false;
                }
                for (var p = 0; p < vm.uniqueTerrainTypes.length; p++) {
                    vm.uniqueTerrainTypes[p].selected = false;
                }
                vm.isVerifiedFilter = false;
                vm.isNotVerifiedFilter = false;
                vm.isDeviatedFilter = false;
                for (var id in vm.terrainPolylines) {
                    if (vm.terrainPolylines.hasOwnProperty(id)) {
                        vm.terrainPolylines[id].setOptions({ strokeWeight: 3 });
                    }
                }
                vm.uniqueTerrainTypes = []
                vm.filteredTerrainList = vm.terrainListResponse;
            };
            vm.closeFilters = function () {
                vm.isFilterMenuOpen = false;

            };
        };
        var flyAnimation = null;
        vm.highlightTerrain = function (terrainId) {
            if (flyAnimation) {
                clearInterval(flyAnimation);
                flyAnimation = null;
            }
            for (var id in vm.terrainPolylines) {
                vm.terrainPolylines[id].setOptions({ strokeWeight: 2 });
            }
            var polyline = vm.terrainPolylines[terrainId];
            if (!polyline) {
                return;
            }
            polyline.setOptions({ strokeWeight: 8 });
            var path = polyline.getPath().getArray();
            if (!path || path.length === 0) {
                return;
            }
            var index = 0;
            flyAnimation = setInterval(function () {
                if (index >= path.length) {
                    clearInterval(flyAnimation);
                    flyAnimation = null;
                    return;
                }
                var latLng = path[index];
                vm.newMap.panTo(latLng);
                index++;
            }, 100);
        };


        vm.resetTerrain = function () {
            if (flyAnimation) {
                clearInterval(flyAnimation);
                flyAnimation = null;
            }
            for (var id in vm.terrainPolylines) {
                vm.terrainPolylines[id].setOptions({ strokeWeight: 3 });
            }
        };

        var flyAnimationRow = null

        vm.highlightRow = function (rowId) {
            if (flyAnimationRow) {
                clearInterval(flyAnimationRow);
                flyAnimationRow = null;
            }
            for (var id in vm.rowPolylines) {
                vm.rowPolylines[id].setOptions({ strokeWeight: 2 });
            }
            var polyline = vm.rowPolylines[rowId];
            if (!polyline) {
                return;
            }
            polyline.setOptions({ strokeWeight: 8 });
            var path = polyline.getPath().getArray();
            if (!path || path.length === 0) {
                return;
            }
            var index = 0;
            flyAnimationRow = setInterval(function () {
                if (index >= path.length) {
                    clearInterval(flyAnimationRow);
                    flyAnimationRow = null;
                    return;
                }
                var latLng = path[index];
                vm.newMaps.panTo(latLng);
                index++;
            }, 100);
        };

        vm.resetRow = function () {
            if (flyAnimationRow) {
                clearInterval(flyAnimationRow);
                flyAnimationRow = null;
            }
            for (var id in vm.rowPolylines) {
                if (vm.rowPolylines.hasOwnProperty(id)) {
                    vm.rowPolylines[id].setOptions({ strokeWeight: 3 });
                }
            }
        };

        vm.highlightTableTerrain = function (id) {
            var terrains = document.querySelectorAll('.highlighted-terrain');
            terrains.forEach(function (terrain) {
                terrain.classList.remove('highlighted-terrain');
            });
            var terrainRow = document.getElementById('terrain-' + id);
            if (terrainRow) {
                terrainRow.classList.add('highlighted-terrain');
                var tableContainer = terrainRow.closest('.scroll_table');
                if (tableContainer) {
                    var containerHeight = tableContainer.clientHeight;
                    var rowOffsetTop = terrainRow.offsetTop;
                    var rowHeight = terrainRow.clientHeight;
                    tableContainer.scrollTo({
                        top: rowOffsetTop - containerHeight / 2 + rowHeight / 2,
                        behavior: 'smooth',
                    });
                }
            }
        };

        vm.highlightTableRow = function (id) {
            var rows = document.querySelectorAll('.highlighted-row');
            rows.forEach(function (row) {
                row.classList.remove('highlighted-row');
            });
            var row = document.getElementById('row-' + id);
            if (row) {
                row.classList.add('highlighted-row');
                var tableContainer = row.closest('.scroll_table');
                if (tableContainer) {
                    var containerHeight = tableContainer.clientHeight;
                    var rowOffsetTop = row.offsetTop;
                    var rowHeight = row.clientHeight;
                    tableContainer.scrollTo({
                        top: rowOffsetTop - containerHeight / 2 + rowHeight / 2,
                        behavior: 'smooth',
                    });
                }
            }
        };

        vm.resetTableRowHighlight = function (id) {
            var terrain = document.getElementById('terrain-' + id)
            var row = document.getElementById('row-' + id);
            if (row) {
                row.classList.remove('highlighted-row');
            }
            if (terrain) {
                terrain.classList.remove('highlighted-terrain');
            }
        };
        vm.isFilterMenuOpen = false;
        vm.toggleFilterMenu = function () {
            vm.isFilterMenuOpen = !vm.isFilterMenuOpen;
        };
        vm.fetchRow = function () {
            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePathResponse = response;
                callRoutePath(vm.routePathResponse.routePoints);
            });
            function callRoutePath(routePaths) {
                var colors = ['#FD7A24', '#0096FF'];
                var pathColor = colors[0];
                var proposedPathColor = colors[1];
                var groupedRoutePaths = {};
                var bounds = new google.maps.LatLngBounds();
                routePaths.forEach(function (coord) {
                    if (coord.sessionNumber) {
                        if (!groupedRoutePaths[coord.sessionNumber]) {
                            groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                        }
                        if (coord.routePointType === 'COORDINATE') {
                            if (coord.phase === 'PLANNING') {
                                groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                            } else if (coord.phase === 'SURVEY') {
                                groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                            }
                        }
                    }
                });
                Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                    var sessionData = groupedRoutePaths[sessionNumber];
                    var pathData = [];
                    if (vm.trRoute.phase == 'PLANNING') {
                        pathData = sessionData.planned;
                    } else {
                        pathData = sessionData.proposed;
                    }
                    if (pathData.length) {
                        var pathCoordinates = pathData.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            zIndex: 1
                        });
                        pathPolyline.setMap(vm.newMaps);
                    }

                    if (sessionData.proposed.length) {
                        var proposedPathCoordinates = sessionData.proposed.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        proposedPathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var proposedPathPolyline = new google.maps.Polyline({
                            path: proposedPathCoordinates,
                            geodesic: true,
                            strokeColor: proposedPathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 1
                        });
                        proposedPathPolyline.setMap(vm.newMaps);
                    }
                });
            }
            var markers = [];
            var openedInfoWindow = null;
            var bounds = new google.maps.LatLngBounds();
            vm.newMaps = new google.maps.Map(
                document.getElementById("map_canvasStartss"),
                myOption($rootScope.rolloutMapInitZoom, center)
            );
            geoLocation(vm.newMaps)
            TrRouteForMap.getRoWPathByRoute(vm.trRoute.id, function (response) {
                vm.rowPathResponse = response;
                callRowPath(vm.rowPathResponse);
            });
            function callRowPath(rowPaths) {
                vm.rowPolylines = {};
                vm.rowMarkers = {};
                rowPaths.forEach(function (pathGroup) {
                    vm.rowColorMap = {};
                    vm.rowListResponse.forEach(function (row) {
                        vm.rowColorMap[row.id] = row.colorcode;
                    });
                    var pathColor = vm.rowColorMap[pathGroup.id]
                    if (pathGroup.value && Array.isArray(pathGroup.value.COORDINATE)) {
                        var pathCoordinates = pathGroup.value.COORDINATE.map(function (coord) {
                            if (Array.isArray(coord.routePointNumber)) {
                                coord.routePointNumber.sort(function (a, b) {
                                    return a - b;
                                });
                            }
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 2
                        });
                        pathPolyline.setMap(vm.newMaps);
                        vm.rowPolylines[pathGroup.id] = pathPolyline;
                        var infowindow = new google.maps.InfoWindow();
                        google.maps.event.addListener(pathPolyline, 'click', function (event) {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }
                            var row = vm.rowListResponse.find(function (row) {
                                return row.id === pathGroup.id;
                            });
                            if (row) {
                                var contentString = '<div class="infoWindowhead">' +
                                    "<b>Terrain Name: " + row.name + "</b></br>" +
                                    "<b>Row-Type: " + row.typeName + "</b></br>" +
                                    "<b>Length: " + row.length + "</b></br>" +
                                    "<b>Phase: " + row.phase + "</b></br>" +
                                    "</div>";

                                infowindow.setContent(contentString);
                                infowindow.setPosition(event.latLng);
                                infowindow.open(vm.newMaps);
                                openedInfoWindow = infowindow;
                            }
                        });
                        var tooltip = new google.maps.InfoWindow();
                        google.maps.event.addListener(pathPolyline, 'mouseover', function (event) {
                            var row = vm.rowListResponse.find(function (row) {
                                return row.id === pathGroup.id;
                            });
                            if (row) {
                                tooltip.setContent("<b>" + row.name + "</b>");
                                tooltip.setPosition(event.latLng);
                                tooltip.open(vm.newMaps);
                            }
                        });

                        // Close tooltip when mouse leaves
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            tooltip.close();
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseover', function () {
                            vm.highlightTableRow(pathGroup.id);
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            vm.resetTableRowHighlight(pathGroup.id);
                        });
                    }
                    if (pathGroup.value && Array.isArray(pathGroup.value.MARKER)) {
                        pathGroup.value.MARKER.forEach(function (coord) {
                            var markerPosition = { lat: coord.latitude, lng: coord.longitude };
                            bounds.extend(markerPosition);
                            var marker = new google.maps.Marker({
                                position: markerPosition,
                                map: vm.newMaps,
                                icon: {
                                    url: 'content/images/markersPoint.png',
                                    scaledSize: new google.maps.Size(iconSize, iconSize),
                                    anchor: new google.maps.Point(
                                        iconSize / 2,
                                        iconSize / 2
                                    ),
                                }
                            });
                            markers.push(marker);
                            markerList.push(marker);

                        });
                        vm.rowMarkers[pathGroup.id] = markerList;
                    }
                    vm.newMaps.fitBounds(bounds);
                });
            }

            vm.rowListResponse;
            vm.uniquePhases = [];
            var phasesMap = {};
            for (var i = 0; i < vm.rowListResponse.length; i++) {
                var phase = vm.rowListResponse[i].phase;
                if (!phasesMap[phase]) {
                    vm.uniquePhases.push({ phase: phase, selected: false });
                    phasesMap[phase] = true;
                }
            }
            vm.uniqueRowTypes = [];
            vm.filteredRowList = vm.rowListResponse;
            vm.updateRowTypes = function () {
                var selectedPhases = [];
                for (var j = 0; j < vm.uniquePhases.length; j++) {
                    if (vm.uniquePhases[j].selected) {
                        selectedPhases.push(vm.uniquePhases[j].phase);
                    }
                }
                if (selectedPhases.length === 0) {
                    vm.uniqueRowTypes = [];

                }
                vm.uniqueRowTypes = [];
                var rowTypesMap = {};
                for (var k = 0; k < vm.rowListResponse.length; k++) {
                    var row = vm.rowListResponse[k];
                    var isPhaseMatched = selectedPhases.indexOf(row.phase) !== -1;
                    var isVerifiedMatch = (vm.isVerifiedFilter && row.isVerified === true) ||
                        (vm.isNotVerifiedFilter && row.isVerified === false) ||
                        (!vm.isVerifiedFilter && !vm.isNotVerifiedFilter);

                    var isDeviatedMatch = (vm.isDeviatedFilter && row.isDeviated === true) ||
                        (!vm.isDeviatedFilter);

                    if (isPhaseMatched && isVerifiedMatch && isDeviatedMatch) {
                        if (!rowTypesMap[row.typeName]) {
                            vm.uniqueRowTypes.push({
                                typeName: row.typeName,
                                colorcode: row.colorcode,
                                selected: false
                            });
                            rowTypesMap[row.typeName] = true;
                        }
                    }
                }
                for (var id in vm.rowPolylines) {
                    if (vm.rowPolylines.hasOwnProperty(id)) {
                        vm.rowPolylines[id].setOptions({ strokeWeight: 3 });
                    }
                }
                vm.areFiltersSelected = function () {
                    var selectedPhases = vm.uniquePhases.some(function (phase) {
                        return phase.selected;
                    });
                    var selectedRowTypes = vm.uniqueRowTypes.some(function (row) {
                        return row.selected;
                    });
                    var selectedVerification = vm.isVerifiedFilter || vm.isNotVerifiedFilter || vm.isDeviatedFilter;
                    return selectedPhases || selectedRowTypes || selectedVerification;
                };

            };
            vm.applyFilters = function () {
                var selectedPhases = [];
                var selectedRowTypes = [];
                for (var l = 0; l < vm.uniquePhases.length; l++) {
                    if (vm.uniquePhases[l].selected) {
                        selectedPhases.push(vm.uniquePhases[l].phase);
                    }
                }
                var filteredList = vm.rowListResponse.filter(function (row) {
                    return selectedPhases.length === 0 || selectedPhases.indexOf(row.phase) !== -1;
                });

                var isVerifiedOrNotChecked = vm.isVerifiedFilter || vm.isNotVerifiedFilter;
                var isDeviatedChecked = vm.isDeviatedFilter;

                filteredList = filteredList.filter(function (row) {
                    return (!isVerifiedOrNotChecked) ||
                        (vm.isVerifiedFilter && row.isVerified === true) ||
                        (vm.isNotVerifiedFilter && (row.isVerified === false || row.isVerified === null));
                });

                filteredList = filteredList.filter(function (row) {
                    return (!isDeviatedChecked) || (vm.isDeviatedFilter && row.isDeviated === true);
                });

                var availableRowTypes = [];
                filteredList.forEach(function (row) {
                    if (availableRowTypes.indexOf(row.typeName) === -1) {
                        availableRowTypes.push(row.typeName);
                    }
                });

                vm.uniqueRowTypes.forEach(function (rowType) {
                    rowType.isAvailable = availableRowTypes.indexOf(rowType.typeName) !== -1;
                });

                for (var m = 0; m < vm.uniqueRowTypes.length; m++) {
                    if (vm.uniqueRowTypes[m].selected) {
                        selectedRowTypes.push(vm.uniqueRowTypes[m].typeName);
                    }
                }

                filteredList = filteredList.filter(function (row) {
                    return selectedRowTypes.length === 0 || selectedRowTypes.indexOf(row.typeName) !== -1;
                });
                for (var id in vm.rowPolylines) {
                    if (vm.rowPolylines.hasOwnProperty(id)) {
                        vm.rowPolylines[id].setOptions({ strokeWeight: 0 });
                    }
                }
                filteredList.forEach(function (row) {
                    var rowId = row.id;
                    if (vm.rowPolylines[rowId]) {
                        vm.rowPolylines[rowId].setOptions({ strokeWeight: 6, strokeColor: row.colorcode });
                    }
                });
                vm.filteredRowList = filteredList;
                vm.isFilterMenuOpen = false;
            };
            vm.resetFilters = function () {
                for (var o = 0; o < vm.uniquePhases.length; o++) {
                    vm.uniquePhases[o].selected = false;
                }
                for (var p = 0; p < vm.uniqueRowTypes.length; p++) {
                    vm.uniqueRowTypes[p].selected = false;
                }
                vm.isVerifiedFilter = false;
                vm.isNotVerifiedFilter = false;
                vm.isDeviatedFilter = false;
                for (var id in vm.rowPolylines) {
                    if (vm.rowPolylines.hasOwnProperty(id)) {
                        vm.rowPolylines[id].setOptions({ strokeWeight: 6 });
                    }
                }

                vm.uniqueRowTypes = []
                vm.filteredRowList = vm.rowListResponse;
            };
            vm.closeFilters = function () {
                vm.isFilterMenuOpen = false;
            };
        };
        vm.SectionMap = new google.maps.Map(
            document.getElementById("SectionMap_canvasStart"),
            myOption($rootScope.rolloutMapInitZoom, center)
        );
        vm.objectSectionImg = {
            hidemarker: false,
            routeId: vm.trRoute ? vm.trRoute.id : null,
            map: vm.SectionMap || null
        };

        if (!vm.objectSectionImg.map) {
            console.error("SectionMap is not defined.");
        }
        var routeMarkers = []
        google.maps.event.addListener(
            vm.SectionMap,
            "dragend",
            function () {
                var center = vm.SectionMap.getCenter();
                imageRoutePoint.postCenterLatLng(vm.trRoute.id, { lat: center.lat(), lng: center.lng() }, function (data) {
                    if (data.length) {
                        for (var i = 0; i < routeMarkers.length; i++) {
                            routeMarkers[i].setMap(null);
                        }
                        routeMarkers = [];
                        callRouteImage(data, vm.SectionMap)
                    }
                })
            }
        );
        function callRouteImage(arr, map) {
            var markerImage, iconImg
            var iconSize = 20
            var iconMarker = "content/images/sm_marker_transparent.png"
            var iconImage = "content/images/routePointImage.png"
            arr.forEach(function (each) {
                iconImg = (each.imageAttached) ? iconImage : iconMarker
                markerImage = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconImg,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                var infowindow = new google.maps.InfoWindow({
                    content:
                        '',
                });

                google.maps.event.addListener(
                    markerImage,
                    "click",
                    (function () {
                        if (each && each.id && each.imageAttached) {
                            $scope.imgName = (each.name == null) ? "Marker" : each.name
                            $scope.imgLatitude = each.latitude
                            $scope.imgLongitude = each.longitude
                            $scope.$apply();
                            imageRoutePoint.getImagesList(each.id, function (item) {
                                if (item.length >= 2) {
                                    item.forEach(function (i) {
                                        i.rID = each.id
                                    })
                                    $scope.nameImages = item;
                                    $("#modalAttachments").show();

                                } else {
                                    item.map(function (media) {
                                        vm.newTabDisplay(each.id, media.imageId, media.imageType, media.imgDescription)
                                    })
                                }
                                // $scope.$apply()
                            })
                        } else {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }
                            var contentString = document.createElement("div");
                            contentString.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<br><br>" +
                                "<b>Name : " + each.type + "_" + each.id + "</b><br>" +
                                "<b>Latitude : " + each.latitude + "</b><br>" +
                                "<b>Longitude : " + each.longitude + "</b><br>" +
                                "<b>Type : " + each.type + "</b><br>" +
                                "<br></div>";

                            infowindow.setContent(contentString);
                            infowindow.setPosition({
                                lat: each.latitude,
                                lng: each.longitude
                            });
                            infowindow.open(scope.obj.map);
                            openedInfoWindow = infowindow;

                            if (!each.imageAttached) {
                                var btnShowAsset = document.createElement("input");
                                btnShowAsset.type = "button";
                                btnShowAsset.value = "Show attributes";
                                btnShowAsset.className = "button";

                                google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                    imageRoutePoint.getRouteMarkerDetails(each.id, function (response) {
                                        showAssetAttributesModals(response);
                                    });
                                });

                                contentString.appendChild(btnShowAsset);
                            }

                        }
                    })
                );

                routeMarkers.push(markerImage);
            })


        }
        vm.newTabDisplay = function (id, imgid, str, imgDescription) {
            if (vm.tabNum == 2) {
                $scope.routePointId = id
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) {
                    spinner.style.display = "block";
                }

                var request = new XMLHttpRequest();
                request.open("GET", 'api/routepoint-images/' + id + '/' + imgid, true);
                request.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                request.responseType = "blob";
                request.onload = function () {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    if (request.status === 200) {
                        var urlCreator = window.URL || window.webkitURL;
                        var mediaUrl = urlCreator.createObjectURL(request.response);
                        if (imgDescription == '360') {
                            var modalContent = document.getElementById("mediaModalContent");
                            var videoHTML = '<div class="video-container style="flex: 0 0 70%; height: 500px; position: relative;">' +
                                '<a-scene embedded vr-mode-ui="enabled: true" style="width: 100%; height: 100%; position: absolute;">' +
                                '<a-assets>' +
                                '<video id="video360" loop playsinline webkit-playsinline crossorigin="anonymous" style="width: 100%; height: 100%; object-fit: cover;">' +
                                '<source src="' + mediaUrl + '" type="video/mp4">' +
                                '</video>' +
                                '</a-assets>' +
                                '<a-videosphere src="#video360"></a-videosphere>' +
                                '<a-entity camera position="0 1.6 0" look-controls wasd-controls></a-entity>' +
                                '</a-scene>' +
                                '<div class="controls" style="position: absolute; bottom: 10px; left: 10px; background: rgba(0,0,0,0.5); padding: 10px;">' +
                                '<button id="playPauseBtn">Pause</button>' +
                                '<button id="muteBtn">Mute</button>' +
                                '<input type="range" id="seekBar" min="0" value="0" step="1">' +
                                '</div>' +
                                '</div>';

                            var mapHTML = '<div class="map-container" style="flex: 0 0 30%; height: 379px;">' +
                                '<div id="map" style="width: 100%; height: 100%;"></div>' +
                                '</div>';

                            modalContent.innerHTML = '<div style="display: flex; width: 100%; height: 390px;justify-content: space-between;">' +
                                videoHTML + mapHTML + '</div>';

                            $("#mediaModal").modal("show");
                            $("#mediaModal").on("shown.bs.modal", function () {
                                setTimeout(function () {
                                    var video = document.getElementById("video360");
                                    var playPauseBtn = document.getElementById("playPauseBtn")
                                    var muteBtn = document.getElementById("muteBtn");
                                    var seekBar = document.getElementById("seekBar");
                                    var scene = document.querySelector("a-scene");

                                    if (video) {
                                        video.play();
                                        // Play/Pause
                                        playPauseBtn.addEventListener("click", function () {
                                            if (video.paused) {
                                                video.play();
                                                playPauseBtn.textContent = "Pause";
                                            } else {
                                                video.pause();
                                                playPauseBtn.textContent = "Play";
                                            }
                                        });

                                        // Mute/Unmute
                                        muteBtn.addEventListener("click", function () {
                                            video.muted = !video.muted;
                                            muteBtn.textContent = video.muted ? "Unmute" : "Mute";
                                        });

                                        // Seek Bar Update
                                        video.addEventListener("loadedmetadata", function () {
                                            seekBar.max = video.duration;
                                            var durationInSeconds = video.duration;
                                            var minutes = Math.floor(durationInSeconds / 60);
                                            var seconds = Math.floor(durationInSeconds % 60).toString().padStart(2, '0');
                                        });

                                        video.addEventListener("timeupdate", function () {
                                            seekBar.value = video.currentTime;
                                        });

                                        seekBar.addEventListener("input", function () {
                                            video.currentTime = seekBar.value;
                                        });

                                        // Prevent automatic fullscreen issue
                                        scene.setAttribute("gesture-detector", "enabled: true");

                                        // Keep Modal Open on VR Exit
                                        scene.addEventListener("exit-vr", function () {
                                            $("#mediaModal").modal("show");
                                        });

                                    } else {
                                        console.log("Video element not found.");
                                    }
                                }, 1000);
                            });

                            // Clear modal content when closed
                            $("#mediaModal").on("hidden.bs.modal", function () {
                                modalContent.innerHTML = "";
                            });
                        } else if (str === "MP4") {
                            RouteImageMeta.getData(id, function (response) {
                                var metaCoordinates;
                                metaCoordinates = Array.isArray(response) ? response : [];
                                if (metaCoordinates.length > 0) {
                                    var modalContent = document.getElementById("mediaModalContent");
                                    // Ensure mediaUrl is properly defined before this block
                                    var videoHTML = '<div class="video-container style="flex: 0 0 70%; height: 500px; position: relative;">' +
                                        '<video id="videoPlayer" controls autoplay style="max-width: 99%; max-height: 100vh; object-fit: contain;">' +
                                        '<source src="' + mediaUrl + '" type="video/mp4">' +
                                        'Your browser does not support the video tag.' +
                                        '</video>' +
                                        '</div>';
                                    var mapHTML = '<div class="map-container" style="flex: 0 0 30%; height: 379px;"">' +
                                        '<div id="map" style="width: 100%; height: 100%;"></div>' +
                                        '</div>';

                                    modalContent.innerHTML = '<div  style="display: flex; width: 100%; height: 390px;justify-content: space-between;">' +
                                        videoHTML + mapHTML + '</div>';

                                    $("#mediaModal").modal("show");

                                    $("#mediaModal").on("shown.bs.modal", function () {
                                        setTimeout(function () {
                                            var video = document.getElementById("videoPlayer");
                                            if (!video) return;
                                            video.onpause = function () {
                                                pauseMarkerAnimation();
                                            };
                                            video.onplay = function () {
                                                resumeMarkerAnimation();
                                            };

                                            var lastTime = 0;

                                            video.addEventListener('canplay', function () {
                                                var givenTime = video.currentTime;
                                                var direction = givenTime >= lastTime ? 'forward' : 'backward'; // Determine playback direction

                                                var nearestIndex = $scope.coordinates.findIndex(function (coord) {
                                                    return coord.timeInSec >= givenTime;
                                                });

                                                if (nearestIndex === -1) {
                                                    nearestIndex = $scope.coordinates.length - 1;
                                                }
                                                $scope.nearestObject = $scope.coordinates[nearestIndex];

                                                if (direction === 'backward') {
                                                    clearPolylines();
                                                    drawBackwardPolyline(nearestIndex);
                                                } else if (direction === 'forward') {
                                                    drawForwardPolyline(nearestIndex);
                                                }

                                                clearTimeout(animationTimeout);
                                                animatedMove($scope.usermarker, $scope.coordinates, nearestIndex);
                                                lastTime = givenTime;
                                            });
                                            function clearPolylines() {
                                                if ($scope.polyline) {
                                                    $scope.polyline.setMap(null);
                                                    $scope.polyline = null;
                                                }
                                            }
                                            function drawForwardPolyline(nearestIndex) {
                                                var pathCoordinates = $scope.coordinates.slice(0, nearestIndex + 1).map(function (coord) {
                                                    return { lat: coord.lat, lng: coord.lng }
                                                });

                                                if ($scope.polyline) {
                                                    $scope.polyline.setPath(pathCoordinates);
                                                } else {
                                                    $scope.polyline = new google.maps.Polyline({
                                                        path: pathCoordinates,
                                                        geodesic: true,
                                                        strokeColor: '#0000FF',
                                                        strokeOpacity: 0.8,
                                                        strokeWeight: 16,
                                                    });
                                                    $scope.polyline.setMap(scope.map);
                                                }
                                            }

                                            function drawBackwardPolyline(nearestIndex) {
                                                var pathCoordinates = $scope.coordinates.slice(0, nearestIndex - 1).map(function (coord) {
                                                    return { lat: coord.lat, lng: coord.lng }
                                                });

                                                clearPolylines();
                                                if ($scope.polyline) {
                                                    $scope.polyline.setPath(pathCoordinates);
                                                } else {
                                                    $scope.polyline = new google.maps.Polyline({
                                                        path: pathCoordinates,
                                                        geodesic: true,
                                                        strokeColor: '#0000FF',
                                                        strokeOpacity: 0.8,
                                                        strokeWeight: 16,
                                                    });
                                                    $scope.polyline.setMap(scope.map);
                                                }
                                            }

                                            clearTimeout(animationTimeout);
                                            isPaused = false;
                                            currentIndex = 0;
                                            animatedMove($scope.usermarker, $scope.coordinates, 0);

                                        }, 100);
                                    });

                                    // **Clear modal content when hidden**
                                    $("#mediaModal").on("hidden.bs.modal", function () {
                                        modalContent.innerHTML = "";
                                        if ($scope.polyline) {
                                            $scope.polyline.setMap(null);
                                            $scope.polyline = null;
                                        }
                                        $scope.usermarker = null;
                                        clearTimeout(animationTimeout);
                                        isPaused = false;
                                        animationTimeout = null;
                                        currentIndex = 0;
                                    });

                                } else if (metaCoordinates.length === 0) {
                                    var modalContent = document.getElementById("mediaModalContent");
                                    var videoHTML =
                                        '<div class="video-container" style="width: 100%; height: 600px; position: relative;">' +
                                        '<video id="videoPlayer" controls autoplay style="max-width: 100%; max-height: 100vh; object-fit: contain;">' +
                                        '<source src="' + mediaUrl + '" type="video/mp4">' +
                                        'Your browser does not support the video tag.' +
                                        '</video>' +
                                        '</div>';

                                    modalContent.innerHTML = videoHTML;

                                    $("#mediaModal").modal("show");

                                    $("#mediaModal").on("hidden.bs.modal", function () {
                                        modalContent.innerHTML = "";
                                    });

                                    return;
                                }
                            })
                        } else {
                            var modalContent = document.getElementById("mediaModalContent");
                            // modalContent.innerHTML = '<img src="' + mediaUrl + '" style="max-width: 90%; max-height: 60vh; width: 800px; height: 700px;" alt="Image">';
                            modalContent.innerHTML = '<img id="zoomableImage" src="' + mediaUrl + '" ' +
                                'style="max-height: 60vh; height: 700px; width: auto; display: block; margin: auto; ' +
                                'object-fit: contain; transition: transform 0.1s ease;" ' +
                                'alt="Image">';

                            var img = document.getElementById("zoomableImage");
                            var scale = 1;

                            img.onmousewheel = function (event) {
                                event = event || window.event; // Support for older browsers
                                event.preventDefault(); // Prevent page scrolling

                                if (event.wheelDelta > 0) {
                                    // Zoom in
                                    scale += 0.1;
                                } else {
                                    // Zoom out (minimum scale of 1)
                                    scale = Math.max(1, scale - 0.1);
                                }

                                img.style.transform = "scale(" + scale + ")";
                            };


                            $("#mediaModal").modal("show");

                            $("#mediaModal").on("hidden.bs.modal", function () {
                                modalContent.innerHTML = "";
                            });
                        }
                    } else {
                        alert("Error loading media: " + request.status);
                    }
                };

                request.onerror = function () {
                    alert("Network error while fetching media.");
                };

                request.send();
            }
        };
        var minRouteMetaUtcTime = 0;
        var metaCoordinates = []
        var customControlDiv = document.createElement('div');
        var customControlText = document.createElement('div');
        // var geocoder = new google.maps.Geocoder();

        $scope.initializeMap = function () {
            if (vm.tabNum == 2) {
                if (!document.getElementById("map")) {
                    console.error("Map element not found!");
                    return;
                }
                $scope.map = new google.maps.Map(document.getElementById("map"), {
                    center: { lat: 13.027893369650114, lng: 77.59144741784749 },
                    zoom: 18,
                    tilt: 45, // Enable 3D mode for rotation
                    heading: 0,
                    // mapId: "90f87356969d889c", // Vector map ID required for tilt and rotation
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    cameraControl: true,
                    fullscreenControl: true
                });
                coordinateListPlanSurvey.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                $scope.polyline = new google.maps.Polyline({
                    path: coordinateListPlanSurvey,
                    geodesic: true,
                    strokeColor: '#0000FF', // Set polyline color
                    strokeOpacity: 0.4,
                    strokeWeight: 32,
                    map: $scope.map
                });

                customControlText.style.backgroundColor = 'rgba(211, 211, 211, 0.7)';
                customControlText.style.color = '#1a237e';
                customControlText.style.fontSize = '12px';
                customControlText.style.fontWeight = 'bold';
                customControlText.style.padding = '12px';
                customControlText.style.margin = '10px';
                customControlText.style.borderRadius = '5px';
                customControlText.style.boxShadow = '0px 2px 5px rgba(0, 0, 0, 0.3)';
                customControlDiv.appendChild(customControlText);
                $scope.map.controls[google.maps.ControlPosition.TOP_LEFT].push(customControlDiv);

                $scope.polyline = new google.maps.Polyline({
                    path: [],
                    geodesic: true,
                    strokeColor: '#0000FF',
                    strokeOpacity: 0.8,
                    strokeWeight: 16,
                    map: $scope.map
                });

                RouteImageMeta.getData($scope.routePointId, function (response) {
                    $scope.metaCoordinates = Array.isArray(response) ? response : [];
                    if (!response || response.length === 0) {
                        console.warn("No coordinates received.");
                        return;
                    }
                    minRouteMetaUtcTime = $scope.metaCoordinates.reduce(function (min, current) {
                        return current.coordinateDate < min ? current.coordinateDate : min;
                    }, $scope.metaCoordinates[0].coordinateDate);

                    $scope.metaCoordinates.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    // Extract the coordinates and their corresponding coordinateDate
                    $scope.coordinates = $scope.metaCoordinates.map(function (coord) {
                        return { lat: coord.latitude, lng: coord.longitude, coordinateDate: coord.coordinateDate, gpsAccuracy: coord.gpsAccuracy, timeInSec: (coord.coordinateDate - minRouteMetaUtcTime) / 1000 };
                    });
                    $scope.usermarker = new google.maps.Marker({
                        position: $scope.coordinates[0],
                        map: $scope.map,
                        icon: {
                            url: 'content/images/geoLocationAnim.gif',
                            scaledSize: new google.maps.Size(24, 24),
                            anchor: new google.maps.Point(12, 12)
                        }
                    });
                    animatedMove($scope.usermarker, $scope.coordinates, 0);
                });
            }
        };
        var animationTimeout;
        var isPaused = false;
        var currentStep = 0;
        var currentIndex = 0;

        function animatedMove(usermarker, coords, index) {
            currentIndex = index; // Save the current coordinate index
            var moveto = new google.maps.LatLng(coords[index].lat, coords[index].lng);

            $scope.moveMarker(usermarker, coords, index, moveto); // Start animation
        }

        $scope.moveMarker = function (usermarker, coords, index, moveto) {
            if (isPaused) return; // Exit if paused
            usermarker.setPosition(moveto);
            $scope.map.setCenter(moveto);
            $scope.polyline.getPath().push(moveto);
            showLatLngOnMapForVideo(moveto.lat(), moveto.lng(), coords[index].gpsAccuracy);
            if (index < coords.length - 1) {
                var nextPoint = coords[index + 1];
                var bearing = getBearing(moveto.lat(), moveto.lng(), nextPoint.lat, nextPoint.lng);
                $scope.map.setHeading(bearing);
            }
            animationTimeout = setTimeout(function () {
                animatedMove(usermarker, coords, index + 1);
            }, 1000);
        }
        function pauseMarkerAnimation() {
            isPaused = true;
            clearTimeout(animationTimeout); // Stop the ongoing movement
        }
        function resumeMarkerAnimation() {
            if (!isPaused) return;
            isPaused = false;
            if (!$scope.usermarker || !$scope.coordinates) {
                console.error("usermarker or coordinates are not defined");
                return;
            }
            animatedMove($scope.usermarker, $scope.coordinates, currentIndex);
        }

        function showLatLngOnMapForVideo(lat, lng, gpsAccuracy) {
            var accuracy = gpsAccuracy;
            if (gpsAccuracy == null) {
                accuracy = "";
            } else {
                accuracy.toFixed(2);
            }
            // var latLng = new google.maps.LatLng(lat, lng);
            customControlText.innerHTML = 'Location: ' + lat.toFixed(8) + ', ' + lng.toFixed(8);
            // geocoder.geocode({ 'location': latLng }, function (results, status) {
            //     if (status === google.maps.GeocoderStatus.OK) {
            //         if (results[0]) {
            //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>' + results[0].formatted_address;
            //         } else {
            //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>No address found.';
            //         }
            //     } else {
            //         customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>Geocode failed: ' + status;
            //     }
            // });
        }

        function getBearing(lat1, lng1, lat2, lng2) {
            var dLon = (lng2 - lng1) * (Math.PI / 180);
            lat1 = lat1 * (Math.PI / 180);
            lat2 = lat2 * (Math.PI / 180);

            var y = Math.sin(dLon) * Math.cos(lat2);
            var x = Math.cos(lat1) * Math.sin(lat2) -
                Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
            var brng = Math.atan2(y, x) * (180 / Math.PI);
            return (brng + 360) % 360; // Normalize to 0-360 degrees
        }

        $("#mediaModal").on("shown.bs.modal", function () {
            setTimeout(function () {
                $scope.initializeMap();
            }, 2000);
        });
        $scope.closeModal = function (id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
        function showAssetAttributesModals(assetVal) {
            var AttributeValues = []
            $("#modalAssetAttributes").show();
            AttributeValues.push({
                "Id": assetVal.id,
                "Depth": assetVal.depth,
                "Distance": assetVal.distance,
                "Latitude": assetVal.latitude,
                "Longitude": assetVal.longitude,
                "LHS Offset": assetVal.lhsOffset,
                "Land Mark": assetVal.landMark,
                "Height": assetVal.height,
                "RHS Offset": assetVal.rhsOffset,
                "Route Offset": assetVal.routeOffset,
                "Road Width": assetVal.roadWidth,
                "RodoMeter Length": assetVal.rodometerLength,
                "Route Point Type": assetVal.routePointType,
                "Road Type": assetVal.roadType,
                "Placement Level": assetVal.placementLevel,
                "Phase": assetVal.phase,
                "Status": assetVal.status,
                "Surrounding Type": assetVal.surroundingType,
                "Soil Type": assetVal.soilType,
                "Terrain Area": assetVal.terrainArea,
            })
            var attributes = AttributeValues[0];
            document.getElementById("assetAttributeTable").innerHTML = "";
            var newTable =
                "<table align='center' style='border: 1px solid black; width: 80%;'>" +
                "<tr><th style='border: 1px solid black; text-align: center;'>Attribute</th>" +
                "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";

            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    newTable +=
                        "<tr><td style='border: 1px solid black; text-align: center;'>" +
                        key +
                        "</td><td style='border: 1px solid black; text-align: center;'>" +
                        (attributes[key] !== null ? attributes[key] : "N/A") +
                        "</td></tr>";
                }
            }

            newTable += "</table>";

            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.id + " - " + (assetVal.routePointType || "Unknown");
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }


        document.getElementById("maximizeBtn").addEventListener("click", function () {
            var modalDialog = document.querySelector("#mediaModal .modal-dialog");
            var videoContainer = document.querySelector("#mediaModalContent .video-container");
            var modalContent = document.getElementById("mediaModalContent");
            if (metaCoordinates.length > 0) {
                var mapContainer = document.querySelector("#mediaModalContent .map-container");
                mapContainer.style.flex = "0 0 25%";
                mapContainer.style.height = "86vh";
                videoContainer.style.height = '400px'
            }
            if (metaCoordinates.length == 0) {
                videoContainer.style.height = '610px'
            }


            modalDialog.style.width = "100%";
            modalDialog.style.height = "100vh";
            modalDialog.style.maxWidth = "100%";
            modalDialog.style.margin = "0";
            modalDialog.style.paddingLeft = "0";
            modalDialog.style.top = "0px";
            modalContent.style.height = "100vh";
            videoContainer.style.flex = "0 0 75%";
            document.getElementById("maximizeBtn").style.display = "none";
            document.getElementById("minimizeBtn").style.display = "inline-block";
        });

        document.getElementById("minimizeBtn").addEventListener("click", function () {
            var modalDialog = document.querySelector("#mediaModal .modal-dialog");
            var videoContainer = document.querySelector("#mediaModalContent .video-container");
            var zoomableImage = document.querySelector("#mediaModalContent .zoomableImage");
            var modalContent = document.getElementById("mediaModalContent");
            if (metaCoordinates.length > 0) {
                var mapContainer = document.querySelector("#mediaModalContent .map-container");
                mapContainer.style.flex = "0 0 30%";
                mapContainer.style.height = "379px";
                modalContent.style.height = "400px";
                modalDialog.style.paddingLeft = "0";
            }
            if (metaCoordinates.length == 0) {
                modalDialog.style.paddingLeft = "0";
                modalContent.style.height = "615px";
            }
            modalDialog.style.width = "auto";
            modalDialog.style.height = "auto";
            modalDialog.style.maxWidth = "80%";
            modalDialog.style.margin = "auto";
            modalDialog.style.paddingLeft = "0";
            modalDialog.style.top = "50px";
            videoContainer.style.flex = "0 0 70%";
            videoContainer.style.height = "600px";
            document.getElementById("maximizeBtn").style.display = "inline-block";
            document.getElementById("minimizeBtn").style.display = "none";
        });

        $("#mediaModal").on("hidden.bs.modal", function () {
            var modalDialog = document.querySelector("#mediaModal .modal-dialog");
            var videoContainer = document.querySelector("#mediaModalContent .video-container");
            var mapContainer = document.querySelector("#mediaModalContent .map-container");
            var modalContent = document.getElementById("mediaModalContent");

            modalDialog.style.width = "auto";
            modalDialog.style.height = "auto";
            modalDialog.style.maxWidth = "80%";
            modalDialog.style.margin = "auto";
            modalDialog.style.paddingLeft = "0";
            modalDialog.style.top = "50px";

            if (videoContainer) {
                videoContainer.style.flex = "0 0 70%";
                videoContainer.style.height = "500px";
            }
            if (mapContainer) {
                mapContainer.style.flex = "0 0 30%";
                mapContainer.style.height = "379px";
            }
            if (modalContent) {
                modalContent.style.height = "400px";
                modalContent.innerHTML = "";
            }
            if (modalContent && metaCoordinates.length === 0) {
                modalContent.style.height = "610px";
                modalContent.innerHTML = "";
            }

            document.getElementById("maximizeBtn").style.display = "inline-block";
            document.getElementById("minimizeBtn").style.display = "none";

            var videoElement = document.querySelector("#mediaModalContent video");
            if (videoElement) {
                videoElement.pause();
                videoElement.src = "";
                videoElement.load();
            }

            var aScene = document.querySelector("a-scene");
            if (aScene) {
                aScene.innerHTML = "";
            }
            if (metaCoordinates.length > 0) {
                var mapElement = document.getElementById("map");
                if (mapElement) {
                    mapElement.innerHTML = "";
                }
            }
        });

        geoLocation(vm.SectionMap)
        if (vm.trRoute && vm.trRoute.routePoints != null && vm.trRoute.routePoints.length) {
            vm.trRoute.routePoints.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

            var groupedRoutePoints = {};
            vm.trRoute.routePoints.forEach(function (each) {
                if (each.routePointType == "COORDINATE" && each.phase != null) {
                    if (!groupedRoutePoints[each.sessionNumber]) {
                        groupedRoutePoints[each.sessionNumber] = [];
                    }
                    groupedRoutePoints[each.sessionNumber].push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber });
                }
            });

            Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                var sessionCoordinates = groupedRoutePoints[sessionNumber];
                var bounds = new google.maps.LatLngBounds();

                if (sessionCoordinates.length) {
                    sessionCoordinates.forEach(function (coord) {
                        bounds.extend(coord);
                    });
                    sessionCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    var polyline = new google.maps.Polyline({
                        path: sessionCoordinates,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        zIndex: 1
                    });
                    polyline.setMap(vm.SectionMap);
                }
                vm.SectionMap.fitBounds(bounds);
            });
        }

        var sectionPath = {};
        vm.getSectionPath = function () {
            //section path

            vm.sectionPolyline = {}
            routeDetail.getRoutesDetails(entity.id, function (response) {
                vm.sectionResponse = response
                vm.sectionResponse.forEach(function (section) {
                    TaskSectionById.get(section.sectionId, function (sectionVal) {
                        sectionPath = sectionVal;
                        if (sectionPath.COORDINATE != null) {
                            sectionPath.COORDINATE.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                            sectionPath.COORDINATE.forEach(function (coor) {
                                if (coor.routePointNumber) {
                                    coordinateList.push({ latitude: coor.latitude, longitude: coor.longitude, sort: coor.routePointNumberDouble, sessionNumber: coor.sessionNumber });
                                }
                            });
                        }

                    })
                })
                if (coordinateList.length) {
                    vm.SectionMap.setCenter({ lat: coordinateList[0].latitude, lng: coordinateList[0].longitude });
                    var groupedBySessionNumber = {};
                    for (var i = 0; i < coordinateList.length; i++) {
                        var item = coordinateList[i];
                        var session = item.sessionNumber;

                        if (!groupedBySessionNumber[session]) {
                            groupedBySessionNumber[session] = [];
                        }

                        groupedBySessionNumber[session].push(item);
                    }

                    // Initialize groupedRoutePaths
                    var groupedRoutePaths = {};

                    // Populate groupedRoutePaths with session data
                    Object.keys(groupedBySessionNumber).forEach(function (sessionNumber) {
                        var sessionData = groupedBySessionNumber[sessionNumber];

                        // Map session data to lat/lng pairs
                        if (sessionData) {
                            groupedRoutePaths[sessionNumber] = sessionData.map(function (point) {
                                return { lat: point.latitude, lng: point.longitude, sort: point.sort, sessionNumber: point.sessionNumber };
                            });
                        }
                    });
                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        if (sessionNumber !== "null") {
                            var paths = groupedRoutePaths[sessionNumber];
                            paths.sort(function (a, b) {
                                return a.sort - b.sort;
                            });
                            var polylines = new google.maps.Polyline({
                                path: paths,
                                geodesic: true,
                                strokeColor: 'red',
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                zIndex: 2
                            });
                            polylines.setMap(vm.SectionMap);
                        }
                    });

                }

            })
            vm.taskPolyline = vm.taskPolyline || {};
            vm.dailyLogPolyline = vm.dailyLogPolyline || {};
            vm.obstaclePolyline = vm.obstaclePolyline || {};
            vm.sectionResponse.forEach(function (task) {
                Inventory.taskBySection(task.sectionId, function (response) {
                    vm.taskLogResponse = response;
                    vm.taskLogResponse.forEach(function (task) {
                        Inventory.taskPathByID(task.id, function (response) {
                            if (response.COORDINATE !== undefined) {
                                var polylineCoordinates = [];
                                response.COORDINATE.forEach(function (coordinate) {
                                    if (coordinate.routePointType === 'COORDINATE') {
                                        var latLng = {
                                            lat: coordinate.latitude,
                                            lng: coordinate.longitude
                                        };
                                        polylineCoordinates.push(latLng);
                                    }
                                });
                                var taskPolyline = new google.maps.Polyline({
                                    path: polylineCoordinates,
                                    geodesic: true,
                                    strokeColor: '#c89f9c',
                                    strokeOpacity: 0.4,
                                    strokeWeight: 4,
                                    zIndex: 2
                                });
                                taskPolyline.setMap(vm.SectionMap);
                                vm.taskPolyline[task.id] = taskPolyline;
                            }
                        });
                        taskComment.getTaskLogsPaths(task.id, function (response) {
                            function drawPath(logType, color, zIndex) {
                                var segmentCoordinates = [];
                                DailyLogByTaskIdWithType.query({ id: task.id, type: logType }, function (logs) {
                                    response.forEach(function (item) {
                                        logs.forEach(function (log) {
                                            if (item.id == log.id) {
                                                var sortedCoordinates = item.value.COORDINATE.filter(function (coord) {
                                                    return coord.routePointType === "COORDINATE" && coord.latitude && coord.longitude
                                                })
                                                    .sort(function (a, b) {
                                                        var numA = parseFloat(a.routePointNumber) || 0;
                                                        var numB = parseFloat(b.routePointNumber) || 0;
                                                        return numA - numB;
                                                    });
                                                sortedCoordinates.forEach(function (coord) {
                                                    segmentCoordinates.push({
                                                        lat: coord.latitude,
                                                        lng: coord.longitude,
                                                        routePointNumber: parseFloat(coord.routePointNumber),
                                                    });
                                                });
                                                if (segmentCoordinates.length > 1) {
                                                    drawPolyline(segmentCoordinates, color, zIndex);
                                                }
                                                segmentCoordinates = [];
                                            }
                                        });
                                    });
                                });
                                var pathPolyline = new google.maps.Polyline({
                                    path: segmentCoordinates,
                                    geodesic: true,
                                    strokeColor: color,
                                    strokeOpacity: 0.4,
                                    strokeWeight: 4,
                                    zIndex: zIndex
                                });
                                pathPolyline.setMap(vm.SectionMap);
                            }
                            function drawPolyline(coordinates, color, zIndex, bounds) {
                                var polyline = new google.maps.Polyline({
                                    path: coordinates.map(function (latLng) {
                                        return new google.maps.LatLng(latLng.lat, latLng.lng);
                                    }),
                                    geodesic: true,
                                    strokeColor: color,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 4,
                                    zIndex: zIndex,
                                });
                                polyline.setMap(vm.SectionMap);
                            }
                            drawPath("OBSTACLE", "#ff0000", 4);
                            drawPath("PROGRESS", "#00e658", 3);
                        });
                    });
                });
            });
            vm.taskCombinedData = [];
            vm.sectionCombinedData = [];
            var taskDataLoaded = false;
            var sectionDataLoaded = false;

            function checkAndMergeData() {
                if (taskDataLoaded && sectionDataLoaded) {
                    var taskLengths = {};
                    var obstacleLengths = {};
                    var taskLengthsLoadedCount = 0;
                    var obstacleLengthsLoadedCount = 0;

                    vm.taskCombinedData.forEach(function (task) {
                        dailyLog.query({ id: task.taskId }, function (response) {
                            var totalLength = 0;
                            angular.forEach(response, function (log) {
                                totalLength += log.workLength;
                            });
                            taskLengths[task.taskId] = totalLength;
                            taskLengthsLoadedCount++;
                            if (taskLengthsLoadedCount === vm.taskCombinedData.length && obstacleLengthsLoadedCount === vm.taskCombinedData.length) {
                                mergeTaskSectionData(taskLengths, obstacleLengths);
                            }
                        });
                        dailyLogByTaskId.query({ id: task.taskId }, function onSuccess(response) {
                            var obstacleLength = 0;
                            angular.forEach(response, function (log) {
                                obstacleLength += log.workLength;
                            });
                            obstacleLengths[task.taskId] = obstacleLength;
                            obstacleLengthsLoadedCount++;
                            if (taskLengthsLoadedCount === vm.taskCombinedData.length && obstacleLengthsLoadedCount === vm.taskCombinedData.length) {
                                mergeTaskSectionData(taskLengths, obstacleLengths);
                            }
                        });
                    });
                    vm.updateTasksWithMaterials()
                }
            }

            function mergeTaskSectionData(taskLengths, obstacleLengths) {
                vm.mergedArray = vm.taskCombinedData.map(function (task) {
                    var matchingSection = vm.sectionCombinedData.find(function (section) {
                        return section.sectionId === task.sectionId;
                    });
                    return {
                        TaskName: task.TaskName,
                        taskId: task.taskId,
                        taskLength: task.taskLength || "N/A",
                        fromLatlng: task.fromLatlng || 'N/A',
                        toLatlng: task.toLatlng || "N/A",
                        routeId: task.routeId,
                        sectionId: task.sectionId,
                        sectionName: matchingSection ? matchingSection.sectionName : "Unknown Section",
                        vendorName: matchingSection ? matchingSection.vendorName : "Unknown Vendor",
                        totalLength: taskLengths[task.taskId] || 0,
                        obstacleLength: obstacleLengths[task.taskId] || 0,
                        isExpanded: false
                    };
                });

                vm.uniqueMaterials = [];
                vm.mtrlTxSummaries = {};

                angular.forEach(vm.mergedArray, function (item) {
                    SummaryPost.mtrlTx({ taskIds: [item.taskId] }, function (response) {
                        vm.mtrlTxSummaries[item.taskId] = response;
                        angular.forEach(response, function (material) {
                            var existing = vm.uniqueMaterials.find(function (m) {
                                return m.materialName === material.materialName && m.transactionType === material.transactionType;
                            });
                            if (existing) {
                                existing.totalNoOfUnits += material.totalNoOfUnits;
                            } else {
                                vm.uniqueMaterials.push({
                                    materialName: material.materialName,
                                    transactionType: material.transactionType,
                                    totalNoOfUnits: material.totalNoOfUnits,
                                    length: material.unitOfMeasurementName
                                });
                            }
                        });
                        vm.updateTasksWithMaterials();
                    });
                });
                loadMaterialsForTasks();
            }
            routeDetail.getRoutesDetails(entity.id, function (response) {
                vm.sectionResponse = response;
                angular.forEach(vm.sectionResponse, function (section) {
                    vm.sectionCombinedData.push({
                        sectionId: section.sectionId,
                        routeId: section.routeId,
                        sectionName: section.sectionName,
                        vendorName: section.vendorName || 'N/A',
                    });
                });
                sectionDataLoaded = true;
                function loadTasksSequentially(index) {
                    if (index >= vm.sectionResponse.length) {
                        taskDataLoaded = true;
                        checkAndMergeData();
                        return;
                    }

                    var section = vm.sectionResponse[index];
                    routeDetail.taskBySection(section.sectionId, function (taskResponse) {
                        angular.forEach(taskResponse, function (task) {
                            vm.taskCombinedData.push({
                                TaskName: task.name,
                                taskId: task.id,
                                taskLength: task.length || 'N/A',
                                fromLatlng: task.fromLatlng || 'N/A',
                                toLatlng: task.toLatLng || "N/A",
                                routeId: section.routeId,
                                sectionId: section.sectionId
                            });
                        });
                        loadTasksSequentially(index + 1);
                    });
                }
                loadTasksSequentially(0);
                vm.updateTasksWithMaterials();
            });

            vm.toggleSection = function (item) {
                vm.mergedArray.forEach(function (otherItem) {
                    if (otherItem !== item) {
                        otherItem.isExpand = false;
                    }
                });
                item.isExpand = !item.isExpand;
                if (item.isExpand) {
                    SummaryPost.mtrlTx({ taskIds: [item.taskId] }, function (response) {
                        vm.mtrlTxSummary = response;
                    });
                }
            };
            vm.tasksWithMaterials = [];
            function allMaterialsLoaded() {
                return vm.mergedArray.every(function (item) { return vm.mtrlTxSummaries && vm.mtrlTxSummaries[item.taskId] });
            }
            vm.updateTasksWithMaterials = function () {
                vm.tasksWithMaterials = [];
                if (vm.mergedArray && vm.mergedArray.length > 0) {
                    vm.mergedArray.forEach(function (item) {
                        if (vm.mtrlTxSummaries && vm.mtrlTxSummaries[item.taskId]) {
                            var materialMap = {};
                            vm.mtrlTxSummaries[item.taskId].forEach(function (material) {
                                var uniqueKey = material.materialName;
                                if (!materialMap[uniqueKey]) {
                                    materialMap[uniqueKey] = {
                                        sectionName: item.sectionName,
                                        TaskName: item.TaskName,
                                        materialName: material.materialName,
                                        unitOfMeasurementName: material.unitOfMeasurementName,
                                        Requested: 0,
                                        Received: 0,
                                        Utilized: 0,
                                        Reconciled: 0
                                    };
                                }
                                switch (material.transactionType) {
                                    case 'REQUESTED':
                                        materialMap[uniqueKey].Requested += material.totalNoOfUnits;
                                        break;
                                    case 'RECEIVED':
                                        materialMap[uniqueKey].Received += material.totalNoOfUnits;
                                        break;
                                    case 'UTILIZED':
                                        materialMap[uniqueKey].Utilized += material.totalNoOfUnits;
                                        break;
                                    case 'RECONCILED':
                                        materialMap[uniqueKey].Reconciled += material.totalNoOfUnits;
                                        break;
                                }
                            });
                            for (var key in materialMap) {
                                vm.tasksWithMaterials.push(materialMap[key]);
                            }
                        }
                    });
                }
            };
            function loadMaterialsForTasks() {
                angular.forEach(vm.mergedArray, function (item) {
                    if (!vm.mtrlTxSummaries) {
                        vm.mtrlTxSummaries = {};
                    }

                    SummaryPost.mtrlTx({ taskIds: [item.taskId] }, function (response) {
                        vm.mtrlTxSummaries[item.taskId] = response;
                        if (allMaterialsLoaded()) {
                            vm.updateTasksWithMaterials();
                        }
                    });
                });
            }
        }
        vm.downloadMaterialTnx = function () {
            var csvContent = "data:text/csv;charset=utf-8,";
            csvContent += "Sl No,Section Name,Task Name,Material Name,Unit,Requested,Received,Utilized,Reconciled\n";
            vm.tasksWithMaterials.forEach(function (material, index) {
                var row = [
                    index + 1,
                    material.sectionName,
                    material.TaskName,
                    material.materialName,
                    material.unitOfMeasurementName || 0,
                    material.Requested || 0,
                    material.Received || 0,
                    material.Utilized || 0,
                    material.Reconciled || 0
                ].join(",");
                csvContent += row + "\n";
            });

            var encodedUri = encodeURI(csvContent);
            var downloadLink = document.createElement("a");
            downloadLink.href = encodedUri;
            downloadLink.download = entity.name + "_Material_List.csv";
            downloadLink.click();
        };

        vm.startPoint = null;
        vm.endPoint = null;
        vm.highlightLog = function (id) {
            var polyline = vm.dailyLogPolyline[id];
            if (polyline) {
                polyline.setOptions({
                    strokeWeight: 16
                });
                var path = polyline.getPath().getArray();
                var fromLatLng = path[0];
                var toLatLng = path[path.length - 1];
                if (vm.startPoint) {
                    vm.startPoint.setMap(null);
                }
                if (vm.endPoint) {
                    vm.endPoint.setMap(null);
                }
                vm.startPoint = new google.maps.Marker({
                    position: fromLatLng,
                    map: vm.SectionMap,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: "content/images/sections.png",
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            -4
                        ),
                        labelOrigin: new google.maps.Point(25, 22)
                    },
                    label: {
                        text: 'Start',
                        color: '#000000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                });
                vm.endPoint = new google.maps.Marker({
                    position: toLatLng,
                    map: vm.SectionMap,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: "content/images/sections.png",
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            -4
                        ),
                        labelOrigin: new google.maps.Point(25, 22)
                    },
                    label: {
                        text: 'End',
                        color: '#000000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                });
            }
        };
        vm.resetLog = function () {
            Object.keys(vm.dailyLogPolyline).forEach(function (key) {
                var polyline = vm.dailyLogPolyline[key];
                if (polyline) {
                    polyline.setOptions({
                        strokeWeight: 6
                    });
                }
            });
            if (vm.startPoint) {
                vm.startPoint.setMap(null);
                vm.startPoint = null;
            }
            if (vm.endPoint) {
                vm.endPoint.setMap(null);
                vm.endPoint = null;
            }
        };
        vm.highlightTask = function (taskId) {
            for (var id in vm.taskPolyline) {
                if (id == taskId) {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 12 });
                } else {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 7 });
                }
            }
        }
        vm.resetTask = function () {
            for (var id in vm.taskPolyline) {
                if (vm.taskPolyline.hasOwnProperty(id)) {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 7 });
                }
            }
        }
        vm.highlightSection = function (sectionId) {
            var iconSize = 30;
            for (var id in vm.sectionPolyline) {
                if (vm.sectionPolyline.hasOwnProperty(id)) {
                    if (id == sectionId) {
                        vm.sectionPolyline[id].setOptions({
                            strokeWeight: 7
                        });
                    }
                }
            }
        };
        vm.resetRoute = function () {
            for (var id in vm.sectionPolyline) {
                if (vm.sectionPolyline.hasOwnProperty(id)) {
                    vm.sectionPolyline[id].setOptions({ strokeWeight: 5 });
                }
            }
        }
        setTimeout(function () {
            TaskStatusById.post(
                { routeIds: [entity.id] },
                function (statusresponse) {
                    vm.taskstatus = statusresponse;
                    if (vm.taskstatus.length) {
                        callTaskStatusByStagCat()
                    }
                }
            );
        }, 5000)
        function callTaskStatusByStagCat() {
            vm.objectTaskStatus = {}
            vm.taskstatus.forEach(function (eachElement) {
                if (eachElement.taskCategory == "Route-Task") {
                    createObjMapping(eachElement)
                } else if (eachElement.taskCategory == "Section-Task") {
                    createObjMapping(eachElement)
                }
            })
        }
        function createObjMapping(eachElement) {
            if (!vm.objectTaskStatus[eachElement.taskCategory]) {
                vm.objectTaskStatus[eachElement.taskCategory] = {};
            }
            if (!vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage]) {
                vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage] = []
            }
            if (eachElement.totalWorkLength && eachElement.taskLength) {
                vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage].push({
                    taskTypeName: eachElement.taskTypeName,
                    totalWorkLength: eachElement.totalWorkLength,
                    taskLength: eachElement.taskLength,
                    percentage: eachElement.percentage
                });
            }
        }
        vm.taskColors = {
            'Machinery Trenching': '#33FF57',
            'HDD ( Horizontal Directional Drilling )': '#33FF57',
            'Validation': '#3357FF'
        };

      if(vm.tabNum== 4){
          setTimeout(function () {
            callTransaction("Material")
        }, 7000)
        setTimeout(function () {
            callTransaction("Resource")
        }, 8000)
      }
        function callTransaction(str) {

            if (str == "Resource") {
                SummaryPost.resTx({
                    "projectIds": [entity.projectId],
                    "routeIds": [entity.id]
                }, function (response) {
                    if (response.length) {
                        vm.resTxSummary = response
                        var data = [];
                        vm.mapResourceTransaction = {};

                        response.forEach(function (item) {
                            if (!vm.mapResourceTransaction[item.resourceName]) {
                                vm.mapResourceTransaction[item.resourceName] = {
                                    item: item.resourceName,
                                    PLANNED: 0,
                                    REQUESTED: 0,
                                    RECEIVED: 0,
                                    UTILIZED: 0,
                                    RECONCILED: 0
                                };
                                data.push(vm.mapResourceTransaction[item.resourceName]);
                            }
                            vm.mapResourceTransaction[item.resourceName][item.transactionType] += item.totalNoOfResources;
                        });

                        d3.selectAll("#RESOURCES > *").remove();
                        showDashboardData(data, 'RESOURCES')
                    }
                })
            } else if (str == "Material") {
                SummaryPost.mtrlTx(
                    {
                        projectIds: [entity.projectId],
                        routeIds: [entity.id],
                    },
                    function (response) {
                        vm.mtrlTxSummary = response;
                        if (response.length) {
                            var data = [];
                            var map = {};

                            response.forEach(function (item) {
                                if (!map[item.materialName]) {
                                    map[item.materialName] = {
                                        item: item.materialName,
                                        PLANNED: 0,
                                        REQUESTED: 0,
                                        RECEIVED: 0,
                                        UTILIZED: 0,
                                        RECONCILED: 0,
                                    };
                                    data.push(map[item.materialName]);
                                }
                                map[item.materialName][item.transactionType] +=
                                    item.totalNoOfUnits;
                            });

                            //console.log(data)

                            d3.selectAll("#materialChart > *").remove();
                            callUOM(data)
                            showDashboardData(data, "materialChart");
                        }
                    })
            }

        }

        function callUOM(data) {
            vm.uomMaterialTransaction = {}
            data.forEach(function (item) {
                if (item.UOM != null) {
                    if (!vm.uomMaterialTransaction[item.UOM]) {
                        vm.uomMaterialTransaction[item.UOM] = []
                    }
                    vm.uomMaterialTransaction[item.UOM].push(item)
                }
            })

            if (vm.uomMaterialTransaction) {
                if (vm.storeMaterialTransactionName.length) {
                    vm.storeMaterialTransactionName.forEach(function (eachElement) {
                        d3.selectAll("#" + eachElement + " > *").remove();
                    })
                }
                var parentContainer = document.getElementById(
                    "parentMaterial"
                );
                var newDiv = document.createElement(
                    "div"
                );
                Object.keys(vm.uomMaterialTransaction).forEach(function (key) {
                    vm.storeMaterialTransactionName.push(key)
                    newDiv.id = key
                    parentContainer.appendChild(newDiv);
                    showDashboardData(
                        vm.uomMaterialTransaction[key],
                        key
                    );
                })
            }
        }
        function showDashboardData(data, id) {
            var margin, width, height, svg, x, y, xAxis, yAxis;
            // Your existing code for setting up the c
            margin = { top: 20, right: 30, bottom: 85, left: 40 };

            // Get the current width and height of the window
            width = window.innerWidth * 0.8 - margin.left - margin.right;
            height =
                window.innerHeight * 0.5 - margin.top - margin.bottom - 100;

            x = d3.scale
                .ordinal()
                .rangeRoundBands([0, width], 0.1)
                .domain(
                    data.map(function (d) {
                        return d.item;
                    })
                );

            y = d3.scale
                .linear()
                .range([height, 0])
                .domain([
                    0,
                    d3.max(data, function (d) {
                        return d3.max([
                            d.PLANNED,
                            d.REQUESTED,
                            d.RECEIVED,
                            d.UTILIZED,
                            d.RECONCILED,
                        ]);
                    }),
                ]);

            xAxis = d3.svg.axis().scale(x).orient("bottom");
            yAxis = d3.svg.axis()
                .scale(y)
                .orient("left")
                .ticks(5) // Set the number of ticks
                .tickFormat(d3.format("d")); // Use a format that removes decimals


            svg = d3
                .select("#" + id)
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + margin.left + "," + margin.top + ")"
                );

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style("font-size", "11px")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-35)");

            svg.append("g").attr("class", "y axis").call(yAxis);

            // Add text next to the y-axis
            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", 0 - margin.left)
                .attr("x", 0 - height / 2 - (margin.right + 40))
                .attr("dy", "1em")
                .style("text-anchor", "middle")
                .text(id);

            var colors = [
                "#AF7AC5",
                "#7FB3D5",
                "#76D7C4",
                "#E59866",
                "#ffdcf1",
            ];

            var categories = [
                "PLANNED",
                "REQUESTED",
                "RECEIVED",
                "UTILIZED",
                "RECONCILED",
            ];

            var tooltip1 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");



            categories.forEach(function (category, i) {
                svg.selectAll(".bar-" + category)
                    .data(data)
                    .enter()
                    .append("rect")
                    .attr("class", "bar-" + category)
                    .attr("x", function (d) {
                        return (
                            x(d.item) + (x.rangeBand() / categories.length) * i
                        );
                    })
                    .attr("width", x.rangeBand() / categories.length)
                    .attr("y", function (d) {
                        return y(Math.max(0.1, d[category]));
                    })
                    .attr("height", function (d) {
                        return Math.max(1, height - y(Math.max(0.1, d[category])));
                    })
                    .style("fill", colors[i])

                    .on("mouseover", function (d) {

                        if (d[category] != 0) {
                            tooltip1
                                .style("left", d3.event.pageX - 50 + "px")
                                .style("top", d3.event.pageY - 50 + "px")
                                .style("display", "inline-block")
                                .style("fill", "black")
                                .html(category + ' - ' + d[category]);
                            return tooltip1.style("visibility", "visible");
                        }

                    })
                    .on("mousemove", function () {
                        return tooltip1
                            .style("top", d3.event.pageY - 10 + "px")
                            .style("left", d3.event.pageX + 10 + "px");
                    })
                    .on("mouseout", function () {
                        return tooltip1.style("visibility", "hidden");
                    });
            });

        }

        $scope.names = ['PLANNED', 'REQUESTED', 'RECEIVED', 'UTILIZED', 'RECONCILED'];
        $scope.legends = [
            { name: 'PLANNED', color: '#AF7AC5' },
            { name: 'REQUESTED', color: '#7FB3D5' },
            { name: 'RECEIVED', color: '#76D7C4' },
            { name: 'UTILIZED', color: '#E59866' },
            { name: 'RECONCILED', color: '#ffdcf1' }
        ];

        function addLatLng(event, map) {
            var path = polyMeasureTool.getPath();
            path.push(event.latLng);
            addPointer(event.latLng, map);
            var point1, point2
            for (var i = 0; i < path.getLength() - 1; i++) {
                point1 = path.getAt(i);
                point2 = path.getAt(i + 1);
                segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
                // Add distance marker
                midpoint = google.maps.geometry.spherical.interpolate(point1, point2, 0.5);

            }

            if (path.getLength() > 1) {
                totalDistance += segmentDistance;
                var marker = new google.maps.Marker({
                    position: midpoint,
                    map: map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: formatDistance(segmentDistance),
                    },
                });
                distanceMarkers.push(marker);

                var totalDistanceMarker = new google.maps.Marker({
                    position: point2,
                    map: map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: "Total : " + formatDistance(totalDistance),
                    },
                });
                totalDistanceMarkers.push(totalDistanceMarker);
            }

        }

        function addPointer(location, map) {
            var pointerIcon = {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                strokeColor: 'black',
                fillColor: 'white',
                fillOpacity: 1,
                strokeWeight: 2
            };

            var pointer = new google.maps.Marker({
                position: location,
                map: map,
                icon: pointerIcon
            });
            pointerMarkers.push(pointer);
        }
        function formatDistance(distance) {
            // Convert meters to kilometers
            var km = distance / 1000;

            // Show in meters if less than 1 km, otherwise show in kilometers
            if (km < 1) {
                return distance.toFixed(0) + ' m';
            } else {
                return km.toFixed(2) + ' km';
            }
        }

        function clearMeasureTool(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].setMap(null)
            }
        }

        function geoLocation(map) {
            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);

            goTo.addEventListener("click", function () {
                gotoLatitute();
            });
            measureTool = document.createElement("button");
            measureTool.setAttribute("title", "Measure Distance");
            measureTool.classList.add("custom-map-control-button");
            measureTool.id = "measureDistance";
            measureToolIcon.classList.add("fa");
            measureToolIcon.classList.add("fa-arrows-h");
            measureToolIcon.classList.add("ruler");
            measureTool.appendChild(measureToolIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(measureTool);
            measureTool.addEventListener("click", function () {

                if (measureEnabled) {
                    google.maps.event.removeListener(vm.clickListener);

                    totalDistance = 0
                    clearMeasureTool(distanceMarkers)
                    clearMeasureTool(pointerMarkers)
                    clearMeasureTool(arrpolyMeasureTool)
                    clearMeasureTool(totalDistanceMarkers)
                    distanceMarkers = []
                    totalDistanceMarkers = []
                    pointerMarkers = []
                    arrpolyMeasureTool = []
                    measureEnabled = false
                    measureTool.setAttribute("title", "Measure Distance");
                    measureToolIcon.classList.remove("fa-times");
                    measureToolIcon.classList.add("fa-arrows-h");
                } else {
                    measureEnabled = true
                    polyMeasureTool = new google.maps.Polyline({
                        strokeColor: 'black',
                        strokeOpacity: 1.0,
                        strokeWeight: 3
                    });
                    polyMeasureTool.setMap(map);
                    arrpolyMeasureTool.push(polyMeasureTool)

                    vm.clickListener = map.addListener('click', function (event) {
                        addLatLng(event, map)
                    });
                    measureTool.setAttribute("title", "Clear Distance");
                    measureToolIcon.classList.remove("fa-arrows-h");
                    measureToolIcon.classList.add("fa-times");
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }
        var input = document.getElementById("field_pinLat");
        input.addEventListener("input", function () {
            this.value = this.value.replace(/[^-0-9\,\.]/, "");
        });

        function showZoomLocation() {
            var latlng = vm.getLocationCoordinate.split(",");
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinate != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                if ($scope.tab == 10) {
                    vm.newMaps.setCenter(assetCenterLatLng);
                    vm.newMaps.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: vm.newMaps,
                        position: assetCenterLatLng,
                    });
                    input.value = ''
                }
                if ($scope.tab == 9) {
                    vm.newMap.setCenter(assetCenterLatLng);
                    vm.newMap.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: vm.newMap,
                        position: assetCenterLatLng,
                    });
                    input.value = ''
                }
                if ($scope.tab == 1) {
                    locations.map.setCenter(assetCenterLatLng);
                    // locations.map.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: locations.map,
                        position: assetCenterLatLng,
                    });
                    input.value = ''
                }
                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }

        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
        }

        function gotoLatituteCity() {
            $("#modalLatLongs").show();
        }

        function closeGotoLatitute(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
        function closeGotoLatituteCity() {
            $("#modalLatLongs").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLatLongs").hide();
        }

        vm.downloadMaterial = function () {
            BaseUrl.getBaseUrl(function (baseurl) {
                var request = new XMLHttpRequest();
                request.open('GET', baseurl.stringValue + "api/rollout/mtrl-tx-summary-export-excel/" + vm.trRoute.projectId + "/" + vm.trRoute.id, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';
                request.onload = function (e) {
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'MtrlTxSummaryExportExcel.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    }
                };
                request.send();
            });
        }

        vm.downloadResource = function () {
            BaseUrl.getBaseUrl(function (baseurl) {
                var request = new XMLHttpRequest();
                request.open('GET', baseurl.stringValue + "api/rollout/res-tx-summary-export-excel/" + vm.trRoute.projectId + "/" + vm.trRoute.id, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'ResTxSummaryExportExcel.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    }
                };
                request.send();
            });
        }

        BaseUrl.getBaseUrl(function (baseurl) {
            $scope.downloadExcelBoqSoq = function () {
                var apiUrl = baseurl.stringValue + "api/report-download";

                $http({
                    method: "GET",
                    url: apiUrl,
                    responseType: "arraybuffer" // Important for binary data
                }).then(function (response) {
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "BoQAndSoQ.xlsx"; // File name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function (error) {
                    console.error("Error downloading Excel file:", error);
                });
            };
        });



        BaseUrl.getBaseUrl(function (baseurl) {
            $scope.downloadExcelSurveyReport = function () {
                var apiUrl = baseurl.stringValue + "api/survey-report-download";

                $http({
                    method: "GET",
                    url: apiUrl,
                    responseType: "arraybuffer" // Important for binary data
                }).then(function (response) {
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "SurveyReport.xlsx"; // File name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function (error) {
                    console.error("Error downloading Excel file:", error);
                });
            };
        });


        vm.updateMarkerVisibility = function () {
            if (vm.objectRouteImg && typeof vm.objectRouteImg.toggleMarkers === 'function') {
                vm.objectRouteImg.toggleMarkers();
            }
        };
        vm.updateImageMarkerVisibility = function () {
            if (vm.objectRouteImg && typeof vm.objectRouteImg.toggleRouteMarkers === 'function') {
                vm.objectRouteImg.toggleRouteMarkers();
            }
        };
        var assetMarker = []
        var spreadPolyline = []
        vm.routeAsset = []
        vm.assets = [];
        $scope.showDropDown = true
        function loadAssets(routeId, lastId) {
            routeDetail.getAssetsById(routeId, lastId, function (response) {
                vm.routeAsset = response.assets

                if (vm.routeAsset.length >= 50) {
                    vm.routeAsset.forEach(function (asset) {
                        vm.assets.push(asset);
                    });
                    loadAssets(
                        vm.trRoute.id,
                        vm.routeAsset[vm.routeAsset.length - 1].id
                    );
                } else {
                    vm.routeAsset.forEach(function (asset) {
                        vm.assets.push(asset);
                    });
                    vm.assets.forEach(function (asset) {
                        var coordinates = asset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        drawAssetMarker(asset)
                        if (asset.assetTypeLayout === 'SPREAD') {
                            var polylineColor = "";
                            polylineColor = "#ff0025";
                            if (!asset.isExisting) {
                                polylineColor = "#00A36C"; //tmpColor = "blue";
                            }
                            if (!asset.isUsed && asset.isExisting) {
                                polylineColor = "#FFAE42";
                            }
                            var drawPolyline = new google.maps.Polyline({
                                path: coordinates,
                                geodesic: true,
                                strokeColor: polylineColor,
                                strokeOpacity: 0.9,
                                strokeWeight: 3,
                                zIndex: 1
                            });
                            drawPolyline.setMap(locations.map);
                            spreadPolyline.push(drawPolyline);
                            var polylineInfoWindow = new google.maps.InfoWindow();

                            (function (currentAsset) {
                                google.maps.event.addListener(drawPolyline, 'click', function (event) {
                                    if (openedInfoWindow !== null) {
                                        openedInfoWindow.close();
                                    }

                                    var infoWindowContent = document.createElement('div');
                                    infoWindowContent.className = "infoWindowhead";

                                    infoWindowContent.innerHTML = "<b>ID: " + currentAsset.id + "</b><br>" +
                                        "<b>Name: " + currentAsset.name + "</b><br>" +
                                        "<b>AssetTypeName: " + currentAsset.assetTypeName + "</b><br>";

                                    if (vm.trRoute.id) {
                                        var btnShowAsset = document.createElement("input");
                                        btnShowAsset.type = "button";
                                        btnShowAsset.value = "Show attributes";
                                        btnShowAsset.className = "button";

                                        infoWindowContent.appendChild(btnShowAsset);

                                        google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                            AssetByID.get(currentAsset.id, function (response) {
                                                showAssetAttributesModal(response);
                                            });
                                        });
                                    }

                                    polylineInfoWindow.setContent(infoWindowContent);
                                    polylineInfoWindow.setPosition(event.latLng);
                                    polylineInfoWindow.open(locations.map);
                                    openedInfoWindow = polylineInfoWindow;
                                });
                            })(asset); // IIFE passing current asset
                        }
                    });
                    var searchInput = document.createElement("input");
                    searchInput.type = "text";
                    searchInput.placeholder = "Search asset...";
                    searchInput.style.position = "absolute";
                    searchInput.style.top = "10px";
                    searchInput.style.left = "50%";
                    searchInput.style.transform = "translateX(-50%)";
                    searchInput.style.zIndex = "5";
                    searchInput.style.padding = "5px";
                    searchInput.style.border = "1px solid #ccc";
                    searchInput.style.borderRadius = "4px";
                    document.getElementById("map_canvasStart").appendChild(searchInput);
                    searchInput.addEventListener("input", function () {
                        var searchTerm = searchInput.value.toLowerCase();
                        var foundAsset = null;
                        vm.assets.forEach(function (asset) {
                            if (asset.name.toLowerCase().includes(searchTerm)) {
                                foundAsset = asset;
                            }
                        })
                        if (foundAsset) {
                            var coordinates = foundAsset.assetCoordinates.map(function (coord) {
                                return { lat: coord.latitude, lng: coord.longitude };
                            });
                            if (coordinates.length > 0) {
                                locations.map.setCenter(coordinates[0]);
                                locations.map.setZoom(15);
                            }
                        }
                    });
                }
            });
        }
        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue: assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }
        AllAssetsTypes.getAll(function (response) {
            vm.assetTypeValues = response.length ? response : null;
        });

        vm.layerItems = [];
        vm.selectedLayers = {};
        vm.filteredAssetsList = [];
        vm.layersInitialized = false;

        vm.showLayers = function () {
            if (!vm.layersInitialized) {
                if (vm.layerItems.length > 0) return;
                vm.layerItems = [];
                var uniqueAssetTypeNames = {};
                for (var i = 0; i < vm.assets.length; i++) {
                    var item = vm.assets[i];
                    var temp = vm.assetTypeValues.find(function (storedAsset) {
                        return storedAsset.name === item.assetTypeName;
                    });
                    item.assetType = temp;
                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(temp);
                    var assetType = item.assetTypeName.trim().toUpperCase();
                    var mapAssetsTypeName = ['OLT'].includes(assetType)
                        ? 'BLOCK'
                        : assetType === 'JOINT KIT'
                            ? 'JUNCTION POINT' : assetType === 'GP'
                                ? 'GP Router' : item.assetTypeName;
                    if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                        if (item.isExisting === true && item.isUsed === true) {
                            if (!uniqueAssetTypeNames["Existing"]) {
                                uniqueAssetTypeNames["Existing"] = true;
                                var existingSelected = vm.selectedLayers["Existing"] !== undefined ? vm.selectedLayers["Existing"] : true;
                                vm.layerItems.push({ name: "Existing", selected: existingSelected });
                                vm.selectedLayers["Existing"] = existingSelected;
                            }
                        }
                        if (item.isExisting === true && item.isUsed === false) {
                            if (!uniqueAssetTypeNames["Unused"]) {
                                uniqueAssetTypeNames["Unused"] = true;
                                var unusedSelected = vm.selectedLayers["Unused"] !== undefined ? vm.selectedLayers["Unused"] : true;
                                vm.layerItems.push({ name: "Unused", selected: unusedSelected });
                                vm.selectedLayers["Unused"] = unusedSelected;
                            }
                        }
                        if (item.isExisting === false) {
                            if (!uniqueAssetTypeNames["New OFC"]) {
                                uniqueAssetTypeNames["New OFC"] = true;
                                var newSelected = vm.selectedLayers["New OFC"] !== undefined ? vm.selectedLayers["New OFC"] : true;
                                vm.layerItems.push({ name: "New OFC", selected: newSelected });
                                vm.selectedLayers["New OFC"] = newSelected;
                            }
                        }

                    }

                    else {
                        if (!uniqueAssetTypeNames[mapAssetsTypeName]) {
                            uniqueAssetTypeNames[mapAssetsTypeName] = true;
                            var layerSelected = vm.selectedLayers[mapAssetsTypeName] !== undefined ? vm.selectedLayers[mapAssetsTypeName] : true;
                            vm.layerItems.push({
                                name: mapAssetsTypeName,
                                selected: layerSelected
                            });
                            vm.selectedLayers[mapAssetsTypeName] = layerSelected;
                        }
                    }
                }
                vm.layersInitialized = true;
            }
        };

        vm.updateSelectedLayers = function () {
            vm.selectedLayers = {};
            for (var i = 0; i < vm.layerItems.length; i++) {
                var layer = vm.layerItems[i];
                if (layer.selected) {
                    vm.selectedLayers[layer.name] = true;
                }
            }
            vm.filterMapByLayers();
        };

        var assetPolyline = [];

        vm.filterMapByLayers = function () {
            clearMarkersPolyLine();
            vm.filteredAssetsList = vm.assets.filter(function (item) {
                var assetType = item.assetTypeName.trim().toUpperCase();
                var mapAssetsTypeName = ['OLT'].includes(assetType)
                    ? 'BLOCK'
                    : assetType === 'JOINT KIT'
                        ? 'JUNCTION POINT' : assetType === 'GP'
                            ? 'GP Router' : item.assetTypeName;
                if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                    var attrType = item.assetTypeAttributeValues[0] &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute.assetAttributeTypes;
                    if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                        if (item.isExisting && item.isUsed && vm.selectedLayers["Existing"]) {
                            return true;
                        }
                        if (item.isExisting && item.isUsed === false && vm.selectedLayers["Unused"]) {
                            return true;
                        }
                        if (!item.isExisting && vm.selectedLayers["New OFC"]) {
                            return true;
                        }

                        return false;
                    }
                    return false;
                }

                return vm.selectedLayers[mapAssetsTypeName];
            });

            for (var k = 0; k < vm.filteredAssetsList.length; k++) {
                var asset = vm.filteredAssetsList[k];
                if (asset.assetCoordinates) {
                    var assetCoordinateValues = [];
                    for (var j = 0; j < asset.assetCoordinates.length; j++) {
                        assetCoordinateValues.push({ lat: asset.assetCoordinates[j].latitude, lng: asset.assetCoordinates[j].longitude });
                    }
                    if (assetCoordinateValues.length > 0 && assetCoordinateValues[0].sortOrder != null) {
                        assetCoordinateValues.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    }
                    if (asset.assetTypeLayout === "SPREAD") {
                        var polylineColor = "";
                        polylineColor = "#ff0025";
                        if (!asset.isExisting) {
                            polylineColor = "#00A36C"; //tmpColor = "blue";
                        }
                        if (!asset.isUsed && asset.isExisting) {
                            polylineColor = "#FFAE42";
                        }
                        var polyline = new google.maps.Polyline({
                            path: assetCoordinateValues,
                            geodesic: true,
                            strokeColor: polylineColor,
                            strokeOpacity: 0.9,
                            strokeWeight: 3,
                            zIndex: 1
                        });
                        polyline.setMap(locations.map);
                        assetPolyline.push(polyline);
                        (function (currentAsset) {
                            var polylineInfoWindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(polyline, 'click', function (event) {
                                if (openedInfoWindow !== null) {
                                    openedInfoWindow.close();
                                }

                                var infoWindowContent = document.createElement('div');
                                infoWindowContent.className = "infoWindowhead";

                                infoWindowContent.innerHTML = "<b>ID: " + currentAsset.id + "</b><br>" +
                                    "<b>Name: " + currentAsset.name + "</b><br>" +
                                    "<b>AssetTypeName: " + currentAsset.assetTypeName + "</b><br>";

                                if (vm.trRoute.id) {
                                    var btnShowAsset = document.createElement("input");
                                    btnShowAsset.type = "button";
                                    btnShowAsset.value = "Show attributes";
                                    btnShowAsset.className = "button";

                                    infoWindowContent.appendChild(btnShowAsset);

                                    google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                        AssetByID.get(currentAsset.id, function (response) {
                                            showAssetAttributesModal(response);
                                        });
                                    });
                                }

                                polylineInfoWindow.setContent(infoWindowContent);
                                polylineInfoWindow.setPosition(event.latLng);
                                polylineInfoWindow.open(locations.map);
                                openedInfoWindow = polylineInfoWindow;
                            });
                        })(asset);
                    } else if (asset.assetTypeLayout === "FIXED") {
                        drawAssetMarker(asset);
                    }
                }
            }
        };
        vm.toggleCheckAll = false;

        vm.toggleAllLayers = function () {
            var checkAll = vm.toggleCheckAll;
            for (var i = 0; i < vm.layerItems.length; i++) {
                vm.layerItems[i].selected = checkAll;
            }
            vm.objectRouteImg = vm.objectRouteImg || {};
            vm.objectRouteImg.hideRoutemarker = checkAll;
            vm.objectRouteImg.hidemarker = checkAll;
            vm.updateSelectedLayers();
            if (typeof vm.updateImageMarkerVisibility === 'function') {
                vm.updateImageMarkerVisibility();
            }
            if (typeof vm.updateMarkerVisibility === 'function') {
                vm.updateMarkerVisibility();
            }
            vm.toggleCheckAll = !vm.toggleCheckAll;
        };


        function drawAssetMarker(asset) {
            var coordinates = asset.assetCoordinates.map(function (coord) {
                return { lat: coord.latitude, lng: coord.longitude };
            });
            if (asset.assetTypeLayout === 'FIXED') {
                vm.gpAssets.push(asset);
                if (asset.assetTypeName == "GP" && (asset.phase == "SURVEY" || asset.phase == "ROLLOUT")) {
                    var marker = new google.maps.Marker({
                        position: coordinates[0],
                        map: locations.map,
                        title: asset.name,
                        icon: {
                            url: 'content/images/yellowGp.png',
                            scaledSize: new google.maps.Size(32, 32)
                        }
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: coordinates[0],
                        map: locations.map,
                        title: asset.name,
                        icon: {
                            url: asset.assetTypeImagePath,
                            scaledSize: new google.maps.Size(32, 32)
                        }
                    });
                }
                function updateMarkerLabelVisibility() {
                    var currentZoom = locations.map.getZoom();
                    if (currentZoom > 10) {
                        if (asset.assetTypeName == "GP") {
                            marker.setLabel({
                                color: "red",
                                fontWeight: "bold",
                                fontSize: "12px",
                                text: asset.name,
                                className: "asset_label top-label"
                            });
                        }
                    } else {
                        marker.setLabel(null);
                    }
                    var style = document.createElement('style');
                    style.innerHTML = '.top-label {' +
                        '    position: relative; /* Needed for top positioning */' +
                        '    top: 30px; /* Adjust this value to move the label higher */' +
                        '    left: 0;' +
                        '    transform: translateX(10%); /*center the label*/' +
                        '    white-space: nowrap; /*prevent wrapping*/' +
                        '}';
                    document.head.appendChild(style);
                }
                assetMarker.push(marker)
                var infowindow = new google.maps.InfoWindow();

                var updateIconSize = function () {
                    var zoom = locations.map.getZoom();

                    // Define minimum and maximum zoom levels
                    var minZoom = 8;
                    var maxZoom = 21;

                    // Define minimum and maximum icon sizes
                    var minSize = 6;  // Smallest size at zoom 8
                    var maxSize = 60;  // Full size at zoom 21

                    // Compute new size based on zoom level
                    var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                    var icon = {
                        url: marker.getIcon().url,  // Keep the existing marker image
                        scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                        anchor: new google.maps.Point(newSize / 2, newSize / 2), // Adjust anchor to prevent clipping
                    };

                    marker.setIcon(icon);
                };

                // Run updateIconSize once to initialize
                updateIconSize();

                // Listen for zoom changes
                google.maps.event.addListener(locations.map, "zoom_changed", function () {
                    updateIconSize();
                    updateMarkerLabelVisibility()
                });

                google.maps.event.addListener(marker, 'click', function () {
                    if (openedInfoWindow !== null) {
                        openedInfoWindow.close();
                    }
                    var contentString = document.createElement("div"),
                        btnShowImage,
                        btnShowAsset
                    contentString.innerHTML =
                        '<div class="infoWindowhead">' +
                        '<b>ID: ' + asset.id + '</b><br>' +
                        '<b>Name: ' + asset.name + '</b><br>' +
                        '<b>AssetTypeName: ' + asset.assetTypeName + '</b><br>' +
                        '<b>Latitude: ' + coordinates[0].lat + '</b><br>' +
                        '<b>Longitude: ' + coordinates[0].lng + '</b>' +
                        '<button onclick="copyToClipboard(\'' + coordinates[0].lat + ',' + coordinates[0].lng + '\', this)" ' +
                        'style="font-size:10px; padding:2px 5px; margin-left:5px; cursor:pointer;">Copy</button>' +
                        '</div>';

                    infowindow.setContent(contentString);
                    infowindow.open(locations.map, marker);
                    openedInfoWindow = infowindow;
                    if (vm.trRoute.id) {
                        btnShowImage = contentString.appendChild(document.createElement("input"));
                        btnShowImage.type = "button";
                        btnShowImage.value = "Show Media";
                        btnShowImage.className = "button";

                        google.maps.event.addDomListener(btnShowImage, "click", function () {
                            AssetByID.get(asset.id, function (imageResponse) {
                                vm.assetName = asset.name;
                                vm.assetTypeName = asset.assetTypeName
                                vm.assetIdDownload = asset.id;
                                if (imageResponse && imageResponse.assetImages.length) {
                                    var token = $localStorage.authenticationToken;
                                    gpName = imageResponse.name || "Images";
                                    var validTypes = ['.PNG', 'PNG', 'PDF', '.PDF', 'JPEG', '.JPEG', 'JPG', '.JPG', 'MP4', '.MP4'];
                                    var imageMetaList = imageResponse.assetImages.filter(function (img) {
                                        var type = img.imageType ? img.imageType.toUpperCase() : '';
                                        return validTypes.indexOf(type) !== -1;
                                    }).sort(function (a, b) {
                                        return a.createdDate - b.createdDate;
                                    }).map(function (img) {
                                        return {
                                            url: img.imageUrl || ('/api/trakeyeassetimages/' + asset.id + '/' + img.imageId),
                                            type: img.imageType ? img.imageType.toUpperCase() : 'PNG',
                                            createdDate: img.createdDate
                                        };
                                    });
                                    if (imageMetaList.length) {
                                        preloadImagesWithToken(imageMetaList, token);
                                    } else {
                                        alert("No images or PDFs found.");
                                    }
                                } else {
                                    alert("No images or PDFs found.");
                                }
                            });
                        });
                    }
                    if (vm.trRoute.id) {
                        btnShowAsset = contentString.appendChild(
                            document.createElement("input")
                        );
                        btnShowAsset.type = "button";
                        btnShowAsset.value = "Show attributes";
                        btnShowAsset.className = "button";
                        google.maps.event.addDomListener(
                            btnShowAsset,
                            "click",
                            function () {
                                AssetByID.get(asset.id, function (response) {
                                    showAssetAttributesModal(response);
                                });
                            }
                        );
                    }
                });
                $scope.showDropDown = false
            }
        }
        window.copyToClipboard = function (text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(function () {
                }).catch(function (err) {
                    console.error("Clipboard copy failed: ", err);
                });
            } else {
                var tempInput = document.createElement("input");
                tempInput.value = text;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                document.body.removeChild(tempInput);
            }
        };
        var carouselImages = [];
        var currentImageIndex = 0;
        var gpName = 'images';
        function preloadImagesWithToken(imageMetaList, token) {
            var blobUrls = [];
            var remaining = imageMetaList.length;
            var hasError = false;

            for (var i = 0; i < imageMetaList.length; i++) {
                (function (img, index) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', img.url, true);
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        if (xhr.status === 200 && xhr.response) {
                            var metaType = img.type ? img.type.toUpperCase() : '';
                            var type = metaType.includes("PDF") ? "PDF" :
                                metaType.includes("MP4") ? "VIDEO" :
                                    "IMAGE";
                            blobUrls[index] = {
                                url: URL.createObjectURL(xhr.response),
                                type: type
                            };
                        } else {
                            hasError = true;
                        }
                        remaining--;
                        if (remaining === 0) {
                            if (hasError) alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.onerror = function () {
                        hasError = true;
                        remaining--;
                        if (remaining === 0) {
                            alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.send();
                })(imageMetaList[i], i);
            }
        }

        function openCarousel(images) {
            carouselImages = images;
            currentImageIndex = 0;
            document.getElementById("imageCarouselModal").style.display = "flex";
            updateCarouselImage();
            generateThumbnails();
        }

        function updateCarouselImage() {
            var container = document.getElementById("carouselDisplayContainers");
            container.innerHTML = "";
            if (!carouselImages.length || !carouselImages[currentImageIndex]) {
                console.warn("No valid media found at index:", currentImageIndex);
                return;
            }
            var current = carouselImages[currentImageIndex];
            if (current.type === "PDF") {
                var iframe = document.createElement("iframe");
                iframe.src = current.url;
                iframe.className = "carousel-pdf";
                container.appendChild(iframe);
            } else if (current.type === "VIDEO") {
                var video = document.createElement("video");
                video.src = current.url;
                video.controls = true;
                video.autoplay = true;
                video.className = "carousel-video";
                container.appendChild(video);
            } else {
                var img = document.createElement("img");
                img.className = "carousel-image";
                img.src = current.url;
                img.id = "carouselImage";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");
                container.appendChild(img);

                // Zoom + Drag behavior
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform = 'translate(' + imgOffsetX + 'px, ' + imgOffsetY + 'px) scale(' + zoom + ')';
                    img.style.transition = "transform 0.1s ease-out";
                }

                applyTransform();

                container.addEventListener("wheel", function (e) {
                    e.preventDefault();
                    var delta = Math.sign(e.deltaY);
                    var zoomAmount = 0.10;
                    var newZoom = zoom;

                    if (delta < 0) {
                        newZoom = Math.min(maxZoom, zoom + zoomAmount);
                    } else {
                        newZoom = Math.max(minZoom, zoom - zoomAmount);
                    }

                    var scaleFactor = newZoom / zoom;
                    var rect = img.getBoundingClientRect();
                    var mouseX = e.clientX - rect.left;
                    var mouseY = e.clientY - rect.top;

                    if (newZoom === minZoom) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    } else {
                        imgOffsetX -= mouseX * scaleFactor - mouseX;
                        imgOffsetY -= mouseY * scaleFactor - mouseY;
                    }

                    zoom = newZoom;
                    applyTransform();
                });

                var isDragging = false;
                var startCursorX, startCursorY;
                var startImgOffsetX, startImgOffsetY;

                img.addEventListener("mousedown", function (e) {
                    isDragging = true;
                    img.style.cursor = "grabbing";
                    startCursorX = e.clientX;
                    startCursorY = e.clientY;
                    startImgOffsetX = imgOffsetX;
                    startImgOffsetY = imgOffsetY;
                    img.style.transition = "none";
                });

                document.addEventListener("mouseup", function () {
                    isDragging = false;
                    img.style.cursor = "grab";
                });

                document.addEventListener("mousemove", function (e) {
                    if (!isDragging) return;
                    e.preventDefault();
                    var dx = e.clientX - startCursorX;
                    var dy = e.clientY - startCursorY;
                    imgOffsetX = startImgOffsetX + dx;
                    imgOffsetY = startImgOffsetY + dy;
                    applyTransform();
                });
            }
        }

        function generateThumbnails() {
            var container = document.getElementById("carouselThumbnails");
            container.innerHTML = "";

            for (var i = 0; i < carouselImages.length; i++) {
                (function (index) {
                    var current = carouselImages[index];
                    var thumb = document.createElement("img");

                    thumb.src = current.type === "PDF"
                        ? "content/images/pdf_file_icon.png"
                        : current.type === "VIDEO"
                            ? "content/images/video_icon.png"
                            : current.url;
                    thumb.className = "carousel-thumbnail";
                    if (index === currentImageIndex) {
                        thumb.classList.add("selected");
                    }

                    thumb.onclick = function () {
                        currentImageIndex = index;
                        updateCarouselImage();
                        generateThumbnails();
                    };

                    container.appendChild(thumb);
                })(i);
            }
        }

        window.closeCarousel = function () {
            document.getElementById("imageCarouselModal").style.display = "none";
            var container = document.getElementById("carouselDisplayContainers");
            if (container) {
                var video = container.querySelector("video");
                if (video) {
                    video.pause();
                    video.src = "";
                    video.load();
                }
                container.innerHTML = "";
            }
            var thumbContainer = document.getElementsByClassName("carousel-thumbnails");
            if (thumbContainer) {
                thumbContainer.innerHTML = "";
            }
        };

        window.changeImage = function (n) {
            currentImageIndex += n;
            if (currentImageIndex < 0) currentImageIndex = carouselImages.length - 1;
            if (currentImageIndex >= carouselImages.length) currentImageIndex = 0;
            updateCarouselImage();
            generateThumbnails();
        };

        window.downloadCurrentImage = function () {
            var current = carouselImages[currentImageIndex];
            var link = document.createElement('a');
            link.href = current.url;
            var extension = current.type === "PDF" ? ".pdf" :
                current.type === "VIDEO" ? ".mp4" :
                    ".png";
            link.download = gpName + "_gpfile_" + (currentImageIndex + 1) + extension;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        window.downloadAllImages = function () {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/assets/downloadFiles/' + vm.assetIdDownload, true);
            xhr.setRequestHeader('Accept', 'application/zip');
            xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
            xhr.responseType = 'blob';

            xhr.onload = function () {
                if (spinner) {
                    spinner.style.display = "none"; // Show the spinner
                }
                if (xhr.status === 200) {
                    var blob = new Blob([xhr.response], { type: 'application/zip' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = vm.assetName + '.zip';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    alert('Download failed. Status: ' + xhr.status);
                }
            };

            xhr.onerror = function () {
                alert('Request error.');
            };

            xhr.send();
        }
        vm.modalClosing = false;
        $('#imageCarouselModal').on('hide.bs.modal', function () {
            vm.modalClosing = true;
        });
        $('#imageCarouselModal').on('hidden.bs.modal', function () {
            vm.modalClosing = false;
            var container = document.getElementById("carouselDisplayContainers");
            if (container) {
                var video = container.querySelector("video");
                if (video) {
                    video.pause();
                    video.src = "";
                }
                container.innerHTML = "";
            }
        });

        document.addEventListener("keydown", function (e) {
            if (document.getElementById("imageCarouselModal").style.display === "flex") {
                if (e.key === "ArrowRight") changeImage(1);
                if (e.key === "ArrowLeft") changeImage(-1);
                if (e.key === "Escape") closeCarousel();
            }
        });
        function clearMarkersPolyLine() {
            for (var i = 0; i < assetMarker.length; i++) {
                assetMarker[i].setMap(null);
            }
            assetMarker = [];
            for (var k = 0; k < assetPolyline.length; k++) {
                assetPolyline[k].setMap(null);
            }
            assetPolyline = [];
            for (var l = 0; l < spreadPolyline.length; l++) {
                spreadPolyline[l].setMap(null);
            }
            spreadPolyline = [];
        }


        $scope.newTabDisplay = function (id, imageId) {
            var request = new XMLHttpRequest(), apiImage = "api/trakeyeassetimages/";
            request.open(
                "GET",
                apiImage + id + "/" + imageId,
                true
            );
            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                } else {
                    alert("Error loading media: " + request.status);
                }
            }
            request.send();
        };
        function closeAssetAttributesModal() {
            console.log("closed")
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }
        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList = assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";
            var newTable =
                "<table align='center' style='border: 1px solid black; width: 50%;'>" +
                "<tr><th style='border: 1px solid black; text-align: center;'>Attribute</th>" +
                "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";
            var filteredAndSortedList = [];
            for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
                var value = assetTypeAttributeValuesList[i];
                filteredAndSortedList.push(value);
            }

            filteredAndSortedList.sort(function (a, b) {
                return (
                    a.assetTypeAttribute.assetTypeAttribOrder -
                    b.assetTypeAttribute.assetTypeAttribOrder
                );
            });

            for (var j = 0; j < filteredAndSortedList.length; j++) {
                var item = filteredAndSortedList[j];
                newTable +=
                    "<tr><td style='border: 1px solid black; text-align: center;'>" +
                    (item.assetTypeAttribute.name || "N/A") +
                    "</td><td style='border: 1px solid black; text-align: center;'>" +
                    (item.attributeValue || "N/A") +
                    "</td></tr>";
            }

            newTable += "</table>";

            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }
        vm.geofenceCoordinates = [];
        RingGeofence.getGeofence(vm.trRoute.id, function (response) {
            if (Array.isArray(response) && response.length > 0) {
                response.forEach(function (item) {
                    if (item && item.coordinates && typeof item.coordinates === 'string' && item.coordinates.trim() !== "") {
                        try {
                            var coordinates = JSON.parse(item.coordinates);
                            var polygonCoords = coordinates.map(function (coord) {
                                return {
                                    lat: coord.lat,
                                    lng: coord.lng
                                };
                            });
                            var geofencePolygon = new google.maps.Polygon({
                                paths: polygonCoords,
                                strokeColor: "#fd7a24",
                                strokeOpacity: 1,
                                strokeWeight: 1,
                                fillColor: '#fd7a24',
                                fillOpacity: 0.20,
                                clickable: false,
                            });
                            geofencePolygon.setMap(locations.map);
                        } catch (e) {
                            console.error("Error parsing coordinates:", e);
                        }
                    }
                });
            }
        });
        var gpSelected = false;
        vm.highLightedSectionPath = []
        vm.surveyOFCPolylines = [];
        vm.createSection = function () {
            vm.selectedPaths = [];
            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePath = response;
                callRoutePath(vm.routePath.routePoints);
                var bounds = new google.maps.LatLngBounds();
                function callRoutePath(routePaths) {
                    var colors = ['#FD7A24', '#0096FF'];
                    var pathColor = colors[0];
                    var proposedPathColor = colors[1];
                    var groupedRoutePaths = {};
                    routePaths.forEach(function (coord) {
                        if (coord.sessionNumber) {
                            if (!groupedRoutePaths[coord.sessionNumber]) {
                                groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                            }
                            if (coord.routePointType === 'COORDINATE') {
                                if (coord.phase === 'PLANNING') {
                                    groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                                } else if (coord.phase === 'SURVEY') {
                                    groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                                }
                            }
                        }
                    })

                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        var sessionData = groupedRoutePaths[sessionNumber];
                        if (sessionData.proposed.length) {
                            var pathCoordinates = sessionData.proposed.map(function (coord) {
                                var latLng = { lat: coord.latitude, lng: coord.longitude, id: coord.id, routePointNumber: parseFloat(coord.routePointNumber) };
                                return latLng;
                            });
                            pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            vm.sectionCreate.setCenter(pathCoordinates[0])
                            var pathPolyline = new google.maps.Polyline({
                                path: pathCoordinates,
                                geodesic: true,
                                strokeColor: pathColor,
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                zIndex: 1,
                            });
                            pathPolyline.setMap(vm.sectionCreate);
                            vm.surveyOFCPolylines.push(pathPolyline);
                            var polylineInfoWindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(pathPolyline, 'click', function (event) {
                                var contentString = document.createElement("div"),
                                    // btnAddSection,
                                    btnAddPortion
                                contentString.innerHTML = '<div class="infoWindowhead">'
                                "</div>";
                                polylineInfoWindow.setContent(contentString);
                                polylineInfoWindow.setPosition(event.latLng);
                                polylineInfoWindow.open(vm.sectionCreate);
                                openedInfoWindow = polylineInfoWindow;
                                var originalOptions = {
                                    strokeColor: pathPolyline.get("strokeColor"),
                                    strokeWeight: pathPolyline.get("strokeWeight"),
                                    strokeOpacity: pathPolyline.get("strokeOpacity")
                                };
                                pathPolyline.setOptions({
                                    strokeColor: "#A938F3",
                                    strokeWeight: 12,
                                    strokeOpacity: 0.6,
                                });
                                setTimeout(function () {
                                    pathPolyline.setOptions(originalOptions);
                                }, 10000);
                                // if (vm.trRoute.id) {
                                //     btnAddSection = contentString.appendChild(
                                //         document.createElement("input")
                                //     );

                                //     btnAddSection.type = "button";
                                //     btnAddSection.value = "Add to Section";
                                //     btnAddSection.className = "button";
                                //     google.maps.event.addDomListener(
                                //         btnAddSection,
                                //         "click",
                                //         function () {
                                //             vm.selectedPaths.push({
                                //                 id: vm.trRoute.id,
                                //                 name: sessionNumber,
                                //                 phase: vm.trRoute.phase,
                                //                 type: "SPREAD",
                                //                 latlngs: pathCoordinates,
                                //                 uid: sessionNumber
                                //             });
                                //             polylineInfoWindow.close()
                                //         }
                                //     );
                                // }
                                if (vm.trRoute.id) {
                                    btnAddPortion = contentString.appendChild(
                                        document.createElement("input")
                                    );
                                    btnAddPortion.type = "button";
                                    btnAddPortion.value = "draw fence to select path";
                                    btnAddPortion.className = "button";
                                    google.maps.event.addDomListener(
                                        btnAddPortion,
                                        "click",
                                        function () {
                                            polylineInfoWindow.close()
                                            var drawingManager = new google.maps.drawing.DrawingManager({
                                                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                                                drawingControl: false,
                                                polygonOptions: {
                                                    fillColor: "#FD7A24",
                                                    fillOpacity: 0.2,
                                                    strokeWeight: 2,
                                                    clickable: true,
                                                    editable: true,
                                                    zIndex: 1,
                                                },
                                            });
                                            drawingManager.setMap(vm.sectionCreate);

                                            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                                                if (event.type === google.maps.drawing.OverlayType.POLYGON) {

                                                    var polygon = event.overlay;
                                                    var polygonPath = polygon.getPath().getArray();

                                                    Object.keys(groupedRoutePaths).forEach(function (sessionNumberTemp) {
                                                        var sessionDataTemp = groupedRoutePaths[sessionNumberTemp];
                                                        if (sessionDataTemp.proposed.length) {
                                                            var pathCoordinatesTemp = sessionDataTemp.proposed.map(function (coord) {
                                                                var latLng = { lat: coord.latitude, lng: coord.longitude, id: coord.id, routePointNumber: parseFloat(coord.routePointNumber) };
                                                                return latLng;
                                                            });
                                                            pathCoordinatesTemp.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                                                            for (var i = 0; i < pathCoordinatesTemp.length - 1; i++) {
                                                                var p1 = pathCoordinatesTemp[i];
                                                                var p2 = pathCoordinatesTemp[i + 1];
                                                                for (var j = 0; j < polygonPath.length; j++) {
                                                                    var p3 = toPlainCoord(polygonPath[j]);
                                                                    var p4 = toPlainCoord(polygonPath[(j + 1) % polygonPath.length]);
                                                                    var inter = getLineIntersection(p1, p2, p3, p4);
                                                                    if (inter) {
                                                                        vm.fromToIntersectingPoints.push(inter);
                                                                    }
                                                                }
                                                            }

                                                            var highlightedPath = [];
                                                            pathCoordinatesTemp.forEach(function (point) {
                                                                var latLng = new google.maps.LatLng(point.lat, point.lng);
                                                                if (google.maps.geometry.poly.containsLocation(latLng, polygon)) {
                                                                    highlightedPath.push(latLng);
                                                                }
                                                            });

                                                            if (highlightedPath.length > 1) {
                                                                var highlightPolyline = new google.maps.Polyline({
                                                                    path: highlightedPath,
                                                                    geodesic: true,
                                                                    strokeColor: "#0096FF",
                                                                    strokeOpacity: 0.8,
                                                                    strokeWeight: 6,
                                                                    zIndex: 10,
                                                                });
                                                                highlightPolyline.setMap(vm.sectionCreate);
                                                                vm.highLightedSectionPath.push(highlightPolyline)
                                                            }
                                                        }
                                                    });


                                                    var newPath = {
                                                        id: vm.trRoute.id,
                                                        name: sessionNumber,
                                                        phase: vm.trRoute.phase,
                                                        type: "POLYGON",
                                                        latlngs: polygonPath,
                                                        uid: sessionNumber
                                                    };

                                                    if (!isDuplicatePath(newPath)) {
                                                        vm.selectedPaths.push(newPath);
                                                    }

                                                    polygon.setMap(null);
                                                    drawingManager.setDrawingMode(null);
                                                    drawingManager.setMap(null);
                                                }
                                            });
                                        }
                                    );
                                }
                            });
                        }
                    });
                    vm.newOFCPolylines = [];
                    vm.existingOFCPolylines = [];
                    vm.unusedOFCPolylines = [];
                    vm.assets.forEach(function (asset) {
                        var coordinates = asset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        if (asset.assetTypeLayout === 'SPREAD') {
                            var polylineColor = "";
                            polylineColor = "#ff0025";
                            if (!asset.isExisting) {
                                polylineColor = "#00A36C"; //tmpColor = "blue";
                            }
                            if (!asset.isUsed && asset.isExisting) {
                                polylineColor = "#FFAE42";
                            }
                            var drawPolyline = new google.maps.Polyline({
                                path: coordinates,
                                geodesic: true,
                                strokeColor: polylineColor,
                                strokeOpacity: 0.9,
                                strokeWeight: 3,
                                zIndex: 1
                            });
                            drawPolyline.setMap(vm.sectionCreate);
                            if (!asset.isExisting) {
                                vm.newOFCPolylines.push(drawPolyline);
                            } else if (!asset.isUsed && asset.isExisting) {
                                vm.unusedOFCPolylines.push(drawPolyline);
                            } else {
                                vm.existingOFCPolylines.push(drawPolyline);
                            }
                        }
                    });
                }
                vm.gpAssets.forEach(function (asset) {
                    var coordinates = asset.assetCoordinates.map(function (coord) {
                        return { lat: coord.latitude, lng: coord.longitude, id: coord.id, sortOrder: coord.sortOrder };
                    });
                    if (asset.assetTypeLayout === 'FIXED') {
                        vm.sectionCreate.setCenter(coordinates[0])
                        var marker = new google.maps.Marker({
                            position: coordinates[0],
                            map: vm.sectionCreate,
                            title: asset.name,
                            icon: {
                                url: asset.assetTypeImagePath,
                                scaledSize: new google.maps.Size(32, 32)
                            }
                        });
                        var infowindow = new google.maps.InfoWindow();
                        var updateIconSize = function () {
                            var zoom = locations.map.getZoom();
                            var minZoom = 8;
                            var maxZoom = 21;
                            var minSize = 6;
                            var maxSize = 60;
                            var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);
                            var icon = {
                                url: marker.getIcon().url,
                                scaledSize: new google.maps.Size(newSize, newSize),
                                anchor: new google.maps.Point(newSize / 2, newSize),
                            };

                            marker.setIcon(icon);
                        };
                        updateIconSize();
                        google.maps.event.addListener(locations.map, "zoom_changed", function () {
                            updateIconSize();
                        });

                        google.maps.event.addListener(marker, 'click', function () {
                            if (openedInfoWindow !== null) {
                                openedInfoWindow.close();
                            }
                            var contentString = document.createElement("div"),
                                btnAddSection
                            contentString.innerHTML = '<div class="infoWindowhead">' +
                                "<b>ID: " + asset.id + "</b><br>" +
                                "<b>Name: " + asset.name + "</b><br>" +
                                "<b>AssetTypeName: " + asset.assetTypeName + "</b><br>" +
                                "<b>Latitude: " + coordinates[0].lat + "</b><br>" +
                                "<b>Longitude: " + coordinates[0].lng + "</b><br>" +
                                "</div>";
                            infowindow.setContent(contentString);
                            infowindow.open(vm.sectionCreate, marker);
                            openedInfoWindow = infowindow;
                            if (vm.trRoute.id) {
                                btnAddSection = contentString.appendChild(
                                    document.createElement("input")
                                );
                                btnAddSection.type = "button";
                                btnAddSection.value = "Add to section";
                                btnAddSection.className = "button";
                                google.maps.event.addDomListener(
                                    btnAddSection,
                                    "click",
                                    function () {
                                        vm.selectedPaths.push({
                                            id: vm.trRoute.id,
                                            name: asset.name,
                                            type: asset.assetTypeLayout,
                                            phase: vm.trRoute.phase,
                                            latlngs: coordinates
                                        });
                                        gpSelected = true
                                        openedInfoWindow.close();
                                    }
                                );
                            }
                        });
                    }
                });
                var searchInput = document.createElement("input");
                searchInput.type = "text";
                searchInput.placeholder = "Search asset...";
                searchInput.style.position = "absolute";
                searchInput.style.top = "10px";
                searchInput.style.left = "50%";
                searchInput.style.transform = "translateX(-50%)";
                searchInput.style.zIndex = "5";
                searchInput.style.padding = "5px";
                searchInput.style.border = "1px solid #ccc";
                searchInput.style.borderRadius = "4px";
                document.getElementById("create_section_map").appendChild(searchInput);
                searchInput.addEventListener("input", function () {
                    var searchTerm = searchInput.value.toLowerCase();
                    var foundAsset = null;
                    vm.gpAssets.forEach(function (asset) {
                        if (asset.name.toLowerCase().includes(searchTerm)) {
                            foundAsset = asset;
                        }
                    });
                    if (foundAsset) {
                        var coordinates = foundAsset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        if (coordinates.length > 0) {
                            vm.sectionCreate.setCenter(coordinates[0]);
                            vm.sectionCreate.setZoom(15);
                        }
                    }
                });
            });
        }
        vm.ofcFilterOptions = [
            { name: "New OFC", value: "new", selected: true },
            { name: "Existing OFC", value: "existing", selected: true },
            { name: "Unused OFC", value: "Unused", selected: true },
            { name: "Survey Route", value: "survey", selected: true }
        ];
        vm.selectedOFCFilters = angular.copy(vm.ofcFilterOptions);
        vm.applyOFCFilter = function () {
            vm.newOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.existingOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.unusedOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.surveyOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.selectedOFCFilters.forEach(function (filter) {
                if (filter.selected) {
                    if (filter.value === "new") {
                        vm.newOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }
                    if (filter.value === "existing") {
                        vm.existingOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }
                    if (filter.value === "Unused") {
                        vm.unusedOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }
                    if (filter.value === "survey") {
                        vm.surveyOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }

                }
            });
        };

        setTimeout(function () {
            vm.sectionCreate = new google.maps.Map(
                document.getElementById("create_section_map"),
                {
                    zoom: $rootScope.rolloutMapInitZoom || 10,
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    }
                }
            );
        }, 500);


        function toLatLng(coord) {
            return (coord instanceof google.maps.LatLng) ? coord : new google.maps.LatLng(coord.lat, coord.lng);
        }

        function toPlainCoord(latLng) {
            return { lat: latLng.lat(), lng: latLng.lng() };
        }

        function getLineIntersection(p1, p2, p3, p4) {
            p1 = toLatLng(p1); p2 = toLatLng(p2);
            p3 = toLatLng(p3); p4 = toLatLng(p4);
            var x1 = p1.lng(), y1 = p1.lat();
            var x2 = p2.lng(), y2 = p2.lat();
            var x3 = p3.lng(), y3 = p3.lat();
            var x4 = p4.lng(), y4 = p4.lat();

            var denom = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
            if (denom === 0) return null;

            var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denom;
            var u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denom;

            if (t >= 0 && t <= 1 && u >= 0 && u <= 1) {
                return {
                    lat: y1 + t * (y2 - y1),
                    lng: x1 + t * (x2 - x1)
                };
            }
            return null;
        }

        function findClosestCoord(target, coords) {
            var minDist = Infinity, closest = null;
            var targetLatLng = toLatLng(target);
            for (var i = 0; i < coords.length; i++) {
                var current = toLatLng(coords[i]);
                var dist = google.maps.geometry.spherical.computeDistanceBetween(targetLatLng, current);
                if (dist < minDist) {
                    minDist = dist;
                    closest = coords[i];
                }
            }
            return closest;
        }

        function enrichWithMeta(interPoint, originalCoords) {
            var closest = findClosestCoord(interPoint, originalCoords);
            return {
                lat: interPoint.lat,
                lng: interPoint.lng,
                id: closest.id || null,
                routePointNumber: closest.routePointNumber || null
            };
        }

        function areCoordsSame(p1, p2) {
            return (
                toLatLng(p1).lat().toFixed(7) === toLatLng(p2).lat().toFixed(7) &&
                toLatLng(p1).lng().toFixed(7) === toLatLng(p2).lng().toFixed(7)
            );
        }

        function isDuplicatePath(newPathObj) {
            return vm.selectedPaths.some(function (existingPath) {
                if (existingPath.id !== newPathObj.id) return false;
                var a = existingPath.latlngs, b = newPathObj.latlngs;
                if (a.length !== b.length) return false;
                for (var i = 0; i < a.length; i++) {
                    if (!areCoordsSame(a[i], b[i])) return false;
                }
                return true;
            });
        }

        function sectionSave() {
            var fixedAssets = vm.selectedPaths.filter(function (item) {
                return item.type === "FIXED" && item.name && item.name.trim() !== "";
            });
            if (fixedAssets.length < 2) {
                alert("Both FROM and TO fixed assets must be selected before saving.");
                return;
            }
            var fixedFrom = fixedAssets[0];
            var fixedTo = fixedAssets[1];
            if (fixedFrom.name === fixedTo.name) {
                vm.selectedPaths = []
                for (var i = 0; i < vm.highLightedSectionPath.length; i++) {
                    vm.highLightedSectionPath[i].setMap(null)
                    vm.highLightedSectionPath = []
                }
                alert("FROM and TO assets are the same. Please select different assets.");
                return;
            }
            if (vm.fromToIntersectingPoints.length > 1) {
                vm.selectedPaths.push({
                    id: vm.trRoute.id,
                    name: "from",
                    phase: vm.trRoute.phase,
                    type: "FROM",
                    latlngs: [{ lat: vm.fromToIntersectingPoints[0].lat, lng: vm.fromToIntersectingPoints[0].lng }],
                    uid: "from"
                });

                vm.selectedPaths.push({
                    id: vm.trRoute.id,
                    name: "to",
                    phase: vm.trRoute.phase,
                    type: "TO",
                    latlngs: [{ lat: vm.fromToIntersectingPoints[1].lat, lng: vm.fromToIntersectingPoints[1].lng }],
                    uid: "to"
                });
                SectionSelect.create(vm.selectedPaths, function (response) {
                    if (response) {
                        vm.selectedPaths = [];
                        vm.fromToIntersectingPoints = [];
                        for (var i = 0; i < vm.highLightedSectionPath.length; i++) {
                            vm.highLightedSectionPath[i].setMap(null)
                            vm.highLightedSectionPath = []
                        }
                        alert("Section '" + response.name + "' is created successfully");
                    }
                });
            } else {
                vm.fromToIntersectingPoints = [];
                SectionSelect.create(vm.selectedPaths, function (response) {
                    if (response) {
                        vm.selectedPaths = [];
                        vm.fromToIntersectingPoints = [];
                        for (var i = 0; i < vm.highLightedSectionPath.length; i++) {
                            vm.highLightedSectionPath[i].setMap(null)
                            vm.highLightedSectionPath = []
                        }
                        alert("Section '" + response.name + "' is created successfully");
                    }
                });
            }

        }
        vm.downloadProjectSurveyExcel = function (canAggregate) {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/route-survey-reportv1/" + vm.trRoute.id + "/" + vm.trRoute.phase + "/" + canAggregate;
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';
                request.onload = function (e) {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'report.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'Rings - ' + vm.trRoute.name + '.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    } else {
                        alert("No data found");
                    }
                };

                request.send();
            });
        }
        geoLocation(locations.map);
        vm.gpAssetsVisible = true;
        vm.gpAssetMarkers = [];
        vm.planpathPolyline = [];
        vm.planpathPolylineVisible = true;
        vm.routeMarkerssurveyVisible = true;
        vm.routeMarkerssurveyMap = [];
        vm.editSurveyPath = function (coordsurvey) {
            vm.updatedSurveyPath = [];
            vm.editSurveyMap = new google.maps.Map(
                document.getElementById("map_canvas_edit_survey_path"),
                {
                    zoom: $rootScope.rolloutMapInitZoom || 10,
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    }
                }
            );

            var legend = document.createElement("div");
            legend.id = "map-legend";
            legend.style.position = "absolute";
            legend.style.background = "#f3f3f3";
            legend.style.padding = "4px";
            legend.style.border = "1px solid rgb(204, 204, 204)";
            legend.style.fontFamily = "Arial, sans-serif";
            legend.style.borderRadius = "5px";
            legend.style.boxShadow = "1px 1px 1px 0px";
            legend.style.color = "black";

            legend.innerHTML =
                '<div style="display: flex; align-items: center;">' +
                '<div style="display: flex; align-items: center; margin-right: 15px;">' +
                '<div style="width: 12px; height: 12px; background: #FD7A24; margin-right: 5px;"></div>' +
                '<span>PLANNED</span>' +
                '</div>' +
                '<div style="display: flex; align-items: center;">' +
                '<div style="width: 12px; height: 12px; background: #0096FF; margin-right: 5px;"></div>' +
                '<span>SURVEY</span>' +
                '</div>' +
                '</div>';

            vm.editSurveyMap.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(legend);
            var center = vm.editSurveyMap.getCenter();
            imageRoutePoint.postCenterLatLng(vm.trRoute.id, { lat: center.lat(), lng: center.lng() }, function (data) {
                if (data && data.length) {
                    for (var i = 0; i < vm.routeMarkerssurveyMap.length; i++) {
                        vm.routeMarkerssurveyMap[i].setMap(null);
                    }
                    vm.routeMarkerssurveyMap = [];
                    var markerImage, iconImg
                    var iconSize = 20
                    var iconMarker = "content/images/sm_marker_transparent.png"
                    var iconImage = "content/images/routePointImage.png"
                    data.forEach(function (each) {
                        iconImg = (each.imageAttached) ? iconImage : iconMarker
                        markerImage = new google.maps.Marker({
                            position: { lat: each.latitude, lng: each.longitude },
                            map: vm.editSurveyMap,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: iconImg,
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    iconSize / 2
                                ),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                        vm.routeMarkerssurveyMap.push(markerImage);
                    });
                }
            });

            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePathforSurevey = response;
                callRoutePath(vm.routePathforSurevey.routePoints);
                var bounds = new google.maps.LatLngBounds();

                vm.gpAssets.forEach(function (asset) {
                    var coordinates = [];
                    for (var i = 0; i < asset.assetCoordinates.length; i++) {
                        var coord = asset.assetCoordinates[i];
                        coordinates.push({
                            lat: coord.latitude,
                            lng: coord.longitude,
                            id: coord.id,
                            sortOrder: coord.sortOrder
                        });
                    }

                    if (asset.assetTypeLayout === 'FIXED') {
                        var marker = new google.maps.Marker({
                            map: vm.editSurveyMap,
                            position: coordinates[0],
                            title: asset.name,
                            icon: {
                                scaledSize: new google.maps.Size(24, 24),
                                url: asset.assetTypeImagePath,
                                anchor: new google.maps.Point(12, 24),
                                labelOrigin: new google.maps.Point(25, 22)
                            }
                        });
                        vm.gpAssetMarkers.push(marker)
                        // Define marker label visibility function
                        var updateMarkerLabelVisibility = function () {
                            var currentZoom = vm.editSurveyMap.getZoom();
                            if (currentZoom > 17) {
                                marker.setLabel({
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    text: asset.name,
                                    className: "asset_label top-label"
                                });
                            } else {
                                marker.setLabel(null);
                            }
                        };

                        // Inject CSS for label only once
                        if (!document.getElementById('top-label-style')) {
                            var style = document.createElement('style');
                            style.id = 'top-label-style';
                            style.innerHTML = '.top-label {' +
                                'position: relative;' +
                                'top: 30px;' +
                                'left: 0;' +
                                'transform: translateX(10%);' +
                                'white-space: nowrap;' +
                                '}';
                            document.head.appendChild(style);
                        }

                        var infowindow = new google.maps.InfoWindow();
                        var updateIconSize = function () {
                            var zoom = vm.editSurveyMap.getZoom();
                            var minZoom = 8;
                            var maxZoom = 21;
                            var minSize = 6;
                            var maxSize = 60;
                            var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);
                            var icon = {
                                url: marker.getIcon().url,
                                scaledSize: new google.maps.Size(newSize, newSize),
                                anchor: new google.maps.Point(newSize / 2, newSize),
                            };

                            marker.setIcon(icon);
                        };
                        updateIconSize();
                        google.maps.event.addListener(vm.editSurveyMap, "zoom_changed", function () {
                            updateIconSize();
                        });
                    }
                });

                function callRoutePath(routePaths) {
                    var colors = ['#FD7A24', '#0096FF'];
                    var pathColor = colors[0];
                    var proposedPathColor = colors[1];
                    var groupedRoutePaths = {};
                    routePaths.forEach(function (coord) {
                        if (coord.sessionNumber) {
                            if (!groupedRoutePaths[coord.sessionNumber]) {
                                groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                            }
                            if (coord.routePointType === 'COORDINATE') {
                                if (coord.phase === 'PLANNING') {
                                    groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                                } else if (coord.phase === 'SURVEY') {
                                    groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                                }
                            }
                        }
                    })
                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        var sessionData = groupedRoutePaths[sessionNumber];
                        if (sessionData.proposed.length) {
                            var pathCoordinates = sessionData.proposed.map(function (coord) {
                                return {
                                    lat: coord.latitude,
                                    lng: coord.longitude,
                                    id: coord.id,
                                    sessionNumber: coord.sessionNumber,
                                    routeId: coord.routeId,
                                    routePointNumber: parseFloat(coord.routePointNumber)
                                };
                            });

                            pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            var isEditable = (sessionNumber === coordsurvey[0].sessionNumber);
                            var googlePath = new google.maps.MVCArray();
                            var pathMetaMap = new Map();
                            pathCoordinates.forEach(function (coord, index) {
                                var latLng = new google.maps.LatLng(coord.lat, coord.lng);
                                googlePath.push(latLng);
                                pathMetaMap.set(index, {
                                    id: coord.id,
                                    sessionNumber: coord.sessionNumber,
                                    routeId: coord.routeId
                                });
                            });

                            var pathPolyline = new google.maps.Polyline({
                                path: googlePath,
                                geodesic: true,
                                strokeColor: proposedPathColor,
                                strokeWeight: isEditable ? 6 : 4,
                                zIndex: isEditable ? 2 : 1,
                                editable: isEditable
                            });
                            pathPolyline.setMap(vm.editSurveyMap);

                            if (isEditable) {
                                google.maps.event.addListener(pathPolyline.getPath(), "insert_at", function () {
                                    updateSurveyCoordinates(pathPolyline, sessionNumber, pathMetaMap);
                                    snapEndsToNearest(pathPolyline, sessionNumber);
                                });

                                google.maps.event.addListener(pathPolyline.getPath(), "set_at", function () {
                                    updateSurveyCoordinates(pathPolyline, sessionNumber, pathMetaMap);
                                    snapEndsToNearest(pathPolyline, sessionNumber);
                                });
                                vm.editSurveyMap.setCenter(vm.SuveryMapCenter);
                            }
                        }

                        if (sessionData.planned.length) {
                            var pathCoordinatesplan = sessionData.planned.map(function (coord) {
                                return {
                                    lat: coord.latitude,
                                    lng: coord.longitude,
                                    id: coord.id,
                                    sessionNumber: coord.sessionNumber,
                                    routeId: coord.routeId,
                                    routePointNumber: parseFloat(coord.routePointNumber)
                                };
                            });

                            pathCoordinatesplan.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            var Path = new google.maps.MVCArray();
                            pathCoordinatesplan.forEach(function (coord) {
                                var latLng = new google.maps.LatLng(coord.lat, coord.lng);
                                Path.push(latLng);
                            });

                            var planpathPolyline = new google.maps.Polyline({
                                path: Path,
                                geodesic: true,
                                strokeColor: pathColor,
                                strokeWeight: 4,
                                zIndex: 1,

                            });
                            planpathPolyline.setMap(vm.editSurveyMap);
                            vm.planpathPolyline.push(planpathPolyline);
                        }
                    });
                }

            });
            var ele = document.getElementById("editSurveyPath");
            $(ele).modal("show");
            $("#editSurveyPath").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_survey_path").css("width", "100%");

        }
        var isSnapping = false
        function snapEndsToNearest(pathPolyline, sessionNumber) {
            var path = pathPolyline.getPath();
            if (path.getLength() > 1) {
                if (isSnapping) return;
                isSnapping = true;
                var firstCoord = { lat: path.getAt(0).lat(), lng: path.getAt(0).lng() };
                var lastCoord = { lat: path.getAt(path.getLength() - 1).lat(), lng: path.getAt(path.getLength() - 1).lng() };

                var minFirstDist = 5; // meters
                var minLastDist = 5;  // meters
                var nearestFirst = null;
                var nearestLast = null;

                vm.routePathforSurevey.routePoints.forEach(function (coord) {
                    if (coord.sessionNumber !== sessionNumber &&
                        coord.routePointType === "COORDINATE" &&
                        coord.phase == "SURVEY") {
                        var mappedLat = coord.latitude;
                        var mappedLon = coord.longitude;

                        var distToFirst = getDistanceMeters(firstCoord.lat, firstCoord.lng, mappedLat, mappedLon);
                        if (distToFirst <= minFirstDist) {
                            minFirstDist = distToFirst;
                            nearestFirst = { lat: mappedLat, lng: mappedLon };
                        }

                        var distToLast = getDistanceMeters(lastCoord.lat, lastCoord.lng, mappedLat, mappedLon);
                        if (distToLast <= minLastDist) {
                            minLastDist = distToLast;
                            nearestLast = { lat: mappedLat, lng: mappedLon };
                        }
                    }
                });

                if (nearestFirst) {
                    path.setAt(0, new google.maps.LatLng(nearestFirst.lat, nearestFirst.lng));
                }
                if (nearestLast) {
                    path.setAt(path.getLength() - 1, new google.maps.LatLng(nearestLast.lat, nearestLast.lng));
                }

                isSnapping = false;
            }
        }

        function getDistanceMeters(lat1, lon1, lat2, lon2) {
            var R = 6371000; // Radius of Earth in meters
            var dLat = (lat2 - lat1) * Math.PI / 180;
            var dLon = (lon2 - lon1) * Math.PI / 180;
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        }


        vm.updatePlanedPathVisibilitysuveyEdit = function () {
            vm.gpAssetsVisible = !vm.gpAssetsVisible;
            if (vm.gpAssetMarkers && vm.gpAssetMarkers.length) {
                for (var i = 0; i < vm.gpAssetMarkers.length; i++) {
                    vm.gpAssetMarkers[i].setMap(vm.gpAssetsVisible ? vm.editSurveyMap : null);
                }
            }
        };
        vm.updateMarkerVisibilitySurveyEdit = function () {
            vm.planpathPolylineVisible = !vm.planpathPolylineVisible;
            if (vm.planpathPolyline && vm.planpathPolyline.length) {
                for (var i = 0; i < vm.planpathPolyline.length; i++) {
                    vm.planpathPolyline[i].setMap(vm.planpathPolylineVisible ? vm.editSurveyMap : null);
                }
            }
        };
        function hideSuveryEditModal() {
            $("#editSurveyPath").removeClass("in");
            $(".modal-backdrop").remove();
            $("#editSurveyPath").hide();
        }

        function updateSurveyCoordinates(polyline, sessionNumber, pathMetaMap) {
            var path = polyline.getPath();
            var newCoordinates = [];
            vm.updatedSurveyPath = [];

            for (var i = 0; i < path.getLength(); i++) {
                var latLng = path.getAt(i);
                var meta = pathMetaMap.get(i) || {
                    id: null,
                    sessionNumber: sessionNumber,
                    routeId: vm.trRoute.id
                };

                var isValidId = (typeof meta.id === 'number' && meta.id > 0);

                newCoordinates.push({
                    latitude: latLng.lat(),
                    longitude: latLng.lng(),
                    id: isValidId ? meta.id : null,
                    sessionNumber: meta.sessionNumber || sessionNumber,
                    routeId: meta.routeId || vm.trRoute.id,
                    routePointNumber: i + 1.0,
                    routePointType: "COORDINATE"
                });
            }

            vm.updatedSurveyPath = newCoordinates;
        }
        vm.saveEditSurveyPath = function () {
            if (vm.updatedSurveyPath != null && vm.updatedSurveyPath.length > 0) {
                routeDetail.saveEditedRoutepoints(vm.updatedSurveyPath, function (response) {
                    if (response.status == '201 OK') {
                        alert("Survey path updated sucessful.");
                        hideSuveryEditModal();
                        if (!(vm.drawMarkers != null && vm.drawingPolyline != null)) {
                            window.location.reload();
                        }
                    } else {
                        alert("Something went wrong!.");
                    }
                });
            }
            if (vm.drawMarkers != null && vm.drawingPolyline != null) {
                vm.createSurveyPath();
            }


        }

        vm.drawSurveyPath = function () {
            vm.drawingPolyline = new google.maps.Polyline({
                map: vm.editSurveyMap,
                path: [],
                strokeColor: '#007bff',
                strokeOpacity: 1.0,
                strokeWeight: 3,
                editable: true
            });

            vm.drawCoordinates = [];
            vm.drawMarkers = [];
            vm.drawingListeners = [];

            var path = vm.drawingPolyline.getPath();

            function addDrawMarker(latLng) {
                var index = vm.drawCoordinates.length + 1;
                vm.drawCoordinates.push({ lat: latLng.lat(), lng: latLng.lng() });
                path.push(latLng);

                var marker = new google.maps.Marker({
                    position: latLng,
                    map: vm.editSurveyMap,
                    clickable: false,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 6,
                        fillColor: "#ff0000",
                        fillOpacity: 1,
                        strokeWeight: 1,
                        strokeColor: "#fff"
                    },
                    label: {
                        text: index.toString(),
                        color: "#000",
                        fontSize: "10px",
                        fontWeight: "bold"
                    }
                });

                vm.drawMarkers.push(marker);

            }

            var mapClickListener = google.maps.event.addListener(vm.editSurveyMap, 'click', function (e) {
                addDrawMarker(e.latLng);
            });
            vm.drawingListeners.push(mapClickListener);

            alert("Drawing tool activated! Click to add points, click the last marker to finish.");
        };

        vm.stopDrawingPolyline = function () {
            vm.drawingListeners.forEach(function (listener) {
                google.maps.event.removeListener(listener);
            });
            vm.drawingListeners = [];

            if (vm.drawingPolyline) {
                vm.drawingPolyline.setEditable(true);
            }
        };
        vm.toggleDrawingPath = function () {
            if (!vm.drawingPolyline) {
                vm.drawSurveyPath();
            } else {
                vm.stopDrawingPolyline();
            }
        };

        vm.stopDrawingPolyline = function () {
            vm.drawingListeners.forEach(function (listener) {
                google.maps.event.removeListener(listener);
            });
            vm.drawingListeners = [];

            if (vm.drawingPolyline) {
                vm.drawingPolyline.setEditable(true);
            }
        };

        vm.undoLastPoint = function () {
            if (vm.drawCoordinates.length > 0) {
                vm.drawCoordinates.pop();

                if (vm.drawingPolyline) {
                    var path = vm.drawingPolyline.getPath();
                    path.pop();
                }

                var marker = vm.drawMarkers.pop();
                if (marker) {
                    marker.setMap(null);
                }
            }
        };

        vm.resetDrawing = function () {
            vm.stopDrawingPolyline();

            vm.drawMarkers.forEach(function (marker) {
                marker.setMap(null);
            });
            vm.drawMarkers = [];

            vm.drawCoordinates = [];

            if (vm.drawingPolyline) {
                vm.drawingPolyline.setMap(null);
                vm.drawingPolyline = null;
            }
        };

        vm.createSurveyPath = function () {
            var markerFormattedPath = vm.drawMarkers.map(function (marker, i) {
                var latLng = marker.getPosition();
                return {
                    latitude: latLng.lat(),
                    longitude: latLng.lng(),
                    id: null,
                    sessionNumber: generateUUID(),
                    routeId: vm.trRoute.id,
                    routePointNumber: i + 1.0,
                    routePointType: "MARKER",
                    // lhsOffset: 3,
                    // rhsOffset: 3,
                    // rodometerLength: 3,
                    // roadWidth: 3,
                    //  distance: 0,
                    //  landMark: "",
                    phase: "SURVEY"
                };
            });

            var pathCoords = vm.drawingPolyline.getPath().getArray().map(function (latLng) {
                return {
                    lat: latLng.lat(),
                    lng: latLng.lng()
                };
            });
            var sessionNumber = generateUUID();
            var formattedPath = pathCoords.map(function (coord, i) {
                return {
                    latitude: coord.lat,
                    longitude: coord.lng,
                    id: null,
                    sessionNumber: sessionNumber,
                    routeId: vm.trRoute.id,
                    routePointNumber: i + 1.0,
                    routePointType: "COORDINATE",
                    phase: "SURVEY"
                };
            });
            var combinedPath = markerFormattedPath.concat(formattedPath);
            routeDetail.saveBulkRoutePoints(combinedPath, function (response) {
                if (response != null) {
                    vm.routePointData = [];
                    vm.resetDrawing();
                    var routeMarkerData = [];
                    var routesurveypathData = [];
                    vm.routePointData = response;
                    vm.routePointData.forEach(function (route) {
                        if (route.routePointType == "COORDINATE") {
                            routesurveypathData.push(route);
                        } else {
                            routeMarkerData.push(route);
                        }
                    });
                    //callRouteImage(routeMarkerData,vm.editSurveyMap);
                    routesurveypathData.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    var newSurevyPath = [];
                    routesurveypathData.forEach(function (coord) {
                        var latLng = new google.maps.LatLng(coord.latitude, coord.longitude);
                        newSurevyPath.push(latLng);
                    });

                    var pathPolyline = new google.maps.Polyline({
                        path: newSurevyPath,
                        geodesic: true,
                        strokeColor: '#0096FF',
                        strokeWeight: 4,
                        zIndex: 1,
                    });
                    pathPolyline.setMap(vm.editSurveyMap);
                    Trmarkers = [];
                    addClick(pathPolyline);
                    $('#confirmModal').modal('show');
                    vm.combinedPathToSave = combinedPath;
                }
            });

        }

        function addClick(item) {
            item.addListener("click", function (event) {
                if (Trmarkers.length < 2) {
                    addMarker(event.latLng);
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }
        function addMarker(location) {
            var markerText
            if (Trmarkers.length == 0) {
                markerText = labelFrom
            } else if (Trmarkers.length == 1) {
                markerText = labelTo;
                $('#terrainRow').modal('show');
            }

            var marker = new google.maps.Marker({
                position: location,
                map: vm.editSurveyMap,
                label: {
                    text: markerText,
                }
            });
            Trmarkers.push(marker);
        }

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now();
            }

            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

        vm.createTerrainRow = function () {
            $('#confirmModal').modal('hide');
            Trmarkers = [];
            alert("please select from and to point to create terrain and row");
        }

        vm.saveTerrainRow = function () {
            vm.trTerrain = vm.trTerrain || {};
            vm.trTerrain.terrainType = vm.terrainType;
            vm.trTerrain.phase = "SURVEY";
            vm.trTerrain.routeId = vm.trRoute.id;
            vm.trTerrain.name = vm.terrainType.name + "_0";

            vm.trRow = vm.trRow || {};
            vm.trRow.rowType = vm.rowType;
            vm.trRow.phase = "SURVEY";
            vm.trRow.routeId = vm.trRoute.id;
            vm.trRow.name = vm.rowType.name + "_0";
            if (Trmarkers.length === 2) {
                Trmarkers.forEach(function (item) {
                    if (item.label.text === labelFrom) {
                        vm.trTerrain.fromRoutePoint = {
                            latitude: item.position.lat(),
                            longitude: item.position.lng()
                        };
                        vm.trRow.fromRoutePoint = angular.copy(vm.trTerrain.fromRoutePoint);
                    }
                    if (item.label.text === labelTo) {
                        vm.trTerrain.toRoutePoint = {
                            latitude: item.position.lat(),
                            longitude: item.position.lng()
                        };
                        vm.trRow.toRoutePoint = angular.copy(vm.trTerrain.toRoutePoint);
                    }
                });

                var terrainSaved = false;
                var rowSaved = false;
                var terrainPathDrawn = false;
                var terraintWithRoutePoints = {
                    terrainDTO: vm.trTerrain,
                    routePoints: vm.routePointData
                }
                AllTerrainTypes.saveTerrainWithRoutepoints(terraintWithRoutePoints, function (response) {
                    terrainSaved = true;

                    routeDetail.getTerrainPathByTerrainId(response.id, function (terrainPath) {
                        var terrrainCoords = terrainPath.COORDINATE;
                        var newterrainPath = [];

                        if (terrrainCoords.length > 2) {

                            terrrainCoords.sort(function (a, b) {
                                return a.routePointNumber - b.routePointNumber;
                            });

                            terrrainCoords.forEach(function (coord) {
                                var latLng = new google.maps.LatLng(coord.latitude, coord.longitude);
                                newterrainPath.push(latLng);
                            });

                            var pathterrain = new google.maps.Polyline({
                                path: newterrainPath,
                                geodesic: true,
                                strokeColor: 'red',
                                strokeWeight: 9,
                                zIndex: 1
                            });

                            pathterrain.setMap(vm.editSurveyMap);
                        }

                        terrainPathDrawn = true;
                        checkSaveCompletion();
                    });
                });
                var rowWithRoutePoints = {
                    rowDTO: vm.trRow,
                    routePoints: vm.routePointData
                }
                AllTerrainTypes.saveRowWithRoutepoints(rowWithRoutePoints, function (rowResponse) {
                    rowSaved = true;
                    checkSaveCompletion();
                });

                function checkSaveCompletion() {
                    if (terrainSaved && rowSaved && terrainPathDrawn) {
                        for (var i = 0; i < Trmarkers.length; i++) {
                            Trmarkers[i].setMap(null);
                        }
                        Trmarkers = [];
                        vm.trTerrain = {};
                        vm.trRow = {};

                        $('#terrainRow').modal('hide');
                        $('#confirmModal').modal('show');
                    }
                }
            } else {
                vm.infoMessage = "Please select both From and To points to create Terrain and ROW.";
                $timeout(function () {
                    vm.infoMessage = '';
                }, 5000);
            }
        };


        vm.returnToHome = function () {
            window.location.reload();
        }

        vm.updateRouteMarkerVisibilitySurveyEdit = function () {
            vm.routeMarkerssurveyVisible = !vm.routeMarkerssurveyVisible;
            if (vm.routeMarkerssurveyMap && vm.routeMarkerssurveyMap.length) {
                for (var i = 0; i < vm.routeMarkerssurveyMap.length; i++) {
                    vm.routeMarkerssurveyMap[i].setMap(vm.routeMarkerssurveyVisible ? vm.editSurveyMap : null);
                }
            }
        };
        var fullData = [];
        var selectedUser = "All";

        function getRouteStatus() {
            RouteStatus.getRouteStatus(vm.trRoute.id, function (response) {
                if (response && response.length > 0) {
                    fullData = response;
                    var usersMap = {};
                    var users = [];
                    for (var i = 0; i < response.length; i++) {
                        var u = response[i].createdBy;
                        if (!usersMap[u]) {
                            usersMap[u] = true;
                            users.push(u);
                        }
                    }

                    var select = document.getElementById("userFilter");
                    select.innerHTML = "";
                    var defaultOpt = document.createElement("option");
                    defaultOpt.value = "All";
                    defaultOpt.text = "All";
                    select.appendChild(defaultOpt);

                    for (var j = 0; j < users.length; j++) {
                        var opt = document.createElement("option");
                        opt.value = users[j];
                        opt.text = users[j];
                        select.appendChild(opt);
                    }


                    showRouteStatus(fullData, selectedUser);
                } else {
                    fullData = [];
                    showRouteStatus([], selectedUser);
                }
            });
        }

        vm.filterRouteStatus = function () {
            selectedUser = document.getElementById("userFilter").value;
            showRouteStatus(fullData, selectedUser);
        };

        function showRouteStatus(dataArray, selectedUser) {
            var svgtemp = d3.select("#sync-chart");
            svgtemp.selectAll("*").remove();

            if (!dataArray || dataArray.length === 0) return;

            var filteredData;
            if (selectedUser === "All") {
                var entityMap = {};
                dataArray.forEach(function (d) {
                    if (!entityMap[d.entityName]) {
                        entityMap[d.entityName] = {
                            entityName: d.entityName,
                            openCount: 0, inProgressCount: 0, failedCount: 0, doneCount: 0
                        };
                    }
                    entityMap[d.entityName].openCount += d.openCount;
                    entityMap[d.entityName].inProgressCount += d.inProgressCount;
                    entityMap[d.entityName].failedCount += d.failedCount;
                    entityMap[d.entityName].doneCount += d.doneCount;
                });
                filteredData = [];
                for (var k in entityMap) {
                    if (entityMap.hasOwnProperty(k)) {
                        filteredData.push(entityMap[k]);
                    }
                }
            } else {
                filteredData = dataArray.filter(function (d) {
                    return d.createdBy === selectedUser;
                });
            }

            var statusKeys = ["Open", "In Progress", "Failed", "Done"];
            var color = d3.scale.ordinal()
                .domain(statusKeys)
                .range(["#FD7A24", "#82eedd", "#f70303ff", "#00e658"]);

            var width = document.getElementById("sync-chart").offsetWidth || 500;
            var height = 300;
            var margin = { top: 40, right: 150, bottom: 80, left: 60 };

            var svg = d3.select("#sync-chart")
                .append("svg")
                .attr("width", width)
                .attr("height", height);

            var chartWidth = width - margin.left - margin.right;
            var chartHeight = height - margin.top - margin.bottom;

            var g = svg.append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            var maxBarWidth = 100;
            var bandWidth = Math.min(chartWidth / filteredData.length, maxBarWidth);

            var x = d3.scale.ordinal()
                .domain(filteredData.map(function (d) { return d.entityName; }))
                .rangeBands([0, filteredData.length * bandWidth], 0.3);

            var totalChartWidth = filteredData.length * bandWidth;
            svg.attr("width", totalChartWidth + margin.left + margin.right);

            var stackedData = filteredData.map(function (d) {
                var y0 = 0;
                return statusKeys.map(function (key) {
                    var count = 0;
                    if (key === "Open") count = d.openCount;
                    else if (key === "In Progress") count = d.inProgressCount;
                    else if (key === "Failed") count = d.failedCount;
                    else if (key === "Done") count = d.doneCount;
                    var result = { key: key, y0: y0, y1: y0 + count, entityName: d.entityName, count: count };
                    y0 += count;
                    return result;
                });
            });

            var maxCount = d3.max(stackedData, function (d) { return d[d.length - 1].y1; });

            var y = d3.scale.linear()
                .domain([0, maxCount || 1])
                .range([chartHeight, 0]);

            var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);
            g.append("g").attr("class", "y axis").call(yAxis);

            var tooltip = d3.select("body").append("div")
                .attr("class", "chart-tooltip")
                .style("position", "absolute")
                .style("background", "white")
                .style("border", "1px solid #ccc")
                .style("padding", "6px 8px")
                .style("font-size", "12px")
                .style("border-radius", "4px")
                .style("pointer-events", "none")
                .style("opacity", 0);

            var entityGroups = g.selectAll(".entityGroup")
                .data(stackedData)
                .enter().append("g")
                .attr("transform", function (d) { return "translate(" + x(d[0].entityName) + ",0)"; });

            entityGroups.selectAll("rect")
                .data(function (d) { return d; })
                .enter().append("rect")
                .attr("width", x.rangeBand())
                .attr("y", function (d) { return y(d.y1); })
                .attr("height", function (d) { return y(d.y0) - y(d.y1); })
                .style("fill", function (d) { return color(d.key); })
                .on("mouseover", function (d) {
                    tooltip.transition().duration(200).style("opacity", 0.9);
                    tooltip.html(
                        "<b>" + d.entityName + "</b><br/>" +
                        d.key + ": " + d.count
                    );
                })
                .on("mousemove", function () {
                    tooltip.style("left", (d3.event.pageX + 10) + "px")
                        .style("top", (d3.event.pageY - 28) + "px");
                })
                .on("mouseout", function () {
                    tooltip.transition().duration(500).style("opacity", 0);
                });

            // Totals above bars
            entityGroups.append("text")
                .attr("x", x.rangeBand() / 2)
                .attr("y", function (d) { return y(d[d.length - 1].y1) - 5; })
                .attr("text-anchor", "middle")
                .style("font-size", "12px")
                .style("font-weight", "bold")
                .text(function (d) { return d[d.length - 1].y1; });

            // X Axis
            var xAxis = d3.svg.axis().scale(x).orient("bottom");
            g.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + chartHeight + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-0.8em")
                .attr("dy", "0.15em")
                .attr("transform", "rotate(-40)");

            // Legend
            var legend = g.selectAll(".legend")
                .data(statusKeys)
                .enter().append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) { return "translate(0," + i * 20 + ")"; });

            legend.append("rect")
                .attr("x", totalChartWidth + 20)
                .attr("width", 14)
                .attr("height", 14)
                .style("fill", color);

            legend.append("text")
                .attr("x", totalChartWidth + 40)
                .attr("y", 7)
                .attr("dy", ".35em")
                .style("font-size", "12px")
                .text(function (d) { return d; });
        }
        vm.showStatistics = false;

        vm.toggleStatistics = function () {
            vm.showStatistics = !vm.showStatistics;
            if (vm.showStatistics) {
                getRouteStatus();
            }
        };


    }
})();